export const i18nKeys = {
  ACCOUNT_LIMITATION: 'ACCOUNT_LIMITATION',
  ACCOUNT_MANAGER: 'ACCOUNT_MANAGER',
  NEW: 'NEW',
  SAVED: 'SAVED',
  ACTIONS: {
    ADD: 'ACTIONS.ADD',
    ADD_SALE_CONDITION: 'ACTIONS.ADD_SALE_CONDITION',
    FAVORITE: 'ACTIONS.FAVORITE',
    FILTER: 'ACTIONS.FILTER',
    TOOLTIP: 'ACTIONS.TOOLTIP',
    USE_BELGIAN_LAW: 'ACTIONS.USE_BELGIAN_LAW',
    USE_DEFAULT: 'ACTIONS.USE_DEFAULT',
  },
  SENT_VIA_PEPPOL: 'SENT_VIA_PEPPOL',
  MANDATORY: 'MANDATORY',
  ACTIVATE: 'ACTIVATE',
  ACTIVATED: 'ACTIVATED',
  ACTIVITIES: {
    AUTHOR: 'ACTIVITIES.AUTHOR',
    COUNTERPART: 'ACTIVITIES.COUNTERPART',
    DETAIL: 'ACTIVITIES.DETAIL',
    DOWNLOAD_DOCUMENT: 'ACTIVITIES.DOWNLOAD_DOCUMENT',
    EDIT_COMPANY: 'ACTIVITIES.EDIT_COMPANY',
    EXTERNAL_ID: 'ACTIVITIES.EXTERNAL_ID',
    INVOICES_TO_PAY_ATTENTION: 'ACTIVITIES.INVOICES_TO_PAY_ATTENTION',
    INVOICE_TO_PAY_ATTENTION: 'ACTIVITIES.INVOICE_TO_PAY_ATTENTION',
    CLIENTS_TO_PAY_ATTENTION: 'ACTIVITIES.CLIENTS_TO_PAY_ATTENTION',
    CLIENT_TO_PAY_ATTENTION: 'ACTIVITIES.CLIENT_TO_PAY_ATTENTION',
    LAWYER: 'ACTIVITIES.LAWYER',
    LAWYER_CASE: 'ACTIVITIES.LAWYER_CASE',
    MARK_ALL_AS_READ: 'ACTIVITIES.MARK_ALL_AS_READ',
    NEW: 'ACTIVITIES.NEW',
    PAY_ATTENTION: 'ACTIVITIES.PAY_ATTENTION',
    SEE_CLIENT: 'ACTIVITIES.SEE_CLIENT',
    SEE_CREDIT_NOTE: 'ACTIVITIES.SEE_CREDIT_NOTE',
    SEE_INVOICE: 'ACTIVITIES.SEE_INVOICE',
    SEE_PAYMENT_PLAN: 'ACTIVITIES.SEE_PAYMENT_PLAN',
    SEE_TASK: 'ACTIVITIES.SEE_TASK',
    SEND_MESSAGE: 'ACTIVITIES.SEND_MESSAGE',
    SINCE_LAST_LOGIN: 'ACTIVITIES.SINCE_LAST_LOGIN',
    TITLE: 'ACTIVITIES.TITLE',
    UNPROCESSED_TRANSACTION: 'ACTIVITIES.UNPROCESSED_TRANSACTION',
    UNPROCESSED_TRANSACTIONS: 'ACTIVITIES.UNPROCESSED_TRANSACTIONS',
    UNSEEN_ACTIVITIES: 'ACTIVITIES.UNSEEN_ACTIVITIES',
    UNSEEN_ACTIVITY: 'ACTIVITIES.UNSEEN_ACTIVITY',
    UPDATE_STATUS_CREDIT_NOTE: 'ACTIVITIES.UPDATE_STATUS_CREDIT_NOTE',
    UPDATE_STATUS_DEBTOR: 'ACTIVITIES.UPDATE_STATUS_DEBTOR',
    UPDATE_STATUS_INVOICE: 'ACTIVITIES.UPDATE_STATUS_INVOICE',
    UPDATE_STATUS_TASK: 'ACTIVITIES.UPDATE_STATUS_TASK',
  },
  ADDITIONAL_FILES: 'ADDITIONAL_FILES',
  ADDITIONAL_LINE_1: 'ADDITIONAL_LINE_1',
  ADDITIONAL_LINE_2: 'ADDITIONAL_LINE_2',
  AFTERNOON: 'AFTERNOON',
  ADDRESS: 'ADDRESS',
  ADDRESSES: 'ADDRESSES',
  ADDRESS_COMPLEMENT: 'ADDRESS_COMPLEMENT',
  ADD_CONTACT_PERSON: 'ADD_CONTACT_PERSON',
  ADD_DOCUMENT: 'ADD_DOCUMENT',
  ADD_FILE: 'ADD_FILE',
  ADD_INVOICE: 'ADD_INVOICE',
  ADD_INVOICES: 'ADD_INVOICES',
  ADDITIONAL_INVOICES: 'ADDITIONAL_INVOICES',
  ADD_LATER: 'ADD_LATER',
  ADD_LATE_FEES: 'ADD_LATE_FEES',
  ADD_REASON: 'ADD_REASON',
  ADD_REASON_HINT: 'ADD_REASON_HINT',
  ADD_REMINDER: 'ADD_REMINDER',
  ADD_STATEMENT: 'ADD_STATEMENT',
  ADD_STEP: 'ADD_STEP',
  ADD_TASK: 'ADD_TASK',
  ADD_TASK_TYPE: 'ADD_TASK_TYPE',
  ADD_VARIABLE: 'ADD_VARIABLE',
  ADD_VIEW: 'ADD_VIEW',
  AI_CALL: 'AI_CALL',
  AI_CALLS: {
    MENU_LABEL: 'AI_CALLS.MENU_LABEL',
    COLUMNS: {
      REFERENCE: 'AI_CALLS.COLUMNS.REFERENCE',
      CLIENT: 'AI_CALLS.COLUMNS.CLIENT',
      OUTCOME: 'AI_CALLS.COLUMNS.OUTCOME',
      END_REASON: 'AI_CALLS.COLUMNS.END_REASON',
      CALL_DATE: 'AI_CALLS.COLUMNS.CALL_DATE',
    },
    EMPTY_STATE: 'AI_CALLS.EMPTY_STATE',
    FILTERS: 'AI_CALLS.FILTERS',
    FILTER_DRAWER: {
      TITLE: 'AI_CALLS.FILTER_DRAWER.TITLE',
      INVOICE_REFERENCE: 'AI_CALLS.FILTER_DRAWER.INVOICE_REFERENCE',
      INVOICE_REFERENCE_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.INVOICE_REFERENCE_PLACEHOLDER',
      DEBTOR_NAME: 'AI_CALLS.FILTER_DRAWER.DEBTOR_NAME',
      DEBTOR_NAME_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.DEBTOR_NAME_PLACEHOLDER',
      START_DATE: 'AI_CALLS.FILTER_DRAWER.START_DATE',
      START_DATE_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.START_DATE_PLACEHOLDER',
      END_DATE: 'AI_CALLS.FILTER_DRAWER.END_DATE',
      END_DATE_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.END_DATE_PLACEHOLDER',
      OUTCOME: 'AI_CALLS.FILTER_DRAWER.OUTCOME',
      OUTCOME_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.OUTCOME_PLACEHOLDER',
      END_REASON: 'AI_CALLS.FILTER_DRAWER.END_REASON',
      END_REASON_PLACEHOLDER: 'AI_CALLS.FILTER_DRAWER.END_REASON_PLACEHOLDER',
      OUTCOME_OPTIONS: {
        DISPUTE: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.DISPUTE',
        INFORMATIONAL: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.INFORMATIONAL',
        BAD_CONTEXT_INFO: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.BAD_CONTEXT_INFO',
        PAYMENT_PLAN: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.PAYMENT_PLAN',
        PROMISE_TO_PAY: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.PROMISE_TO_PAY',
        FOLLOW_UP_TASK: 'AI_CALLS.FILTER_DRAWER.OUTCOME_OPTIONS.FOLLOW_UP_TASK',
      },
      END_REASON_OPTIONS: {
        CUSTOMER_DID_NOT_ANSWER:
          'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.CUSTOMER_DID_NOT_ANSWER',
        CUSTOMER_ENDED_CALL: 'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.CUSTOMER_ENDED_CALL',
        ASSISTANT_ENDED_CALL: 'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.ASSISTANT_ENDED_CALL',
        SILENCE_TIMED_OUT: 'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.SILENCE_TIMED_OUT',
        VONAGE_REJECTED: 'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.VONAGE_REJECTED',
        VONAGE_COMPLETED: 'AI_CALLS.FILTER_DRAWER.END_REASON_OPTIONS.VONAGE_COMPLETED',
      },
    },
  },
  AI_SUMMARY: {
    BILLING_PANEL: {
      TITLE: 'AI_SUMMARY.BILLING_PANEL.TITLE',
      DESCRIPTION: 'AI_SUMMARY.BILLING_PANEL.DESCRIPTION',
      MORE_INFORMATION: 'AI_SUMMARY.BILLING_PANEL.MORE_INFORMATION',
    },
    GENERATE_PANEL: {
      TITLE: 'AI_SUMMARY.GENERATE_PANEL.TITLE',
      DESCRIPTION: 'AI_SUMMARY.GENERATE_PANEL.DESCRIPTION',
      GENERATE_BRIEFING: 'AI_SUMMARY.GENERATE_PANEL.GENERATE_BRIEFING',
    },
    LOADING_MESSAGES: {
      PREPARING: 'AI_SUMMARY.LOADING_MESSAGES.PREPARING',
      REVIEWING_TRANSACTIONS: 'AI_SUMMARY.LOADING_MESSAGES.REVIEWING_TRANSACTIONS',
      ANALYZING_BALANCES: 'AI_SUMMARY.LOADING_MESSAGES.ANALYZING_BALANCES',
      SUMMARIZING_METRICS: 'AI_SUMMARY.LOADING_MESSAGES.SUMMARIZING_METRICS',
      COMPILING_OVERVIEW: 'AI_SUMMARY.LOADING_MESSAGES.COMPILING_OVERVIEW',
      FINALIZING: 'AI_SUMMARY.LOADING_MESSAGES.FINALIZING',
    },
    OVERVIEW_TITLE: 'AI_SUMMARY.OVERVIEW_TITLE',
    OUTDATED_OVERLAY: {
      DESCRIPTION: 'AI_SUMMARY.OUTDATED_OVERLAY.DESCRIPTION',
      REGENERATE: 'AI_SUMMARY.OUTDATED_OVERLAY.REGENERATE',
      UNDERSTOOD: 'AI_SUMMARY.OUTDATED_OVERLAY.UNDERSTOOD',
    },
    RECOMMENDED_ACTIONS: 'AI_SUMMARY.RECOMMENDED_ACTIONS',
    RECOMMENDED_BADGE: 'AI_SUMMARY.RECOMMENDED_BADGE',
    THANKS_FOR_FEEDBACK: 'AI_SUMMARY.THANKS_FOR_FEEDBACK',
  },
  AML_MODAL: {
    TITLE: 'AML_MODAL.TITLE',
    STEPS: {
      COMPANY: 'AML_MODAL.STEPS.COMPANY',
      RELATED_PERSONS: 'AML_MODAL.STEPS.RELATED_PERSONS',
      REPRESENTATIVE: 'AML_MODAL.STEPS.REPRESENTATIVE',
      ADDITIONAL_INFO: 'AML_MODAL.STEPS.ADDITIONAL_INFO',
      IDENTITY: 'AML_MODAL.STEPS.IDENTITY',
    },
    COMPANY_IDENTIFICATION: {
      CASE_NAME: 'AML_MODAL.COMPANY_IDENTIFICATION.CASE_NAME',
      COMPANY_NAME: 'AML_MODAL.COMPANY_IDENTIFICATION.COMPANY_NAME',
      VAT_NUMBER: 'AML_MODAL.COMPANY_IDENTIFICATION.VAT_NUMBER',
      REGISTERED_OFFICE: 'AML_MODAL.COMPANY_IDENTIFICATION.REGISTERED_OFFICE',
      PLACEHOLDERS: {
        CASE_NAME: 'AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.CASE_NAME',
        COMPANY_NAME: 'AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.COMPANY_NAME',
        VAT_NUMBER: 'AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.VAT_NUMBER',
        REGISTERED_OFFICE: 'AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.REGISTERED_OFFICE',
      },
    },
    RELATED_PERSONS: {
      DIRECTORS: 'AML_MODAL.RELATED_PERSONS.DIRECTORS',
      DIRECTORS_HINT: 'AML_MODAL.RELATED_PERSONS.DIRECTORS_HINT',
      CAN_BIND: 'AML_MODAL.RELATED_PERSONS.CAN_BIND',
      ADD_DIRECTOR: 'AML_MODAL.RELATED_PERSONS.ADD_DIRECTOR',
      LISTED_COMPANY: 'AML_MODAL.RELATED_PERSONS.LISTED_COMPANY',
      BENEFICIAL_OWNERS: 'AML_MODAL.RELATED_PERSONS.BENEFICIAL_OWNERS',
      ADD_BENEFICIAL_OWNER: 'AML_MODAL.RELATED_PERSONS.ADD_BENEFICIAL_OWNER',
      PLACEHOLDERS: {
        DIRECTOR_NAME: 'AML_MODAL.RELATED_PERSONS.PLACEHOLDERS.DIRECTOR_NAME',
        BENEFICIAL_OWNER_NAME: 'AML_MODAL.RELATED_PERSONS.PLACEHOLDERS.BENEFICIAL_OWNER_NAME',
      },
    },
    REPRESENTATIVE: {
      LAST_NAME: 'AML_MODAL.REPRESENTATIVE.LAST_NAME',
      FIRST_NAME: 'AML_MODAL.REPRESENTATIVE.FIRST_NAME',
      ADDRESS: 'AML_MODAL.REPRESENTATIVE.ADDRESS',
      MOBILE: 'AML_MODAL.REPRESENTATIVE.MOBILE',
      EMAIL: 'AML_MODAL.REPRESENTATIVE.EMAIL',
      NATIONAL_NUMBER: 'AML_MODAL.REPRESENTATIVE.NATIONAL_NUMBER',
      PLACEHOLDERS: {
        LAST_NAME: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.LAST_NAME',
        FIRST_NAME: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.FIRST_NAME',
        ADDRESS: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.ADDRESS',
        MOBILE: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.MOBILE',
        EMAIL: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.EMAIL',
        NATIONAL_NUMBER: 'AML_MODAL.REPRESENTATIVE.PLACEHOLDERS.NATIONAL_NUMBER',
      },
    },
    ADDITIONAL_INFO: {
      RELATION_ORIGIN: 'AML_MODAL.ADDITIONAL_INFO.RELATION_ORIGIN',
      SERVICE_DESCRIPTION: 'AML_MODAL.ADDITIONAL_INFO.SERVICE_DESCRIPTION',
      SERVICE_DESCRIPTION_HINT: 'AML_MODAL.ADDITIONAL_INFO.SERVICE_DESCRIPTION_HINT',
      PEP_TITLE: 'AML_MODAL.ADDITIONAL_INFO.PEP_TITLE',
      PEP_DESCRIPTION: 'AML_MODAL.ADDITIONAL_INFO.PEP_DESCRIPTION',
      PEP_NO: 'AML_MODAL.ADDITIONAL_INFO.PEP_NO',
      PEP_YES: 'AML_MODAL.ADDITIONAL_INFO.PEP_YES',
      PEP_DETAILS_LABEL: 'AML_MODAL.ADDITIONAL_INFO.PEP_DETAILS_LABEL',
      PEP_DETAILS_PLACEHOLDER: 'AML_MODAL.ADDITIONAL_INFO.PEP_DETAILS_PLACEHOLDER',
      PLACEHOLDERS: {
        RELATION_ORIGIN: 'AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.RELATION_ORIGIN',
        SERVICE_DESCRIPTION: 'AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.SERVICE_DESCRIPTION',
      },
    },
    IDENTITY: {
      DESCRIPTION: 'AML_MODAL.IDENTITY.DESCRIPTION',
      ID_FRONT: 'AML_MODAL.IDENTITY.ID_FRONT',
      ID_BACK: 'AML_MODAL.IDENTITY.ID_BACK',
      UPLOAD: 'AML_MODAL.IDENTITY.UPLOAD',
    },
    ACTIONS: {
      PREVIOUS: 'AML_MODAL.ACTIONS.PREVIOUS',
      NEXT: 'AML_MODAL.ACTIONS.NEXT',
      DOWNLOAD_PDF: 'AML_MODAL.ACTIONS.DOWNLOAD_PDF',
      SEND: 'AML_MODAL.ACTIONS.SEND',
    },
  },
  AMOUNT: 'AMOUNT',
  AMOUNT_BILLED: 'AMOUNT_BILLED',
  AMOUNT_CREDITED: 'AMOUNT_CREDITED',
  AMOUNT_CURRENCY: 'AMOUNT_CURRENCY',
  AMOUNT_MIN: 'AMOUNT_MIN',
  AMOUNT_SETTLED: 'AMOUNT_SETTLED',
  ANALYTICS: {
    AGED_BALANCE: {
      '0': 'ANALYTICS.AGED_BALANCE.0',
      '30': 'ANALYTICS.AGED_BALANCE.30',
      '60': 'ANALYTICS.AGED_BALANCE.60',
      '90': 'ANALYTICS.AGED_BALANCE.90',
      CHART_TITLE: 'ANALYTICS.AGED_BALANCE.CHART_TITLE',
      DEBTOR: 'ANALYTICS.AGED_BALANCE.DEBTOR',
      SEE_BREAKDOWN: 'ANALYTICS.AGED_BALANCE.SEE_BREAKDOWN',
      TABLE_TITLE: 'ANALYTICS.AGED_BALANCE.TABLE_TITLE',
      TITLE: 'ANALYTICS.AGED_BALANCE.TITLE',
      notDue: 'ANALYTICS.AGED_BALANCE.notDue',
      totalBalance: 'ANALYTICS.AGED_BALANCE.totalBalance',
      totalDue: 'ANALYTICS.AGED_BALANCE.totalDue',
      SCALE: 'ANALYTICS.AGED_BALANCE.SCALE',
    },
    BETA: 'ANALYTICS.BETA',
    BETA_TITLE: 'ANALYTICS.BETA_TITLE',
    CEI: {
      HELP: {
        LINE_1: 'ANALYTICS.CEI.HELP.LINE_1',
        LINE_2: 'ANALYTICS.CEI.HELP.LINE_2',
        TITLE: 'ANALYTICS.CEI.HELP.TITLE',
      },
      TITLE: 'ANALYTICS.CEI.TITLE',
    },
    COLLECTION_COHORTS: {
      BILLED: 'ANALYTICS.COLLECTION_COHORTS.BILLED',
      COHORT: 'ANALYTICS.COLLECTION_COHORTS.COHORT',
      COLLECTED: 'ANALYTICS.COLLECTION_COHORTS.COLLECTED',
      EMPTY: 'ANALYTICS.COLLECTION_COHORTS.EMPTY',
      GROUP_BY: {
        DUE_DATE: 'ANALYTICS.COLLECTION_COHORTS.GROUP_BY.DUE_DATE',
        ISSUE_DATE: 'ANALYTICS.COLLECTION_COHORTS.GROUP_BY.ISSUE_DATE',
      },
      HELP: {
        LINE_1: 'ANALYTICS.COLLECTION_COHORTS.HELP.LINE_1',
        LINE_2: 'ANALYTICS.COLLECTION_COHORTS.HELP.LINE_2',
        LINE_3: 'ANALYTICS.COLLECTION_COHORTS.HELP.LINE_3',
        LINE_4: 'ANALYTICS.COLLECTION_COHORTS.HELP.LINE_4',
        LINE_5: 'ANALYTICS.COLLECTION_COHORTS.HELP.LINE_5',
      },
      INVOICE_COUNT: 'ANALYTICS.COLLECTION_COHORTS.INVOICE_COUNT',
      TITLE: 'ANALYTICS.COLLECTION_COHORTS.TITLE',
      UNPAID: 'ANALYTICS.COLLECTION_COHORTS.UNPAID',
      WINDOW: 'ANALYTICS.COLLECTION_COHORTS.WINDOW',
    },
    CURRENT_YEAR: 'ANALYTICS.CURRENT_YEAR',
    DAYS_SHORT: 'ANALYTICS.DAYS_SHORT',
    DSO: {
      HELP: {
        LINE_1: 'ANALYTICS.DSO.HELP.LINE_1',
        TITLE: 'ANALYTICS.DSO.HELP.TITLE',
      },
      TITLE: 'ANALYTICS.DSO.TITLE',
    },
    GRAPH_UPDATED: 'ANALYTICS.GRAPH_UPDATED',
    HELP_LABEL: 'ANALYTICS.HELP_LABEL',
    HIGHER_BETTER: 'ANALYTICS.HIGHER_BETTER',
    LAST_UPDATED: 'ANALYTICS.LAST_UPDATED',
    LOWER_BETTER: 'ANALYTICS.LOWER_BETTER',
    MORE_CHARTS: {
      QUESTION: 'ANALYTICS.MORE_CHARTS.QUESTION',
      TITLE: 'ANALYTICS.MORE_CHARTS.TITLE',
    },
    NOT_DUE_YET: 'ANALYTICS.NOT_DUE_YET',
    OVERDUE: 'ANALYTICS.OVERDUE',
    PAID_BY_REMINDER: {
      CTA: 'ANALYTICS.PAID_BY_REMINDER.CTA',
      EMPTY: 'ANALYTICS.PAID_BY_REMINDER.EMPTY',
      HELP: {
        BAR: {
          LABEL: 'ANALYTICS.PAID_BY_REMINDER.HELP.BAR.LABEL',
          TEXT: 'ANALYTICS.PAID_BY_REMINDER.HELP.BAR.TEXT',
        },
        COUNTED: {
          LABEL: 'ANALYTICS.PAID_BY_REMINDER.HELP.COUNTED.LABEL',
          TEXT: 'ANALYTICS.PAID_BY_REMINDER.HELP.COUNTED.TEXT',
        },
        PERIOD: {
          LABEL: 'ANALYTICS.PAID_BY_REMINDER.HELP.PERIOD.LABEL',
          TEXT: 'ANALYTICS.PAID_BY_REMINDER.HELP.PERIOD.TEXT',
        },
        SUMMARY: 'ANALYTICS.PAID_BY_REMINDER.HELP.SUMMARY',
      },
      INVOICE_COUNT: 'ANALYTICS.PAID_BY_REMINDER.INVOICE_COUNT',
      KPI_CAPTION: 'ANALYTICS.PAID_BY_REMINDER.KPI_CAPTION',
      NO_WORKFLOWS: 'ANALYTICS.PAID_BY_REMINDER.NO_WORKFLOWS',
      PERIOD: 'ANALYTICS.PAID_BY_REMINDER.PERIOD',
      SENT_TO_THIRD_PARTY: 'ANALYTICS.PAID_BY_REMINDER.SENT_TO_THIRD_PARTY',
      STILL_OPEN: 'ANALYTICS.PAID_BY_REMINDER.STILL_OPEN',
      TITLE: 'ANALYTICS.PAID_BY_REMINDER.TITLE',
      WORKFLOWS_TITLE: 'ANALYTICS.PAID_BY_REMINDER.WORKFLOWS_TITLE',
    },
    PREVIOUS_YEAR: 'ANALYTICS.PREVIOUS_YEAR',
    REFRESH_BALANCE: 'ANALYTICS.REFRESH_BALANCE',
    REFRESH_BALANCE_DONE: 'ANALYTICS.REFRESH_BALANCE_DONE',
    REFRESH_BALANCE_ERROR: 'ANALYTICS.REFRESH_BALANCE_ERROR',
    REFRESH_BALANCE_SUCCESS: 'ANALYTICS.REFRESH_BALANCE_SUCCESS',
    REMINDERS_AND_COLLECTIONS: {
      GRANULARITY: {
        MONTH: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.GRANULARITY.MONTH',
        WEEK: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.GRANULARITY.WEEK',
      },
      CASH_LABEL: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.CASH_LABEL',
      REMINDERS_LABEL: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.REMINDERS_LABEL',
      SCALE: {
        FEWER: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.SCALE.FEWER',
        MORE: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.SCALE.MORE',
      },
      TITLE: 'ANALYTICS.REMINDERS_AND_COLLECTIONS.TITLE',
    },
    OTHER_BREAKDOWN: {
      IN_REMINDERS: 'ANALYTICS.OTHER_BREAKDOWN.IN_REMINDERS',
      NOT_DUE: 'ANALYTICS.OTHER_BREAKDOWN.NOT_DUE',
      THIRD_PARTY: 'ANALYTICS.OTHER_BREAKDOWN.THIRD_PARTY',
    },
    SHARE_OF_BALANCE: 'ANALYTICS.SHARE_OF_BALANCE',
    TICKERS: {
      ACTIONABLE: {
        TITLE: 'ANALYTICS.TICKERS.ACTIONABLE.TITLE',
      },
      AT_RISK: {
        TITLE: 'ANALYTICS.TICKERS.AT_RISK.TITLE',
      },
      DISPUTED: {
        TITLE: 'ANALYTICS.TICKERS.DISPUTED.TITLE',
      },
      PAUSED: {
        TITLE: 'ANALYTICS.TICKERS.PAUSED.TITLE',
      },
      TOTAL: {
        TITLE: 'ANALYTICS.TICKERS.TOTAL.TITLE',
      },
    },
    TITLE: 'ANALYTICS.TITLE',
  },
  AND: 'AND',
  ASSIGN_ACCOUNT_MANAGER: 'ASSIGN_ACCOUNT_MANAGER',
  ASSIGN_ACCOUNT_MANAGER_SHORT: 'ASSIGN_ACCOUNT_MANAGER_SHORT',
  ATTENTION: 'ATTENTION',
  AUTOMATED_PLANS: 'AUTOMATED_PLANS',
  AUTOMATIC: 'AUTOMATIC',
  AUTOMATIC_ASSIGNATION: 'AUTOMATIC_ASSIGNATION',
  AUTOMATION: {
    NEW: 'AUTOMATION.NEW',
    LABEL: 'AUTOMATION.LABEL',
    ACTIONS: {
      DELETE: 'AUTOMATION.ACTIONS.DELETE',
      EDIT: 'AUTOMATION.ACTIONS.EDIT',
      ENABLE: 'AUTOMATION.ACTIONS.ENABLE',
      DISABLE: 'AUTOMATION.ACTIONS.DISABLE',
    },
    COLUMNS: {
      ACTIONS: 'AUTOMATION.COLUMNS.ACTIONS',
      DESCRIPTION: 'AUTOMATION.COLUMNS.DESCRIPTION',
      LAST_RUN_AT: 'AUTOMATION.COLUMNS.LAST_RUN_AT',
      MODEL: 'AUTOMATION.COLUMNS.MODEL',
      NAME: 'AUTOMATION.COLUMNS.NAME',
    },
    DRAG_AND_DROP_T: {
      NO_DESCRIPTION: 'AUTOMATION.DRAG_AND_DROP_T.NO_DESCRIPTION',
    },
    EMPTY_STATE: {
      NO_AUTOMATIONS_FOUND: 'AUTOMATION.EMPTY_STATE.NO_AUTOMATIONS_FOUND',
    },
    INDEX: {
      TITLE: 'AUTOMATION.INDEX.TITLE',
      SUBTITLE: 'AUTOMATION.INDEX.SUBTITLE',
      DELETE_CONFIRMATION: 'AUTOMATION.INDEX.DELETE_CONFIRMATION',
    },
    MODELS: {
      INVOICE: 'AUTOMATION.MODELS.INVOICE',
      CUSTOMER: 'AUTOMATION.MODELS.CUSTOMER',
    },
    STATUS: {
      NEVER: 'AUTOMATION.STATUS.NEVER',
    },
    TRIGGERS: {
      LABEL: 'AUTOMATION.TRIGGERS.LABEL',
      ONCREATE: 'AUTOMATION.TRIGGERS.ONCREATE',
      ONUPDATE: 'AUTOMATION.TRIGGERS.ONUPDATE',
    },
    WIZARD: {
      INVOICE_FIELDS_GROUP: 'AUTOMATION.WIZARD.INVOICE_FIELDS_GROUP',
      DEBTOR_FIELDS_GROUP: 'AUTOMATION.WIZARD.DEBTOR_FIELDS_GROUP',
      INVOICE_CUSTOM_VARIABLES_GROUP: 'AUTOMATION.WIZARD.INVOICE_CUSTOM_VARIABLES_GROUP',
      DEBTOR_CUSTOM_VARIABLES_GROUP: 'AUTOMATION.WIZARD.DEBTOR_CUSTOM_VARIABLES_GROUP',
      TITLE: {
        CREATE: 'AUTOMATION.WIZARD.TITLE.CREATE',
        EDIT: 'AUTOMATION.WIZARD.TITLE.EDIT',
      },
      STEPS: {
        NAME: 'AUTOMATION.WIZARD.STEPS.NAME',
        MODEL: 'AUTOMATION.WIZARD.STEPS.MODEL',
        CONDITIONS: 'AUTOMATION.WIZARD.STEPS.CONDITIONS',
        ACTIONS: 'AUTOMATION.WIZARD.STEPS.ACTIONS',
      },
      STEP1: {
        NAME_LABEL: 'AUTOMATION.WIZARD.STEP1.NAME_LABEL',
        NAME_PLACEHOLDER: 'AUTOMATION.WIZARD.STEP1.NAME_PLACEHOLDER',
        DESCRIPTION_LABEL: 'AUTOMATION.WIZARD.STEP1.DESCRIPTION_LABEL',
        DESCRIPTION_PLACEHOLDER: 'AUTOMATION.WIZARD.STEP1.DESCRIPTION_PLACEHOLDER',
        NEXT: 'AUTOMATION.WIZARD.STEP1.NEXT',
        NAME_TAKEN: 'AUTOMATION.WIZARD.STEP1.NAME_TAKEN',
      },
      STEP2: {
        SELECT_MODEL: 'AUTOMATION.WIZARD.STEP2.SELECT_MODEL',
        SELECT_TRIGGERS: 'AUTOMATION.WIZARD.STEP2.SELECT_TRIGGERS',
        INVOICE_NAME: 'AUTOMATION.WIZARD.STEP2.INVOICE_NAME',
        INVOICE_DESCRIPTION: 'AUTOMATION.WIZARD.STEP2.INVOICE_DESCRIPTION',
        CUSTOMER_NAME: 'AUTOMATION.WIZARD.STEP2.CUSTOMER_NAME',
        CUSTOMER_DESCRIPTION: 'AUTOMATION.WIZARD.STEP2.CUSTOMER_DESCRIPTION',
        ONCREATE: 'AUTOMATION.WIZARD.STEP2.ONCREATE',
        ON_CREATE_DESCRIPTION: {
          INVOICE: 'AUTOMATION.WIZARD.STEP2.ON_CREATE_DESCRIPTION.INVOICE',
          DEBTOR: 'AUTOMATION.WIZARD.STEP2.ON_CREATE_DESCRIPTION.DEBTOR',
        },
        ON_UPDATE_DESCRIPTION: {
          INVOICE: 'AUTOMATION.WIZARD.STEP2.ON_UPDATE_DESCRIPTION.INVOICE',
          DEBTOR: 'AUTOMATION.WIZARD.STEP2.ON_UPDATE_DESCRIPTION.DEBTOR',
        },
        ONUPDATE: 'AUTOMATION.WIZARD.STEP2.ONUPDATE',
        NEXT: 'AUTOMATION.WIZARD.STEP2.NEXT',
      },
      STEP3: {
        TITLE: 'AUTOMATION.WIZARD.STEP3.TITLE',
        AND_DIVIDER: 'AUTOMATION.WIZARD.STEP3.AND_DIVIDER',
        NEXT: 'AUTOMATION.WIZARD.STEP3.NEXT',
      },
      STEP4: {
        TITLE: 'AUTOMATION.WIZARD.STEP4.TITLE',
        SAVE: 'AUTOMATION.WIZARD.STEP4.SAVE',
      },
    },
    CONDITIONS: {
      FIELD_LABEL: 'AUTOMATION.CONDITIONS.FIELD_LABEL',
      FIELD_PLACEHOLDER: 'AUTOMATION.CONDITIONS.FIELD_PLACEHOLDER',
      IF: 'AUTOMATION.CONDITIONS.IF',
      OPERATOR_LABEL: 'AUTOMATION.CONDITIONS.OPERATOR_LABEL',
      VALUE_LABEL: 'AUTOMATION.CONDITIONS.VALUE_LABEL',
      VALUE_PLACEHOLDER: 'AUTOMATION.CONDITIONS.VALUE_PLACEHOLDER',
      ADD_CONDITION: 'AUTOMATION.CONDITIONS.ADD_CONDITION',
      REMOVE_CONDITION: 'AUTOMATION.CONDITIONS.REMOVE_CONDITION',
    },
    ACTIONS_CONFIG: {
      FIELD_LABEL: 'AUTOMATION.ACTIONS_CONFIG.FIELD_LABEL',
      FIELD_PLACEHOLDER: 'AUTOMATION.ACTIONS_CONFIG.FIELD_PLACEHOLDER',
      VALUE_LABEL: 'AUTOMATION.ACTIONS_CONFIG.VALUE_LABEL',
      VALUE_PLACEHOLDER_TEXT: 'AUTOMATION.ACTIONS_CONFIG.VALUE_PLACEHOLDER_TEXT',
      VALUE_PLACEHOLDER_SELECT: 'AUTOMATION.ACTIONS_CONFIG.VALUE_PLACEHOLDER_SELECT',
      VALUE_PLACEHOLDER_ARRAY: 'AUTOMATION.ACTIONS_CONFIG.VALUE_PLACEHOLDER_ARRAY',
      WORKFLOW_LABEL: 'AUTOMATION.ACTIONS_CONFIG.WORKFLOW_LABEL',
      WORKFLOW_PLACEHOLDER: 'AUTOMATION.ACTIONS_CONFIG.WORKFLOW_PLACEHOLDER',
      ADD_ACTION: 'AUTOMATION.ACTIONS_CONFIG.ADD_ACTION',
      REMOVE_ACTION: 'AUTOMATION.ACTIONS_CONFIG.REMOVE_ACTION',
      COPY_VALUE_TO_FIELD: 'AUTOMATION.ACTIONS_CONFIG.COPY_VALUE_TO_FIELD',
      COPY_FIELD_TO_FIELD: 'AUTOMATION.ACTIONS_CONFIG.COPY_FIELD_TO_FIELD',
      SOURCE_FIELD_LABEL: 'AUTOMATION.ACTIONS_CONFIG.SOURCE_FIELD_LABEL',
      DESTINATION_FIELD_LABEL: 'AUTOMATION.ACTIONS_CONFIG.DESTINATION_FIELD_LABEL',
      ASSIGN_WORKFLOW_DEBTOR: 'AUTOMATION.ACTIONS_CONFIG.ASSIGN_WORKFLOW_DEBTOR',
      ASSIGN_WORKFLOW_INVOICE: 'AUTOMATION.ACTIONS_CONFIG.ASSIGN_WORKFLOW_INVOICE',
      ASSIGN_ACCOUNT_MANAGER_DEBTOR: 'AUTOMATION.ACTIONS_CONFIG.ASSIGN_ACCOUNT_MANAGER_DEBTOR',
      ASSIGN_ACCOUNT_MANAGER_INVOICE: 'AUTOMATION.ACTIONS_CONFIG.ASSIGN_ACCOUNT_MANAGER_INVOICE',
      ACCOUNT_MANAGER_LABEL: 'AUTOMATION.ACTIONS_CONFIG.ACCOUNT_MANAGER_LABEL',
      ACCOUNT_MANAGER_PLACEHOLDER: 'AUTOMATION.ACTIONS_CONFIG.ACCOUNT_MANAGER_PLACEHOLDER',
      TRUE: 'AUTOMATION.ACTIONS_CONFIG.TRUE',
      FALSE: 'AUTOMATION.ACTIONS_CONFIG.FALSE',
      PAUSE_DEBTOR: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_DEBTOR',
      PAUSE_REASON_LABEL: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_REASON_LABEL',
      PAUSE_REASON_PLACEHOLDER: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_REASON_PLACEHOLDER',
      PAUSE_DURATION_LABEL: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_LABEL',
      PAUSE_DURATION_HINT: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_HINT',
      PAUSE_DURATION_PLACEHOLDER: 'AUTOMATION.ACTIONS_CONFIG.PAUSE_DURATION_PLACEHOLDER',
      UNPAUSE_DEBTOR: 'AUTOMATION.ACTIONS_CONFIG.UNPAUSE_DEBTOR',
      UNPAUSE_DEBTOR_HINT: 'AUTOMATION.ACTIONS_CONFIG.UNPAUSE_DEBTOR_HINT',
    },
    ACTION_TYPES: {
      COPYVALUETOFIELD: 'AUTOMATION.ACTION_TYPES.COPYVALUETOFIELD',
      COPYFIELDTOFIELD: 'AUTOMATION.ACTION_TYPES.COPYFIELDTOFIELD',
      ASSIGNACCOUNTMANAGER: 'AUTOMATION.ACTION_TYPES.ASSIGNACCOUNTMANAGER',
      ASSIGNRECOVERYPLAN: 'AUTOMATION.ACTION_TYPES.ASSIGNRECOVERYPLAN',
      PAUSE: 'AUTOMATION.ACTION_TYPES.PAUSE',
      UNPAUSE: 'AUTOMATION.ACTION_TYPES.UNPAUSE',
    },
    OPTIONS: {
      INVOICE: {
        LIFECYCLESTATE: {
          PAUSED: 'AUTOMATION.OPTIONS.INVOICE.LIFECYCLESTATE.PAUSED',
          DISPUTED: 'AUTOMATION.OPTIONS.INVOICE.LIFECYCLESTATE.DISPUTED',
        },
      },
    },
    FIELDS: {
      INVOICE: {
        BILLINGLOGID: 'AUTOMATION.FIELDS.INVOICE.BILLINGLOGID',
        CREATEDAT: 'AUTOMATION.FIELDS.INVOICE.CREATEDAT',
        CSVID: 'AUTOMATION.FIELDS.INVOICE.CSVID',
        CURRENCY: 'AUTOMATION.FIELDS.INVOICE.CURRENCY',
        DISPUTEDREASONID: 'AUTOMATION.FIELDS.INVOICE.DISPUTEDREASONID',
        DUEDATE: 'AUTOMATION.FIELDS.INVOICE.DUEDATE',
        EXTERNALID: 'AUTOMATION.FIELDS.INVOICE.EXTERNALID',
        ISSUEDATE: 'AUTOMATION.FIELDS.INVOICE.ISSUEDATE',
        LIFECYCLESTATE: 'AUTOMATION.FIELDS.INVOICE.LIFECYCLESTATE',
        MARKEDASTOBEPROCESSED: 'AUTOMATION.FIELDS.INVOICE.MARKEDASTOBEPROCESSED',
        PAUSEDREASONID: 'AUTOMATION.FIELDS.INVOICE.PAUSEDREASONID',
        RECOVERYPLANID: 'AUTOMATION.FIELDS.INVOICE.RECOVERYPLANID',
        REMAININGBALANCE: 'AUTOMATION.FIELDS.INVOICE.REMAININGBALANCE',
        REMAININGLATEFEES: 'AUTOMATION.FIELDS.INVOICE.REMAININGLATEFEES',
        SALESCATEGORY: 'AUTOMATION.FIELDS.INVOICE.SALESCATEGORY',
        TOTALTVAC: 'AUTOMATION.FIELDS.INVOICE.TOTALTVAC',
        USERID: 'AUTOMATION.FIELDS.INVOICE.USERID',
        DEBTORCITY: 'AUTOMATION.FIELDS.INVOICE.DEBTORCITY',
        DEBTORCOUNTRYCODE: 'AUTOMATION.FIELDS.INVOICE.DEBTORCOUNTRYCODE',
        DEBTOREMAILS: 'AUTOMATION.FIELDS.INVOICE.DEBTOREMAILS',
        DEBTORLOCALE: 'AUTOMATION.FIELDS.INVOICE.DEBTORLOCALE',
      },
      DEBTOR: {
        ADDITIONALLINE1: 'AUTOMATION.FIELDS.DEBTOR.ADDITIONALLINE1',
        ALLOWPAYMENTPLANS: 'AUTOMATION.FIELDS.DEBTOR.ALLOWPAYMENTPLANS',
        AVERAGEPAYMENTDELAY: 'AUTOMATION.FIELDS.DEBTOR.AVERAGEPAYMENTDELAY',
        CITY: 'AUTOMATION.FIELDS.DEBTOR.CITY',
        COUNTRYCODE: 'AUTOMATION.FIELDS.DEBTOR.COUNTRYCODE',
        CREATEDAT: 'AUTOMATION.FIELDS.DEBTOR.CREATEDAT',
        CSVID: 'AUTOMATION.FIELDS.DEBTOR.CSVID',
        CURRENCY: 'AUTOMATION.FIELDS.DEBTOR.CURRENCY',
        DISPUTED: 'AUTOMATION.FIELDS.DEBTOR.DISPUTED',
        DISPUTEDREASONID: 'AUTOMATION.FIELDS.DEBTOR.DISPUTEDREASONID',
        EMAILS: 'AUTOMATION.FIELDS.DEBTOR.EMAILS',
        EXTERNALID: 'AUTOMATION.FIELDS.DEBTOR.EXTERNALID',
        FULLNAME: 'AUTOMATION.FIELDS.DEBTOR.FULLNAME',
        LASTREMINDERSENTDATE: 'AUTOMATION.FIELDS.DEBTOR.LASTREMINDERSENTDATE',
        LOCALE: 'AUTOMATION.FIELDS.DEBTOR.LOCALE',
        MORALENTITY: 'AUTOMATION.FIELDS.DEBTOR.MORALENTITY',
        PAUSED: 'AUTOMATION.FIELDS.DEBTOR.PAUSED',
        PAUSEDREASONID: 'AUTOMATION.FIELDS.DEBTOR.PAUSEDREASONID',
        RECOVERYPLANID: 'AUTOMATION.FIELDS.DEBTOR.RECOVERYPLANID',
        SCORE: 'AUTOMATION.FIELDS.DEBTOR.SCORE',
        STREETNAME: 'AUTOMATION.FIELDS.DEBTOR.STREETNAME',
        TERMANDCONDITIONSID: 'AUTOMATION.FIELDS.DEBTOR.TERMANDCONDITIONSID',
        USEBELGIANLAW: 'AUTOMATION.FIELDS.DEBTOR.USEBELGIANLAW',
        USERID: 'AUTOMATION.FIELDS.DEBTOR.USERID',
        ZIPCODE: 'AUTOMATION.FIELDS.DEBTOR.ZIPCODE',
        VATNUMBER: 'AUTOMATION.FIELDS.DEBTOR.VATNUMBER',
      },
    },
    OPERATORS: {
      ISSAMESTRING: 'AUTOMATION.OPERATORS.ISSAMESTRING',
      CONTAINS: 'AUTOMATION.OPERATORS.CONTAINS',
      ISEMPTYSTRING: 'AUTOMATION.OPERATORS.ISEMPTYSTRING',
      ISTRUE: 'AUTOMATION.OPERATORS.ISTRUE',
      ISFALSE: 'AUTOMATION.OPERATORS.ISFALSE',
      ISEQUAL: 'AUTOMATION.OPERATORS.ISEQUAL',
      ISEMPTY: 'AUTOMATION.OPERATORS.ISEMPTY',
      ISGREATERTHAN: 'AUTOMATION.OPERATORS.ISGREATERTHAN',
      ISGREATERTHANOREQUAL: 'AUTOMATION.OPERATORS.ISGREATERTHANOREQUAL',
      ISLESSTHAN: 'AUTOMATION.OPERATORS.ISLESSTHAN',
      ISLESSTHANOREQUAL: 'AUTOMATION.OPERATORS.ISLESSTHANOREQUAL',
      ISBEFORE: 'AUTOMATION.OPERATORS.ISBEFORE',
      ISAFTER: 'AUTOMATION.OPERATORS.ISAFTER',
      ISSAMEDAY: 'AUTOMATION.OPERATORS.ISSAMEDAY',
      ISEMPTYDATE: 'AUTOMATION.OPERATORS.ISEMPTYDATE',
      ISSAMEID: 'AUTOMATION.OPERATORS.ISSAMEID',
      ARRAYINCLUDES: 'AUTOMATION.OPERATORS.ARRAYINCLUDES',
      ARRAYCONTAINS: 'AUTOMATION.OPERATORS.ARRAYCONTAINS',
      ISEMPTYARRAY: 'AUTOMATION.OPERATORS.ISEMPTYARRAY',
    },
    DETAIL: {
      MODEL_LABEL: 'AUTOMATION.DETAIL.MODEL_LABEL',
      CONDITIONS_COUNT: 'AUTOMATION.DETAIL.CONDITIONS_COUNT',
      ACTIONS_COUNT: 'AUTOMATION.DETAIL.ACTIONS_COUNT',
      HISTORY_TITLE: 'AUTOMATION.DETAIL.HISTORY_TITLE',
      NO_HISTORY_AVAILABLE: 'AUTOMATION.DETAIL.NO_HISTORY_AVAILABLE',
    },
    ACTION_ROW: {
      IN: 'AUTOMATION.ACTION_ROW.IN',
      SET_WORKFLOW_TO: 'AUTOMATION.ACTION_ROW.SET_WORKFLOW_TO',
      AS_ACCOUNT_MANAGER: 'AUTOMATION.ACTION_ROW.AS_ACCOUNT_MANAGER',
      COULD_NOT_LOAD: 'AUTOMATION.ACTION_ROW.COULD_NOT_LOAD',
      COPY: 'AUTOMATION.ACTION_ROW.COPY',
      PAUSE_CLIENT_FOR: 'AUTOMATION.ACTION_ROW.PAUSE_CLIENT_FOR',
      DURING: 'AUTOMATION.ACTION_ROW.DURING',
      UNPAUSE_CLIENT: 'AUTOMATION.ACTION_ROW.UNPAUSE_CLIENT',
    },
    HISTORY_PANEL: {
      COPY_VALUE_TO_FIELD: {
        VALUE_WRITTEN: 'AUTOMATION.HISTORY_PANEL.COPY_VALUE_TO_FIELD.VALUE_WRITTEN',
        IN_FIELD: 'AUTOMATION.HISTORY_PANEL.COPY_VALUE_TO_FIELD.IN_FIELD',
        OF_INVOICE: 'AUTOMATION.HISTORY_PANEL.COPY_VALUE_TO_FIELD.OF_INVOICE',
        OF_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.COPY_VALUE_TO_FIELD.OF_CUSTOMER',
      },
      COPY_FIELD_TO_FIELD: {
        VALUE_COPIED: 'AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.VALUE_COPIED',
        WAS_COPIED: 'AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.WAS_COPIED',
        OF_INVOICE: 'AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.OF_INVOICE',
        OF_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.COPY_FIELD_TO_FIELD.OF_CUSTOMER',
      },
      ASSIGN_ACCOUNT_MANAGER: {
        OF_INVOICE: 'AUTOMATION.HISTORY_PANEL.ASSIGN_ACCOUNT_MANAGER.OF_INVOICE',
        OF_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.ASSIGN_ACCOUNT_MANAGER.OF_CUSTOMER',
      },
      ASSIGN_RECOVERY_PLAN: {
        LABEL: 'AUTOMATION.HISTORY_PANEL.ASSIGN_RECOVERY_PLAN.LABEL',
        OF_INVOICE: 'AUTOMATION.HISTORY_PANEL.ASSIGN_RECOVERY_PLAN.OF_INVOICE',
        OF_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.ASSIGN_RECOVERY_PLAN.OF_CUSTOMER',
      },
      PAUSE: {
        THE_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.PAUSE.THE_CUSTOMER',
        WAS_PAUSED: 'AUTOMATION.HISTORY_PANEL.PAUSE.WAS_PAUSED',
      },
      UNPAUSE: {
        THE_CUSTOMER: 'AUTOMATION.HISTORY_PANEL.UNPAUSE.THE_CUSTOMER',
        WAS_UNPAUSED: 'AUTOMATION.HISTORY_PANEL.UNPAUSE.WAS_UNPAUSED',
      },
    },
  },
  AYS: {
    AUTOMATIC_ASSIGNATION_DELETE: 'AYS.AUTOMATIC_ASSIGNATION_DELETE',
    CLIENT_ACTION_UNDISPUTED: 'AYS.CLIENT_ACTION_UNDISPUTED',
    CNS_ACTION_DELETE: 'AYS.CNS_ACTION_DELETE',
    CNS_ACTION_SETTLE: 'AYS.CNS_ACTION_SETTLE',
    CNS_ACTION_UNSETTLE: 'AYS.CNS_ACTION_UNSETTLE',
    CN_ACTION_DELETE: 'AYS.CN_ACTION_DELETE',
    CN_ACTION_SETTLE: 'AYS.CN_ACTION_SETTLE',
    CN_ACTION_UNSETTLE: 'AYS.CN_ACTION_UNSETTLE',
    DELETE_CONTACT_PERSON: 'AYS.DELETE_CONTACT_PERSON',
    DELETE_CONTACT_PERSON_WITH_NAME: 'AYS.DELETE_CONTACT_PERSON_WITH_NAME',
    DELETE_DOMAIN: 'AYS.DELETE_DOMAIN',
    DELETE_EXTERNAL_MAIL: 'AYS.DELETE_EXTERNAL_MAIL',
    DELETE_EXTERNAL_MAILBOX_CONFIGURATION: 'AYS.DELETE_EXTERNAL_MAILBOX_CONFIGURATION',
    DELETE_EXTERNAL_MAILS: 'AYS.DELETE_EXTERNAL_MAILS',
    DELETE_REASON: 'AYS.DELETE_REASON',
    DELETE_RECOVERY_PLAN: 'AYS.DELETE_RECOVERY_PLAN',
    DELETE_TASK: 'AYS.DELETE_TASK',
    DELETE_TASKS: 'AYS.DELETE_TASKS',
    DELETE_TASK_TYPE: 'AYS.DELETE_TASK_TYPE',
    DELETE_TEMPLATE: 'AYS.DELETE_TEMPLATE',
    EXIT_PAGE: 'AYS.EXIT_PAGE',
    IGNORE_DUPLICATES: 'AYS.IGNORE_DUPLICATES',
    IGNORE_LATE_FEES: 'AYS.IGNORE_LATE_FEES',
    INVOICES_ACTION_DELETE: 'AYS.INVOICES_ACTION_DELETE',
    INVOICES_ACTION_DISPUTE: 'AYS.INVOICES_ACTION_DISPUTE',
    INVOICES_ACTION_IGNORE_LATE_FEES: 'AYS.INVOICES_ACTION_IGNORE_LATE_FEES',
    INVOICES_ACTION_MARK_AS_PAID: 'AYS.INVOICES_ACTION_MARK_AS_PAID',
    INVOICES_ACTION_PAUSE: 'AYS.INVOICES_ACTION_PAUSE',
    INVOICES_ACTION_TO_BE_PROCESSED: 'AYS.INVOICES_ACTION_TO_BE_PROCESSED',
    INVOICES_ACTION_UNDISPUTE: 'AYS.INVOICES_ACTION_UNDISPUTE',
    INVOICES_ACTION_UNPAUSE: 'AYS.INVOICES_ACTION_UNPAUSE',
    INVOICE_ACTION_DELETE: 'AYS.INVOICE_ACTION_DELETE',
    INVOICE_ACTION_DISPUTE: 'AYS.INVOICE_ACTION_DISPUTE',
    INVOICE_ACTION_IGNORE_LATE_FEES: 'AYS.INVOICE_ACTION_IGNORE_LATE_FEES',
    INVOICE_ACTION_MARK_AS_PAID: 'AYS.INVOICE_ACTION_MARK_AS_PAID',
    INVOICE_ACTION_PAUSE: 'AYS.INVOICE_ACTION_PAUSE',
    INVOICE_ACTION_TO_BE_PROCESSED: 'AYS.INVOICE_ACTION_TO_BE_PROCESSED',
    INVOICE_ACTION_UNDISPUTE: 'AYS.INVOICE_ACTION_UNDISPUTE',
    INVOICE_ACTION_UNPAUSE: 'AYS.INVOICE_ACTION_UNPAUSE',
    INVOICE_BACK_IN_PLAN: 'AYS.INVOICE_BACK_IN_PLAN',
    PAYMENT_PLAN: 'AYS.PAYMENT_PLAN',
    REQUEST_PAYMENT_PLAN: 'AYS.REQUEST_PAYMENT_PLAN',
  },
  BACK: 'BACK',
  BALANCE: 'BALANCE',
  BANK_ACCOUNT_BALANCE: 'BANK_ACCOUNT_BALANCE',
  BALANCE_CURRENCY: 'BALANCE_CURRENCY',
  BANK_ACCOUNT: {
    HISTORY: {
      IGNORED: 'BANK_ACCOUNT.HISTORY.IGNORED',
      PARTIALLY_MATCHED_WITH: 'BANK_ACCOUNT.HISTORY.PARTIALLY_MATCHED_WITH',
      PAYMENT_NO_RECONCILE: 'BANK_ACCOUNT.HISTORY.PAYMENT_NO_RECONCILE',
      RECONCILE_WITH: 'BANK_ACCOUNT.HISTORY.RECONCILE_WITH',
      SENDER: 'BANK_ACCOUNT.HISTORY.SENDER',
      TRANSACTION_NUMBER: 'BANK_ACCOUNT.HISTORY.TRANSACTION_NUMBER',
      UNIGNORED: 'BANK_ACCOUNT.HISTORY.UNIGNORED',
      UNIGNORED_PAYMENT: 'BANK_ACCOUNT.HISTORY.UNIGNORED_PAYMENT',
    },
    RECONCILIATION: {
      ALL_ENTRY_PAYMENT: 'BANK_ACCOUNT.RECONCILIATION.ALL_ENTRY_PAYMENT',
      AYS_TO_IGNORE_PAYMENT: 'BANK_ACCOUNT.RECONCILIATION.AYS_TO_IGNORE_PAYMENT',
      IGNORE_PAYMENTS: 'BANK_ACCOUNT.RECONCILIATION.IGNORE_PAYMENTS',
      LATE_FEES: 'BANK_ACCOUNT.RECONCILIATION.LATE_FEES',
      MANUAL_RECONCILIATION: 'BANK_ACCOUNT.RECONCILIATION.MANUAL_RECONCILIATION',
      PAYMENTS: 'BANK_ACCOUNT.RECONCILIATION.PAYMENTS',
      SEVERAL_ACCOUNT_SELECTED: 'BANK_ACCOUNT.RECONCILIATION.SEVERAL_ACCOUNT_SELECTED',
      SUGGESTION: 'BANK_ACCOUNT.RECONCILIATION.SUGGESTION',
      UNPAID_INVOICES: 'BANK_ACCOUNT.RECONCILIATION.UNPAID_INVOICES',
    },
  },
  BANK_ACCOUNTS: 'BANK_ACCOUNTS',
  BATCH: {
    ACTIONS: {
      ALLOW_PAYMENT_PLANS: {
        TEXT: 'BATCH.ACTIONS.ALLOW_PAYMENT_PLANS.TEXT',
        TITLE: 'BATCH.ACTIONS.ALLOW_PAYMENT_PLANS.TITLE',
      },
      CUSTOM_VARIABLES: 'BATCH.ACTIONS.CUSTOM_VARIABLES',
      UNDISPUTE: 'BATCH.ACTIONS.UNDISPUTE',
    },
    CATEGORIES: {
      ASSIGNMENT: 'BATCH.CATEGORIES.ASSIGNMENT',
      FOLLOW_UP: 'BATCH.CATEGORIES.FOLLOW_UP',
      OTHER: 'BATCH.CATEGORIES.OTHER',
      RECOVERY: 'BATCH.CATEGORIES.RECOVERY',
      STATUS: 'BATCH.CATEGORIES.STATUS',
    },
    TITLE: 'BATCH.TITLE',
    SEARCH: 'BATCH.SEARCH',
    SEARCH_PLACEHOLDER: 'BATCH.SEARCH_PLACEHOLDER',
    SELECT_ALL: 'BATCH.SELECT_ALL',
    HINT_NAVIGATE: 'BATCH.HINT_NAVIGATE',
    HINT_CHOOSE: 'BATCH.HINT_CHOOSE',
    HINT_CLOSE: 'BATCH.HINT_CLOSE',
    HINT_ESCAPE: 'BATCH.HINT_ESCAPE',
    SELECTED_INVOICES: 'BATCH.SELECTED_INVOICES',
    DELETE_INVOICES: 'BATCH.DELETE_INVOICES',
    DESCRIPTIONS: {
      ADDITIONAL_REMINDER: 'BATCH.DESCRIPTIONS.ADDITIONAL_REMINDER',
      FORMAL_NOTICE: 'BATCH.DESCRIPTIONS.FORMAL_NOTICE',
      THIRD_PARTY: 'BATCH.DESCRIPTIONS.THIRD_PARTY',
      PAYMENT_PLAN: 'BATCH.DESCRIPTIONS.PAYMENT_PLAN',
      MARK_AS_PAID: 'BATCH.DESCRIPTIONS.MARK_AS_PAID',
      DISPUTE: 'BATCH.DESCRIPTIONS.DISPUTE',
      UNDISPUTE: 'BATCH.DESCRIPTIONS.UNDISPUTE',
      UNRECOVERABLE: 'BATCH.DESCRIPTIONS.UNRECOVERABLE',
      PAUSE: 'BATCH.DESCRIPTIONS.PAUSE',
      UNPAUSE: 'BATCH.DESCRIPTIONS.UNPAUSE',
      TO_BE_PROCESSED: 'BATCH.DESCRIPTIONS.TO_BE_PROCESSED',
      MOVE_PLAN: 'BATCH.DESCRIPTIONS.MOVE_PLAN',
      ASSIGN: 'BATCH.DESCRIPTIONS.ASSIGN',
      TASK: 'BATCH.DESCRIPTIONS.TASK',
      CUSTOM_VARIABLES: 'BATCH.DESCRIPTIONS.CUSTOM_VARIABLES',
      IGNORE_LATE_FEES: 'BATCH.DESCRIPTIONS.IGNORE_LATE_FEES',
    },
  },
  BCC: 'BCC',
  BILLING_STATEMENT_DESCRIPTION: 'BILLING_STATEMENT_DESCRIPTION',
  BODY: 'BODY',
  CALCULATION_TYPE: {
    ANNUAL: 'CALCULATION_TYPE.ANNUAL',
    MONTHLY: 'CALCULATION_TYPE.MONTHLY',
    QUARTERLY: 'CALCULATION_TYPE.QUARTERLY',
  },
  CANCEL: 'CANCEL',
  CANCELLED: 'CANCELLED',
  CANCELLED_AT: 'CANCELLED_AT',
  CASE_TYPE: 'CASE_TYPE',
  CC: 'CC',
  CHOOSE: 'CHOOSE',
  CHOOSE_ACCOUNT_MANAGER: 'CHOOSE_ACCOUNT_MANAGER',
  CHOOSE_BAILIFF: 'CHOOSE_BAILIFF',
  CHOOSE_COLUMNS: 'CHOOSE_COLUMNS',
  CHOOSE_DEBT_COLLECTOR: 'CHOOSE_DEBT_COLLECTOR',
  CHOOSE_LAWYER: 'CHOOSE_LAWYER',
  CLAIMED_LATE_FEES: 'CLAIMED_LATE_FEES',
  CLIENT: {
    ACTIVITIES: {
      EMPTY: {
        TITLE: 'CLIENT.ACTIVITIES.EMPTY.TITLE',
        DESCRIPTION: 'CLIENT.ACTIVITIES.EMPTY.DESCRIPTION',
      },
      NO_RESULTS: {
        TITLE: 'CLIENT.ACTIVITIES.NO_RESULTS.TITLE',
        DESCRIPTION: 'CLIENT.ACTIVITIES.NO_RESULTS.DESCRIPTION',
      },
    },
    AYS_TO_DELETE_CLIENT: 'CLIENT.AYS_TO_DELETE_CLIENT',
    AYS_TO_DELETE_CLIENT_ALL: 'CLIENT.AYS_TO_DELETE_CLIENT_ALL',
    AYS_TO_DELETE_CLIENT_MULTIPLE: 'CLIENT.AYS_TO_DELETE_CLIENT_MULTIPLE',
    AYS_TO_PAUSE_CLIENT: 'CLIENT.AYS_TO_PAUSE_CLIENT',
    AYS_TO_PAUSE_CLIENT_ALL: 'CLIENT.AYS_TO_PAUSE_CLIENT_ALL',
    AYS_TO_PAUSE_CLIENT_MULTIPLE: 'CLIENT.AYS_TO_PAUSE_CLIENT_MULTIPLE',
    AYS_TO_UNPAUSE_CLIENT: 'CLIENT.AYS_TO_UNPAUSE_CLIENT',
    AYS_TO_UNPAUSE_CLIENT_ALL: 'CLIENT.AYS_TO_UNPAUSE_CLIENT_ALL',
    AYS_TO_UNPAUSE_CLIENT_MULTIPLE: 'CLIENT.AYS_TO_UNPAUSE_CLIENT_MULTIPLE',
    CLIENT_DELETION: 'CLIENT.CLIENT_DELETION',
    DELETED: 'CLIENT.DELETED',
    DELETE_MULTIPLE: 'CLIENT.DELETE_MULTIPLE',
    DETAIL: {
      APPLIED_VAT_0: 'CLIENT.DETAIL.APPLIED_VAT_0',
      AVERAGE_DELAY_AUTHORIZED: 'CLIENT.DETAIL.AVERAGE_DELAY_AUTHORIZED',
      BALANCE_DETAIL_TITLE: 'CLIENT.DETAIL.BALANCE_DETAIL_TITLE',
      CHANGE_INVOICES_STATE: 'CLIENT.DETAIL.CHANGE_INVOICES_STATE',
      CHANGE_TERMS_AND_CONDITIONS: 'CLIENT.DETAIL.CHANGE_TERMS_AND_CONDITIONS',
      CLIENT_TOTAL_TVAC: 'CLIENT.DETAIL.CLIENT_TOTAL_TVAC',
      COCONTRACTOR: 'CLIENT.DETAIL.COCONTRACTOR',
      CONTACT_ADMIN: 'CLIENT.DETAIL.CONTACT_ADMIN',
      DOWNLOAD_OLD_DOC: 'CLIENT.DETAIL.DOWNLOAD_OLD_DOC',
      HAVE_CONDITIONS_FOR_CLIENT: 'CLIENT.DETAIL.HAVE_CONDITIONS_FOR_CLIENT',
      INFORMATIONS: 'CLIENT.DETAIL.INFORMATIONS',
      INTEREST_RATE: 'CLIENT.DETAIL.INTEREST_RATE',
      LATE: 'CLIENT.DETAIL.LATE',
      LATE_PAYMENT_RATE: 'CLIENT.DETAIL.LATE_PAYMENT_RATE',
      MIN_DAYS_BETWEEN_REMINDER: 'CLIENT.DETAIL.MIN_DAYS_BETWEEN_REMINDER',
      MIN_PENALTY_CLAUSE: 'CLIENT.DETAIL.MIN_PENALTY_CLAUSE',
      NOT_HAVE_CONDITIONS_FOR_CLIENT: 'CLIENT.DETAIL.NOT_HAVE_CONDITIONS_FOR_CLIENT',
      NOT_USING_DEFAULT_TNC: 'CLIENT.DETAIL.NOT_USING_DEFAULT_TNC',
      NO_ACTIVITY: 'CLIENT.DETAIL.NO_ACTIVITY',
      OVERWRITE_OLD_DOC: 'CLIENT.DETAIL.OVERWRITE_OLD_DOC',
      PAUSE_DEBTOR_RECOVERY: 'CLIENT.DETAIL.PAUSE_DEBTOR_RECOVERY',
      REMAIN_BALANCE: 'CLIENT.DETAIL.REMAIN_BALANCE',
      SALES_CONDITIONS: 'CLIENT.DETAIL.SALES_CONDITIONS',
      SELECT_DATES: 'CLIENT.DETAIL.SELECT_DATES',
      SHOW_SETTLED: 'CLIENT.DETAIL.SHOW_SETTLED',
      TNC_UPDATED_SUCCESS: 'CLIENT.DETAIL.TNC_UPDATED_SUCCESS',
      TYPES: 'CLIENT.DETAIL.TYPES',
      UNPAUSE_DEBTOR_RECOVERY: 'CLIENT.DETAIL.UNPAUSE_DEBTOR_RECOVERY',
    },
    DISPUTED_REASON: 'CLIENT.DISPUTED_REASON',
    EDITING_DEFAULT_TEMPLATE: 'CLIENT.EDITING_DEFAULT_TEMPLATE',
    EDIT_DEFAULT_TEMPLATE: 'CLIENT.EDIT_DEFAULT_TEMPLATE',
    EXPORT_CSV: 'CLIENT.EXPORT_CSV',
    EXTERNAL_ID: 'CLIENT.EXTERNAL_ID',
    FILTER: {
      ALL: 'CLIENT.FILTER.ALL',
      CURRENT_BALANCE: 'CLIENT.FILTER.CURRENT_BALANCE',
      LATE_BALANCE: 'CLIENT.FILTER.LATE_BALANCE',
      LATE_PAYMENT: 'CLIENT.FILTER.LATE_PAYMENT',
      ONGOING: 'CLIENT.FILTER.ONGOING',
      PAUSED: 'CLIENT.FILTER.PAUSED',
      RECOVERY_STATUS: 'CLIENT.FILTER.RECOVERY_STATUS',
      REVENUES_EURO: 'CLIENT.FILTER.REVENUES_EURO',
    },
    GENERAL_INFO: 'CLIENT.GENERAL_INFO',
    GENERAL_INFO_TAB: {
      ACTIONS: {
        SEE_ALL_ACTIVITY: 'CLIENT.GENERAL_INFO_TAB.ACTIONS.SEE_ALL_ACTIVITY',
        SEE_ALL_BALANCE: 'CLIENT.GENERAL_INFO_TAB.ACTIONS.SEE_ALL_BALANCE',
      },
      ANNUAL_TURNOVER_SHARE: 'CLIENT.GENERAL_INFO_TAB.ANNUAL_TURNOVER_SHARE',
      BILLED_AMOUNT_PREFIX: 'CLIENT.GENERAL_INFO_TAB.BILLED_AMOUNT_PREFIX',
      BILLED_AMOUNT_SUFFIX: 'CLIENT.GENERAL_INFO_TAB.BILLED_AMOUNT_SUFFIX',
      COULD_NOT_FETCH: 'CLIENT.GENERAL_INFO_TAB.COULD_NOT_FETCH',
      NO_ACTIVITY: 'CLIENT.GENERAL_INFO_TAB.NO_ACTIVITY',
      OPEN_INVOICES: 'CLIENT.GENERAL_INFO_TAB.OPEN_INVOICES',
      PANEL_TITLE: {
        ACTIVITY: 'CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.ACTIVITY',
        AVERAGE_PAYMENT_DELAY: 'CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.AVERAGE_PAYMENT_DELAY',
        BALANCE: 'CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.BALANCE',
        INFORMATION: 'CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.INFORMATION',
        LATE_PAYMENT_RATE: 'CLIENT.GENERAL_INFO_TAB.PANEL_TITLE.LATE_PAYMENT_RATE',
      },
    },
    HEADER: {
      AVERAGE_AUTHORIZED_DELAY: 'CLIENT.HEADER.AVERAGE_AUTHORIZED_DELAY',
      CURRENT_BALANCE: 'CLIENT.HEADER.CURRENT_BALANCE',
      LATE_BALANCE: 'CLIENT.HEADER.LATE_BALANCE',
    },
    IMPORT: {
      CLIENTS_TO_CONFIRM: 'CLIENT.IMPORT.CLIENTS_TO_CONFIRM',
    },
    MERGE: {
      DESCRIPTION: 'CLIENT.MERGE.DESCRIPTION',
      IGNORE: 'CLIENT.MERGE.IGNORE',
      SELECT_CLIENT: 'CLIENT.MERGE.SELECT_CLIENT',
      TITLE: 'CLIENT.MERGE.TITLE',
    },
    MOVE_INVOICES_IN_PLAN: 'CLIENT.MOVE_INVOICES_IN_PLAN',
    NOT_IMPORTED: 'CLIENT.NOT_IMPORTED',
    PAUSE: 'CLIENT.PAUSE',
    PAUSED_REASON: 'CLIENT.PAUSED_REASON',
    PAUSE_MULTIPLE: 'CLIENT.PAUSE_MULTIPLE',
    PORTAIL_LINK: 'CLIENT.PORTAIL_LINK',
    STATUS: {
      DISPUTE: 'CLIENT.STATUS.DISPUTE',
      PAUSED: 'CLIENT.STATUS.PAUSED',
    },
    SUCCESSFULLY_ADD: 'CLIENT.SUCCESSFULLY_ADD',
    SUCCESSFULLY_UPDATE: 'CLIENT.SUCCESSFULLY_UPDATE',
    SUCCESSFUL_IMPORT: 'CLIENT.SUCCESSFUL_IMPORT',
    TABS: {
      ACTIVITIES: 'CLIENT.TABS.ACTIVITIES',
      BALANCE: 'CLIENT.TABS.BALANCE',
      GENERAL_INFO: 'CLIENT.TABS.GENERAL_INFO',
      KANBAN: 'CLIENT.TABS.KANBAN',
      PREFERENCES: 'CLIENT.TABS.PREFERENCES',
      TASKS: 'CLIENT.TABS.TASKS',
    },
    TOOLTIP: {
      COPY_PORTAL_LINK: 'CLIENT.TOOLTIP.COPY_PORTAL_LINK',
      EMAIL_SENT: 'CLIENT.TOOLTIP.EMAIL_SENT',
      OPEN_PORTAL_NEW_TAB: 'CLIENT.TOOLTIP.OPEN_PORTAL_NEW_TAB',
      SEND_PORTAL_EMAIL: 'CLIENT.TOOLTIP.SEND_PORTAL_EMAIL',
    },
    UNPAUSE: 'CLIENT.UNPAUSE',
    UNPAUSE_MULTIPLE: 'CLIENT.UNPAUSE_MULTIPLE',
  },
  CLIENTS: 'CLIENTS',
  CLIENT_BALANCE: 'CLIENT_BALANCE',
  CLOSE: 'CLOSE',
  COLUMNS: 'COLUMNS',
  COLUMN_NAME: 'COLUMN_NAME',
  COLUMN_TYPE: {
    ACTIONS: 'COLUMN_TYPE.ACTIONS',
    BOOLEAN: 'COLUMN_TYPE.BOOLEAN',
    DATE: 'COLUMN_TYPE.DATE',
    NUMBER: 'COLUMN_TYPE.NUMBER',
    SELECT: 'COLUMN_TYPE.SELECT',
    STRING: 'COLUMN_TYPE.STRING',
  },
  COMMENT: 'COMMENT',
  COMMENTS: 'COMMENTS',
  COMMENTS_ATTRIBUTES: {
    CANCEL: 'COMMENTS_ATTRIBUTES.CANCEL',
    DELETE: 'COMMENTS_ATTRIBUTES.DELETE',
    DELETED_SUCCESS: 'COMMENTS_ATTRIBUTES.DELETED_SUCCESS',
    DELETE_CONFIRMATION: 'COMMENTS_ATTRIBUTES.DELETE_CONFIRMATION',
    EDIT: 'COMMENTS_ATTRIBUTES.EDIT',
    POSTED_AT: 'COMMENTS_ATTRIBUTES.POSTED_AT',
    SAVE: 'COMMENTS_ATTRIBUTES.SAVE',
    UPDATED_SUCCESS: 'COMMENTS_ATTRIBUTES.UPDATED_SUCCESS',
  },
  COMMON: {
    BANK_ACCOUNT: 'COMMON.BANK_ACCOUNT',
    CLIENT: 'COMMON.CLIENT',
    DASHBOARD: 'COMMON.DASHBOARD',
    INVOICE: 'COMMON.INVOICE',
    INVOICING: 'COMMON.INVOICING',
    TASK: 'COMMON.TASK',
    TEMPLATE: 'COMMON.TEMPLATE',
  },
  COMMUNICATION: 'COMMUNICATION',
  COMPANY_EMAIL: 'COMPANY_EMAIL',
  COMPANY_LOCALE: 'COMPANY_LOCALE',
  COMPANY_NAME: 'COMPANY_NAME',
  COMPLETED: 'COMPLETED',
  CONFIRM: 'CONFIRM',
  IMAGE_FROM_URL: 'IMAGE_FROM_URL',
  CONFIRMATION: 'CONFIRMATION',
  CONGRATULATION: 'CONGRATULATION',
  CONTACT: 'CONTACT',
  CONTACT_PERSON: {
    ADD: 'CONTACT_PERSON.ADD',
    BASIC_INFORMATION: 'CONTACT_PERSON.BASIC_INFORMATION',
    EDIT: 'CONTACT_PERSON.EDIT',
    MAIN_CONTACT: 'CONTACT_PERSON.MAIN_CONTACT',
    NO_CONTACT_PERSON: 'CONTACT_PERSON.NO_CONTACT_PERSON',
    NOTIFICATIONS: {
      AI_CALL: 'CONTACT_PERSON.NOTIFICATIONS.AI_CALL',
      FORMAL_NOTICE: 'CONTACT_PERSON.NOTIFICATIONS.FORMAL_NOTICE',
      INVOICE_SENDING: 'CONTACT_PERSON.NOTIFICATIONS.INVOICE_SENDING',
      LEGAL_CASE: 'CONTACT_PERSON.NOTIFICATIONS.LEGAL_CASE',
      REMINDERS: 'CONTACT_PERSON.NOTIFICATIONS.REMINDERS',
    },
    NOTIFICATIONS_MEDIUM: 'CONTACT_PERSON.NOTIFICATIONS_MEDIUM',
    ONE: 'CONTACT_PERSON.ONE',
    TITLE: 'CONTACT_PERSON.TITLE',
    USE_POSTAL_ADDRESS: 'CONTACT_PERSON.USE_POSTAL_ADDRESS',
  },
  CONTINUE: 'CONTINUE',
  CONTINUE_ANYWAY: 'CONTINUE_ANYWAY',
  COPIED: 'COPIED',
  COPIED_LINK: 'COPIED_LINK',
  COPY: 'COPY',
  CREATION: 'CREATION',
  CREATION_DATE: 'CREATION_DATE',
  CREDIT: 'CREDIT',
  CREDIT_CARD: 'CREDIT_CARD',
  CREDIT_NOTE: 'CREDIT_NOTE',
  CREDIT_NOTES: 'CREDIT_NOTES',
  CREDIT_NOTE_LINKED: 'CREDIT_NOTE_LINKED',
  CREDIT_NOTE_SHORT: 'CREDIT_NOTE_SHORT',
  CURRENCY: 'CURRENCY',
  CUSTOMIZATION_INVOICE_FOOTER: 'CUSTOMIZATION_INVOICE_FOOTER',
  CUSTOM_DOMAIN: {
    REFRESH_RECORDS: 'CUSTOM_DOMAIN.REFRESH_RECORDS',
    VIEW_DNS: 'CUSTOM_DOMAIN.VIEW_DNS',
    DELETE: 'CUSTOM_DOMAIN.DELETE',
    DESCRIPTION: 'CUSTOM_DOMAIN.DESCRIPTION',
    DNS_MODAL_INFO: 'CUSTOM_DOMAIN.DNS_MODAL_INFO',
    DNS_MODAL_TITLE: 'CUSTOM_DOMAIN.DNS_MODAL_TITLE',
    EMPTY_HINT: 'CUSTOM_DOMAIN.EMPTY_HINT',
    LATER: 'CUSTOM_DOMAIN.LATER',
    PENDING_HINT: 'CUSTOM_DOMAIN.PENDING_HINT',
    RECORD_PENDING: 'CUSTOM_DOMAIN.RECORD_PENDING',
    RECORD_VERIFIED: 'CUSTOM_DOMAIN.RECORD_VERIFIED',
    SAVED_NOTICE: 'CUSTOM_DOMAIN.SAVED_NOTICE',
    STATUS_PENDING: 'CUSTOM_DOMAIN.STATUS_PENDING',
    STATUS_VERIFIED: 'CUSTOM_DOMAIN.STATUS_VERIFIED',
    TITLE: 'CUSTOM_DOMAIN.TITLE',
    AUTHENTICATE: 'CUSTOM_DOMAIN.AUTHENTICATE',
    COPY_ALL_RECORDS: 'CUSTOM_DOMAIN.COPY_ALL_RECORDS',
    DEFAULT_FROM: 'CUSTOM_DOMAIN.DEFAULT_FROM',
    DNS_INFO: 'CUSTOM_DOMAIN.DNS_INFO',
    DNS_SETTINGS: 'CUSTOM_DOMAIN.DNS_SETTINGS',
    NAME: 'CUSTOM_DOMAIN.NAME',
    NOT_YET_VERIFIED: 'CUSTOM_DOMAIN.NOT_YET_VERIFIED',
    NO_DOMAIN: 'CUSTOM_DOMAIN.NO_DOMAIN',
    NO_MATCH: 'CUSTOM_DOMAIN.NO_MATCH',
    RECORD_NAME: 'CUSTOM_DOMAIN.RECORD_NAME',
    RECORD_VALUE: 'CUSTOM_DOMAIN.RECORD_VALUE',
    SECTION_TITLE: 'CUSTOM_DOMAIN.SECTION_TITLE',
    VALIDATE_DOMAIN: 'CUSTOM_DOMAIN.VALIDATE_DOMAIN',
    VERIFY: 'CUSTOM_DOMAIN.VERIFY',
  },
  CUSTOM_FIELD: 'CUSTOM_FIELD',
  DASHBOARD: {
    ACTIVE_INTEGRATION: 'DASHBOARD.ACTIVE_INTEGRATION',
    BALANCE_DETAIL: 'DASHBOARD.BALANCE_DETAIL',
    BANK_STATUS: {
      ACCOUNT_BALANCE: 'DASHBOARD.BANK_STATUS.ACCOUNT_BALANCE',
      ALL_ACCOUNTS_BALANCE: 'DASHBOARD.BANK_STATUS.ALL_ACCOUNTS_BALANCE',
      MONTH_FORECAST: 'DASHBOARD.BANK_STATUS.MONTH_FORECAST',
      TITLE: 'DASHBOARD.BANK_STATUS.TITLE',
      WEEK_FORECAST: 'DASHBOARD.BANK_STATUS.WEEK_FORECAST',
    },
    CUSTOMER_RECEIVABLES: {
      TITLE: 'DASHBOARD.CUSTOMER_RECEIVABLES.TITLE',
      TOTAL_COMMITTED: 'DASHBOARD.CUSTOMER_RECEIVABLES.TOTAL_COMMITTED',
    },
    DELAY_GRAPHIC: {
      SUBTITLE: 'DASHBOARD.DELAY_GRAPHIC.SUBTITLE',
      TITLE: 'DASHBOARD.DELAY_GRAPHIC.TITLE',
    },
    FAILED_REMINDERS_COUNT: 'DASHBOARD.FAILED_REMINDERS_COUNT',
    FAILED_REMINDER_COUNT: 'DASHBOARD.FAILED_REMINDER_COUNT',
    LATE_PAYMENT_PLANS_COUNT: 'DASHBOARD.LATE_PAYMENT_PLANS_COUNT',
    LATE_PAYMENT_PLAN_COUNT: 'DASHBOARD.LATE_PAYMENT_PLAN_COUNT',
    ONGOING_TASKS_COUNT: 'DASHBOARD.ONGOING_TASKS_COUNT',
    ONGOING_TASK_COUNT: 'DASHBOARD.ONGOING_TASK_COUNT',
    OUTSTANDINGS_BASED_ON: 'DASHBOARD.OUTSTANDINGS_BASED_ON',
    SELECT_ACCOUNT_MANAGER: 'DASHBOARD.SELECT_ACCOUNT_MANAGER',
    UNPROCESSED_EMAILS_COUNT: 'DASHBOARD.UNPROCESSED_EMAILS_COUNT',
    UNPROCESSED_EMAIL_COUNT: 'DASHBOARD.UNPROCESSED_EMAIL_COUNT',
    UNREAD_THIRD_PARTY_MESSAGES_COUNT: 'DASHBOARD.UNREAD_THIRD_PARTY_MESSAGES_COUNT',
  },
  DASHBOARD_OPTIONS: 'DASHBOARD_OPTIONS',
  DATE: 'DATE',
  DATES: {
    DAY_NAMES: {
      FRIDAY: 'DATES.DAY_NAMES.FRIDAY',
      MONDAY: 'DATES.DAY_NAMES.MONDAY',
      SATURDAY: 'DATES.DAY_NAMES.SATURDAY',
      SUNDAY: 'DATES.DAY_NAMES.SUNDAY',
      THURSDAY: 'DATES.DAY_NAMES.THURSDAY',
      TUESDAY: 'DATES.DAY_NAMES.TUESDAY',
      WEDNESDAY: 'DATES.DAY_NAMES.WEDNESDAY',
    },
    PERIOD_NAMES: {
      MONTHLY: 'DATES.PERIOD_NAMES.MONTHLY',
      WEEKLY: 'DATES.PERIOD_NAMES.WEEKLY',
    },
  },
  DAY: 'DAY',
  DAYS: 'DAYS',
  DAYS_LATE: 'DAYS_LATE',
  DAY_S: 'DAY_S',
  DEACTIVATED: 'DEACTIVATED',
  DEBIT: 'DEBIT',
  DEBTOR: {
    VIEW_PAYMENT_PLAN: 'DEBTOR.VIEW_PAYMENT_PLAN',
    AMOUNT_LINKED: 'DEBTOR.AMOUNT_LINKED',
    CREDIT_NOTE_REFERENCE: 'DEBTOR.CREDIT_NOTE_REFERENCE',
    CURRENCY: 'DEBTOR.CURRENCY',
    DETAILED_VIEW: 'DEBTOR.DETAILED_VIEW',
    DOWNLOAD_LINKED_DOCUMENT: 'DEBTOR.DOWNLOAD_LINKED_DOCUMENT',
    DOWNLOAD_MY: 'DEBTOR.DOWNLOAD_MY',
    INVOICE_REFERENCE: 'DEBTOR.INVOICE_REFERENCE',
    LOCALE: 'DEBTOR.LOCALE',
    MONITORING: {
      CREDIT_LIMIT: 'DEBTOR.MONITORING.CREDIT_LIMIT',
      FULL_REPORT: 'DEBTOR.MONITORING.FULL_REPORT',
      NOT_ENABLED: 'DEBTOR.MONITORING.NOT_ENABLED',
      NOT_EXISTING: 'DEBTOR.MONITORING.NOT_EXISTING',
      NO_VAT: 'DEBTOR.MONITORING.NO_VAT',
      ONGOING: 'DEBTOR.MONITORING.ONGOING',
      SCORE: 'DEBTOR.MONITORING.SCORE',
      SUBSCRIBE: 'DEBTOR.MONITORING.SUBSCRIBE',
      SUBSCRIPTION_ACTIVE: 'DEBTOR.MONITORING.SUBSCRIPTION_ACTIVE',
      TAB_TITLE: 'DEBTOR.MONITORING.TAB_TITLE',
      TO_SETTINGS: 'DEBTOR.MONITORING.TO_SETTINGS',
      UPDATE_DATA: 'DEBTOR.MONITORING.UPDATE_DATA',
      WARNINGS: 'DEBTOR.MONITORING.WARNINGS',
      WARNING_DETAILS: 'DEBTOR.MONITORING.WARNING_DETAILS',
    },
    REACTION: {
      CLIENT_PORTAL_OF: 'DEBTOR.REACTION.CLIENT_PORTAL_OF',
      CREDIT_NOTE_DETAILS: 'DEBTOR.REACTION.CREDIT_NOTE_DETAILS',
      GTC: 'DEBTOR.REACTION.GTC',
      LINK_NO_LONGER_VALID: 'DEBTOR.REACTION.LINK_NO_LONGER_VALID',
      NO_INVOICE_TO_PAY: 'DEBTOR.REACTION.NO_INVOICE_TO_PAY',
      NO_PAID_INVOICE: 'DEBTOR.REACTION.NO_PAID_INVOICE',
      PAY: 'DEBTOR.REACTION.PAY',
      PAYMENT_FAILED: 'DEBTOR.REACTION.PAYMENT_FAILED',
      PAYMENT_QR_CODE: 'DEBTOR.REACTION.PAYMENT_QR_CODE',
      PAYMENT_SUCCEEDED: 'DEBTOR.REACTION.PAYMENT_SUCCEEDED',
      QR_CODE_DESCRIPTION: 'DEBTOR.REACTION.QR_CODE_DESCRIPTION',
      REQUEST_PAYMENT_PLAN: 'DEBTOR.REACTION.REQUEST_PAYMENT_PLAN',
      SELECT_INVOICES: 'DEBTOR.REACTION.SELECT_INVOICES',
    },
    REACTION_AUTHOR_NAME: 'DEBTOR.REACTION_AUTHOR_NAME',
    REACT_TO: 'DEBTOR.REACT_TO',
    REFERENCE: 'DEBTOR.REFERENCE',
    REFERENCE_PLACEHOLDER: 'DEBTOR.REFERENCE_PLACEHOLDER',
    SENDING_MEDIUM: 'DEBTOR.SENDING_MEDIUM',
    SENDING_MEDIUMS: 'DEBTOR.SENDING_MEDIUMS',
    SENT_DOCUMENT_REACTION: 'DEBTOR.SENT_DOCUMENT_REACTION',
    SUCCESSFULLY_COMMENT: 'DEBTOR.SUCCESSFULLY_COMMENT',
    SUMMARY: 'DEBTOR.SUMMARY',
  },
  DEBTOR_BALANCE: 'DEBTOR_BALANCE',
  DEBTOR_EXTERNAL_ID: 'DEBTOR_EXTERNAL_ID',
  EXTERNAL_ID: 'EXTERNAL_ID',
  CSV_ID: 'CSV_ID',
  DEBTOR_LOCALE: 'DEBTOR_LOCALE',
  DEBTOR_NAME: 'DEBTOR_NAME',
  DEFAULT: 'DEFAULT',
  DEFAULT_ADDITIONAL_REMINDER: 'DEFAULT_ADDITIONAL_REMINDER',
  DEFAULT_CN_TEMPLATE: 'DEFAULT_CN_TEMPLATE',
  DEFAULT_FORMAL_NOTICE: 'DEFAULT_FORMAL_NOTICE',
  DEFAULT_INVOICE_TEMPLATE: 'DEFAULT_INVOICE_TEMPLATE',
  DELAY: {
    ABOVE_90: 'DELAY.ABOVE_90',
    BETWEEN_30_AND_60: 'DELAY.BETWEEN_30_AND_60',
    BETWEEN_60_AND_90: 'DELAY.BETWEEN_60_AND_90',
    NOT_DUE_YET: 'DELAY.NOT_DUE_YET',
    OVERDUE: 'DELAY.OVERDUE',
    WITHIN_30: 'DELAY.WITHIN_30',
  },
  DELAY_BETWEEN_REMINDERS: 'DELAY_BETWEEN_REMINDERS',
  DELAY_WITH_PREVIOUS_ACTION: 'DELAY_WITH_PREVIOUS_ACTION',
  DELETE: 'DELETE',
  DELETE_ACCOUNT_MANAGER: 'DELETE_ACCOUNT_MANAGER',
  DELETE_ALL: 'DELETE_ALL',
  DELETE_EMPTY_VALUES: 'DELETE_EMPTY_VALUES',
  DELETE_PAYMENT: 'DELETE_PAYMENT',
  DELETE_SELECTION: 'DELETE_SELECTION',
  DELETE_TEMPLATE: 'DELETE_TEMPLATE',
  DESCRIPTION: 'DESCRIPTION',
  DETAILS: 'DETAILS',
  DIRECT_CONTACT: 'DIRECT_CONTACT',
  DISPLAY_QR_CODE: 'DISPLAY_QR_CODE',
  DOCUMENTS_LOCALE: 'DOCUMENTS_LOCALE',
  DOCUMENT_CUSTOMIZATION: 'DOCUMENT_CUSTOMIZATION',
  DONT_SAVE: 'DONT_SAVE',
  DOWNLOAD: 'DOWNLOAD',
  DOWNLOAD_SENT_LETTER: 'DOWNLOAD_SENT_LETTER',
  DUE_DATE: 'DUE_DATE',
  DUE_DATE_SHORT: 'DUE_DATE_SHORT',
  DUPLICATE: 'DUPLICATE',
  DUPLICATES: 'DUPLICATES',
  EDIT: 'EDIT',
  EDIT_REASON: 'EDIT_REASON',
  EDIT_REMINDER: 'EDIT_REMINDER',
  EDIT_SIGNATURE: 'EDIT_SIGNATURE',
  EDIT_TASK: 'EDIT_TASK',
  EDIT_TASK_TYPE: 'EDIT_TASK_TYPE',
  EDIT_TEMPLATE: 'EDIT_TEMPLATE',
  EMAIL: 'EMAIL',
  EMAILS: 'EMAILS',
  EMPTY: 'EMPTY',
  END_OF_PAUSE: 'END_OF_PAUSE',
  ENTERPRISE_PHONE_NUMBER: 'ENTERPRISE_PHONE_NUMBER',
  ERROR: {
    CANNOT_BE_MOVED: 'ERROR.CANNOT_BE_MOVED',
    CHOOSE_FILE_NOT_ACCEPTED: 'ERROR.CHOOSE_FILE_NOT_ACCEPTED',
    CURRENT_PASSWORD_REQUIRED: 'ERROR.CURRENT_PASSWORD_REQUIRED',
    DOC_NOT_AVAILABLE: 'ERROR.DOC_NOT_AVAILABLE',
    ERROR: 'ERROR.ERROR',
    FIELD_NOT_EMPTY: 'ERROR.FIELD_NOT_EMPTY',
    FIELD_REQUIRED: 'ERROR.FIELD_REQUIRED',
    FIELD_VALUE_TOO_BIG: 'ERROR.FIELD_VALUE_TOO_BIG',
    FIELD_VALUE_TOO_SMALL: 'ERROR.FIELD_VALUE_TOO_SMALL',
    HAS_PROBLEM: 'ERROR.HAS_PROBLEM',
    HAVE_BEEN_DISCONNECTED: 'ERROR.HAVE_BEEN_DISCONNECTED',
    HIGHER_THAN_0: 'ERROR.HIGHER_THAN_0',
    IMPORT_ERROR: 'ERROR.IMPORT_ERROR',
    INVALID: 'ERROR.INVALID',
    INVALID_BIC: 'ERROR.INVALID_BIC',
    INVALID_EMAIL: 'ERROR.INVALID_EMAIL',
    INVALID_FILE_FORMAT: 'ERROR.INVALID_FILE_FORMAT',
    INVALID_IBAN: 'ERROR.INVALID_IBAN',
    INVALID_IBAN_BIC: 'ERROR.INVALID_IBAN_BIC',
    INVALID_PASSWORD: 'ERROR.INVALID_PASSWORD',
    INVALID_PHONE: 'ERROR.INVALID_PHONE',
    MAX_25: 'ERROR.MAX_25',
    MAX_LENGTH: 'ERROR.MAX_LENGTH',
    MIN_5: 'ERROR.MIN_5',
    MIN_LENGTH: 'ERROR.MIN_LENGTH',
    MUST_BE_DIFFERENT: 'ERROR.MUST_BE_DIFFERENT',
    MUST_BE_HIGHER: 'ERROR.MUST_BE_HIGHER',
    MUST_BE_LOWER_EQUAL: 'ERROR.MUST_BE_LOWER_EQUAL',
    MUST_BE_NUMBER: 'ERROR.MUST_BE_NUMBER',
    NOT_FULLY_FILLED: 'ERROR.NOT_FULLY_FILLED',
    NO_CUSTOM_VARIABLE: 'ERROR.NO_CUSTOM_VARIABLE',
    NO_INVOICE_IN_PLAN: 'ERROR.NO_INVOICE_IN_PLAN',
    RECONCILATION_ACTIVATED: 'ERROR.RECONCILATION_ACTIVATED',
    REFRESH_PAGE_IF_ERROR_PERSIST: 'ERROR.REFRESH_PAGE_IF_ERROR_PERSIST',
    REPORT_PROBLEM: 'ERROR.REPORT_PROBLEM',
    RESTART: 'ERROR.RESTART',
    SERVER_NOT_RESPONDING: 'ERROR.SERVER_NOT_RESPONDING',
    START_RF: 'ERROR.START_RF',
    SUMMARY: 'ERROR.SUMMARY',
  },
  EXCL_VAT: 'EXCL_VAT',
  EXCL_VAT_PRICE: 'EXCL_VAT_PRICE',
  EXPORT: 'EXPORT',
  EXPORT_CSV: 'EXPORT_CSV',
  EXTERNAL_MAIL: {
    DRAFT: 'EXTERNAL_MAIL.DRAFT',
    ACTIONS: {
      ASSIGN: 'EXTERNAL_MAIL.ACTIONS.ASSIGN',
      DELETE: 'EXTERNAL_MAIL.ACTIONS.DELETE',
      PROCESS: 'EXTERNAL_MAIL.ACTIONS.PROCESS',
      READ: 'EXTERNAL_MAIL.ACTIONS.READ',
      UNPROCESS: 'EXTERNAL_MAIL.ACTIONS.UNPROCESS',
      UNREAD: 'EXTERNAL_MAIL.ACTIONS.UNREAD',
      ASCENDING: 'EXTERNAL_MAIL.ACTIONS.ASCENDING',
      DESCENDING: 'EXTERNAL_MAIL.ACTIONS.DESCENDING',
      GENERATE_REPLY: 'EXTERNAL_MAIL.ACTIONS.GENERATE_REPLY',
    },
    GENERATE_REPLY_MODAL: {
      SUBTITLE: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.SUBTITLE',
      PROMPT_LABEL: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.PROMPT_LABEL',
      PROMPT_PLACEHOLDER: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.PROMPT_PLACEHOLDER',
      FOOTER_NOTE: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.FOOTER_NOTE',
      GENERATE: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.GENERATE',
      DRAFTING: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.DRAFTING',
      EDIT_PROMPT: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.EDIT_PROMPT',
      ERROR_TITLE: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.ERROR_TITLE',
      SAVE_AS_DRAFT: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.SAVE_AS_DRAFT',
      SEND_DIRECTLY: 'EXTERNAL_MAIL.GENERATE_REPLY_MODAL.SEND_DIRECTLY',
    },
    ATTACHMENTS: 'EXTERNAL_MAIL.ATTACHMENTS',
    ATTACHMENTS_LABEL: 'EXTERNAL_MAIL.ATTACHMENTS_LABEL',
    BCC: 'EXTERNAL_MAIL.BCC',
    BODY_REQUIRED: 'EXTERNAL_MAIL.BODY_REQUIRED',
    CC: 'EXTERNAL_MAIL.CC',
    COMPOSE_TITLE: 'EXTERNAL_MAIL.COMPOSE_TITLE',
    INVALID_EMAIL: 'EXTERNAL_MAIL.INVALID_EMAIL',
    NEW: 'EXTERNAL_MAIL.NEW',
    RECIPIENT_REQUIRED: 'EXTERNAL_MAIL.RECIPIENT_REQUIRED',
    SUBJECT_REQUIRED: 'EXTERNAL_MAIL.SUBJECT_REQUIRED',
    OPEN: 'EXTERNAL_MAIL.OPEN',
    RECIPIENTS_PLACEHOLDER: 'EXTERNAL_MAIL.RECIPIENTS_PLACEHOLDER',
    FILE_TYPE: {
      CLIENT_PORTAL: 'EXTERNAL_MAIL.FILE_TYPE.CLIENT_PORTAL',
      CREDIT_NOTE: 'EXTERNAL_MAIL.FILE_TYPE.CREDIT_NOTE',
      INVOICE: 'EXTERNAL_MAIL.FILE_TYPE.INVOICE',
      TERMS_AND_CONDITIONS: 'EXTERNAL_MAIL.FILE_TYPE.TERMS_AND_CONDITIONS',
    },
    INSERT_DEBTOR_FILE: 'EXTERNAL_MAIL.INSERT_DEBTOR_FILE',
    SELECT_DEBTOR: 'EXTERNAL_MAIL.SELECT_DEBTOR',
    SHOW_MORE: 'EXTERNAL_MAIL.SHOW_MORE',
    SHOW_LESS: 'EXTERNAL_MAIL.SHOW_LESS',
    CATEGORY_FILTER_PLACEHOLDER: 'EXTERNAL_MAIL.CATEGORY_FILTER_PLACEHOLDER',
    CATEGORIES_BETA_TOOLTIP: 'EXTERNAL_MAIL.CATEGORIES_BETA_TOOLTIP',
    CATEGORIES_NEW_LABEL: 'EXTERNAL_MAIL.CATEGORIES_NEW_LABEL',
    CATEGORY: {
      PAYMENT_CONFIRMATION: 'EXTERNAL_MAIL.CATEGORY.PAYMENT_CONFIRMATION',
      PROMISE_TO_PAY: 'EXTERNAL_MAIL.CATEGORY.PROMISE_TO_PAY',
      PAYMENT_PLAN_REQUEST: 'EXTERNAL_MAIL.CATEGORY.PAYMENT_PLAN_REQUEST',
      ADMINISTRATIVE_CHANGE: 'EXTERNAL_MAIL.CATEGORY.ADMINISTRATIVE_CHANGE',
      QUESTION_CLARIFICATION: 'EXTERNAL_MAIL.CATEGORY.QUESTION_CLARIFICATION',
      DOCUMENT_REQUEST: 'EXTERNAL_MAIL.CATEGORY.DOCUMENT_REQUEST',
      DISPUTE: 'EXTERNAL_MAIL.CATEGORY.DISPUTE',
      FORWARD: 'EXTERNAL_MAIL.CATEGORY.FORWARD',
    },
    SORT_FIELDS: {
      DATE: 'EXTERNAL_MAIL.SORT_FIELDS.DATE',
      FROM_MAIL: 'EXTERNAL_MAIL.SORT_FIELDS.FROM_MAIL',
      SORT: 'EXTERNAL_MAIL.SORT_FIELDS.SORT',
      SUBJECT: 'EXTERNAL_MAIL.SORT_FIELDS.SUBJECT',
    },
    DETAIL_NEXT: {
      ACCOUNT_MANAGER: 'EXTERNAL_MAIL.DETAIL_NEXT.ACCOUNT_MANAGER',
      ADD_TAG: 'EXTERNAL_MAIL.DETAIL_NEXT.ADD_TAG',
      BADGE_INBOUND: 'EXTERNAL_MAIL.DETAIL_NEXT.BADGE_INBOUND',
      BADGE_SENT: 'EXTERNAL_MAIL.DETAIL_NEXT.BADGE_SENT',
      BETA_TOGGLE_LABEL: 'EXTERNAL_MAIL.DETAIL_NEXT.BETA_TOGGLE_LABEL',
      BETA_TOGGLE_TOOLTIP_LEAVE: 'EXTERNAL_MAIL.DETAIL_NEXT.BETA_TOGGLE_TOOLTIP_LEAVE',
      BETA_TOGGLE_TOOLTIP_TRY: 'EXTERNAL_MAIL.DETAIL_NEXT.BETA_TOGGLE_TOOLTIP_TRY',
      CATEGORIES_LABEL: 'EXTERNAL_MAIL.DETAIL_NEXT.CATEGORIES_LABEL',
      COLLAPSE: 'EXTERNAL_MAIL.DETAIL_NEXT.COLLAPSE',
      DOWNLOAD_ALL: 'EXTERNAL_MAIL.DETAIL_NEXT.DOWNLOAD_ALL',
      COMPOSER_CLOSE: 'EXTERNAL_MAIL.DETAIL_NEXT.COMPOSER_CLOSE',
      CONVERSATION_HEADER_ONE: 'EXTERNAL_MAIL.DETAIL_NEXT.CONVERSATION_HEADER_ONE',
      CONVERSATION_HEADER_OTHER: 'EXTERNAL_MAIL.DETAIL_NEXT.CONVERSATION_HEADER_OTHER',
      EXPAND_ALL: 'EXTERNAL_MAIL.DETAIL_NEXT.EXPAND_ALL',
      HEADERS_LABEL: 'EXTERNAL_MAIL.DETAIL_NEXT.HEADERS_LABEL',
      KBD_HINT_NEXT_UNPROCESSED: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_NEXT_UNPROCESSED',
      KBD_HINT_PRESS: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_PRESS',
      KBD_HINT_PREV_UNPROCESSED: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_PREV_UNPROCESSED',
      KBD_HINT_TO_ASSIGN: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_ASSIGN',
      KBD_HINT_TO_MARK_PROCESSED: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_MARK_PROCESSED',
      KBD_HINT_TO_REPLY: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_REPLY',
      KBD_HINT_TO_UNMARK_PROCESSED: 'EXTERNAL_MAIL.DETAIL_NEXT.KBD_HINT_TO_UNMARK_PROCESSED',
      NAV_NEXT_ARIA: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_NEXT_ARIA',
      NAV_NEXT_TOOLTIP: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_NEXT_TOOLTIP',
      NAV_POSITION: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_POSITION',
      NAV_PREV_ARIA: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_PREV_ARIA',
      NAV_PREV_TOOLTIP: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_PREV_TOOLTIP',
      NAV_TOTAL: 'EXTERNAL_MAIL.DETAIL_NEXT.NAV_TOTAL',
      REMOVE_CATEGORY: 'EXTERNAL_MAIL.DETAIL_NEXT.REMOVE_CATEGORY',
      SAVE_AS_DRAFT: 'EXTERNAL_MAIL.DETAIL_NEXT.SAVE_AS_DRAFT',
      SAVED_AS_DRAFT: 'EXTERNAL_MAIL.DETAIL_NEXT.SAVED_AS_DRAFT',
    },
  },
  FAILED_ACTIONS: 'FAILED_ACTIONS',
  FAILED_REMINDERS: {
    ACTION_IGNORE: 'FAILED_REMINDERS.ACTION_IGNORE',
    ACTION_RESEND: 'FAILED_REMINDERS.ACTION_RESEND',
    EMPTY_INDEX: 'FAILED_REMINDERS.EMPTY_INDEX',
    MENU_LABEL: 'FAILED_REMINDERS.MENU_LABEL',
    MODALS: {
      CANCEL: 'FAILED_REMINDERS.MODALS.CANCEL',
      CONTINUE: 'FAILED_REMINDERS.MODALS.CONTINUE',
      IGNORE: {
        DESCRIPTION: 'FAILED_REMINDERS.MODALS.IGNORE.DESCRIPTION',
        TITLE: 'FAILED_REMINDERS.MODALS.IGNORE.TITLE',
      },
      IGNORE_REMINDER: 'FAILED_REMINDERS.MODALS.IGNORE_REMINDER',
      PREVIEW: {
        DESCRIPTION: 'FAILED_REMINDERS.MODALS.PREVIEW.DESCRIPTION',
        TITLE: 'FAILED_REMINDERS.MODALS.PREVIEW.TITLE',
      },
      RESEND: {
        DEBTOR_CONTACT_PERSON_LABEL: 'FAILED_REMINDERS.MODALS.RESEND.DEBTOR_CONTACT_PERSON_LABEL',
        DEBTOR_CONTACT_PERSON_PLACEHOLDER:
          'FAILED_REMINDERS.MODALS.RESEND.DEBTOR_CONTACT_PERSON_PLACEHOLDER',
        DEBTOR_EMAIL_LABEL: 'FAILED_REMINDERS.MODALS.RESEND.DEBTOR_EMAIL_LABEL',
        DEBTOR_EMAIL_PLACEHOLDER: 'FAILED_REMINDERS.MODALS.RESEND.DEBTOR_EMAIL_PLACEHOLDER',
        DESCRIPTION: 'FAILED_REMINDERS.MODALS.RESEND.DESCRIPTION',
        EXTERNAL_EMAIL_LABEL: 'FAILED_REMINDERS.MODALS.RESEND.EXTERNAL_EMAIL_LABEL',
        EXTERNAL_EMAIL_PLACEHOLDER: 'FAILED_REMINDERS.MODALS.RESEND.EXTERNAL_EMAIL_PLACEHOLDER',
        SUBMIT_HINT: 'FAILED_REMINDERS.MODALS.RESEND.SUBMIT_HINT',
        TITLE: 'FAILED_REMINDERS.MODALS.RESEND.TITLE',
      },
    },
    STATUS: {
      AUTOMATICALLY_IGNORE: 'FAILED_REMINDERS.STATUS.AUTOMATICALLY_IGNORE',
      AUTOMATICALLY_RESENT: 'FAILED_REMINDERS.STATUS.AUTOMATICALLY_RESENT',
      BUTTON_SEE_ORIGINAL: 'FAILED_REMINDERS.STATUS.BUTTON_SEE_ORIGINAL',
      BUTTON_SEE_REMINDER: 'FAILED_REMINDERS.STATUS.BUTTON_SEE_REMINDER',
      FAILED: 'FAILED_REMINDERS.STATUS.FAILED',
      IGNORED: 'FAILED_REMINDERS.STATUS.IGNORED',
      IGNORE_PAID: 'FAILED_REMINDERS.STATUS.IGNORE_PAID',
      MANUALLY_IGNORE: 'FAILED_REMINDERS.STATUS.MANUALLY_IGNORE',
      MANUALLY_RESENT: 'FAILED_REMINDERS.STATUS.MANUALLY_RESENT',
      ORIGINAL_REMINDER: 'FAILED_REMINDERS.STATUS.ORIGINAL_REMINDER',
      RESENT: 'FAILED_REMINDERS.STATUS.RESENT',
      RESENT_FAILED: 'FAILED_REMINDERS.STATUS.RESENT_FAILED',
    },
  },
  FEEDBACK: {
    BUTTON: 'FEEDBACK.BUTTON',
    PLACEHOLDER: 'FEEDBACK.PLACEHOLDER',
  },
  FILE_LIMIT_EXCEEDED: 'FILE_LIMIT_EXCEEDED',
  FILE_NUMBER: 'FILE_NUMBER',
  FILL: 'FILL',
  FILTER: 'FILTER',
  FILTERS: 'FILTERS',
  FINANCIAL_DATA: 'FINANCIAL_DATA',
  FIX_FEE_AMOUNT: 'FIX_FEE_AMOUNT',
  FN_TEMPLATE: 'FN_TEMPLATE',
  FOLLOW_UP: {
    INVOICE_TO_PROCESS: {
      AGENT_CALL_DEBTOR: 'FOLLOW_UP.INVOICE_TO_PROCESS.AGENT_CALL_DEBTOR',
      FORMAL_NOTICE_SEND_BY_MAIL: 'FOLLOW_UP.INVOICE_TO_PROCESS.FORMAL_NOTICE_SEND_BY_MAIL',
      LEGAL_CITY: {
        RECOVERY_SERVICE_OBJECT: 'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.RECOVERY_SERVICE_OBJECT',
        RECOVERY_SERVICE_OBJECT_PLACEHOLDER:
          'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.RECOVERY_SERVICE_OBJECT_PLACEHOLDER',
        DEBTOR_LEGALREP_FIRST_NAME:
          'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.DEBTOR_LEGALREP_FIRST_NAME',
        DEBTOR_LEGALREP_FIRST_NAME_PLACEHOLDER:
          'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.DEBTOR_LEGALREP_FIRST_NAME_PLACEHOLDER',
        DEBTOR_LEGALREP_LAST_NAME:
          'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.DEBTOR_LEGALREP_LAST_NAME',
        DEBTOR_LEGALREP_LAST_NAME_PLACEHOLDER:
          'FOLLOW_UP.INVOICE_TO_PROCESS.LEGAL_CITY.DEBTOR_LEGALREP_LAST_NAME_PLACEHOLDER',
      },
      GCOLLECT: {
        ACCEPT: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.ACCEPT',
        APE_CODE: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.APE_CODE',
        APE_CODE_FORMAT: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.APE_CODE_FORMAT',
        COLLECTION_AMOUNT: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.COLLECTION_AMOUNT',
        COLLECTION_PERCENTAGE: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.COLLECTION_PERCENTAGE',
        CONFIRM_RATES: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.CONFIRM_RATES',
        INVOICE_AMOUNT: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.INVOICE_AMOUNT',
        SIREN: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.SIREN',
        SIREN_LENGTH_ERROR: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.SIREN_LENGTH_ERROR',
        VALIDATE_FEES_ERRORS: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.VALIDATE_FEES_ERRORS',
        VALIDATE_FEES_TEXT: 'FOLLOW_UP.INVOICE_TO_PROCESS.GCOLLECT.VALIDATE_FEES_TEXT',
      },
      LAWYER_SEND_MAIL_TO_DEBTOR: 'FOLLOW_UP.INVOICE_TO_PROCESS.LAWYER_SEND_MAIL_TO_DEBTOR',
      NO_INVOICE_WITH_DELAY: 'FOLLOW_UP.INVOICE_TO_PROCESS.NO_INVOICE_WITH_DELAY',
      NO_MORE_AUTOMATIC_ACTIONS: 'FOLLOW_UP.INVOICE_TO_PROCESS.NO_MORE_AUTOMATIC_ACTIONS',
      SEND_FORMAL_NOTICE: 'FOLLOW_UP.INVOICE_TO_PROCESS.SEND_FORMAL_NOTICE',
      SEND_REMINDER: 'FOLLOW_UP.INVOICE_TO_PROCESS.SEND_REMINDER',
      SEND_TO_LAWYER: 'FOLLOW_UP.INVOICE_TO_PROCESS.SEND_TO_LAWYER',
      SEND_TO_THIRD_PARTY: 'FOLLOW_UP.INVOICE_TO_PROCESS.SEND_TO_THIRD_PARTY',
      START_BAILIFF: 'FOLLOW_UP.INVOICE_TO_PROCESS.START_BAILIFF',
      START_BAILIFF_CASE: 'FOLLOW_UP.INVOICE_TO_PROCESS.START_BAILIFF_CASE',
      TAKE_OUT_OF_PROCESS: 'FOLLOW_UP.INVOICE_TO_PROCESS.TAKE_OUT_OF_PROCESS',
      THIRD_PARTIES: 'FOLLOW_UP.INVOICE_TO_PROCESS.THIRD_PARTIES',
    },
    SUMMARY: {
      COLLECTION_STEP: {
        '0': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.0',
        '1': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.1',
        '2': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.2',
        '3': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.3',
        '4': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.4',
        '5': 'FOLLOW_UP.SUMMARY.COLLECTION_STEP.5',
      },
      CONFLICT: 'FOLLOW_UP.SUMMARY.CONFLICT',
      DELAY_J: 'FOLLOW_UP.SUMMARY.DELAY_J',
      GREAT_NO_INVOICE: 'FOLLOW_UP.SUMMARY.GREAT_NO_INVOICE',
      TITLE: 'FOLLOW_UP.SUMMARY.TITLE',
    },
  },
  FORM: {
    ACTIONS: 'FORM.ACTIONS',
    ADDITIONAL_REMINDER: {
      CONFIRM_SENDING_OPTIONS: 'FORM.ADDITIONAL_REMINDER.CONFIRM_SENDING_OPTIONS',
      SUMMARY: 'FORM.ADDITIONAL_REMINDER.SUMMARY',
    },
    ADDRESS: {
      ADD: 'FORM.ADDRESS.ADD',
      BOX: 'FORM.ADDRESS.BOX',
      CITY: 'FORM.ADDRESS.CITY',
      COUNTRY: 'FORM.ADDRESS.COUNTRY',
      POSTAL_CODE: 'FORM.ADDRESS.POSTAL_CODE',
      STREET: 'FORM.ADDRESS.STREET',
    },
    ADD_COMMENT: 'FORM.ADD_COMMENT',
    ADD_END_DATE: 'FORM.ADD_END_DATE',
    ADD_NOTE: 'FORM.ADD_NOTE',
    AUTOMATIC_ASSIGNATION: {
      EDIT: 'FORM.AUTOMATIC_ASSIGNATION.EDIT',
      NEW: 'FORM.AUTOMATIC_ASSIGNATION.NEW',
    },
    CATEGORY: 'FORM.CATEGORY',
    CHOICE: 'FORM.CHOICE',
    CHOOSE_DATE: 'FORM.CHOOSE_DATE',
    CHOOSE_FILE: 'FORM.CHOOSE_FILE',
    CHOOSE_INVOICES: {
      ADD_FEES: 'FORM.CHOOSE_INVOICES.ADD_FEES',
      AMOUNT_CLAIMED: 'FORM.CHOOSE_INVOICES.AMOUNT_CLAIMED',
      BAILIFF_DESCRIPTION: 'FORM.CHOOSE_INVOICES.BAILIFF_DESCRIPTION',
      BAILIFF_TITLE: 'FORM.CHOOSE_INVOICES.BAILIFF_TITLE',
      DELETE_FEES: 'FORM.CHOOSE_INVOICES.DELETE_FEES',
      DESCRIPTION: 'FORM.CHOOSE_INVOICES.DESCRIPTION',
      LATE_FEES: 'FORM.CHOOSE_INVOICES.LATE_FEES',
      LATE_FEE_DISCLAIMER: 'FORM.CHOOSE_INVOICES.LATE_FEE_DISCLAIMER',
      MAIN_INVOICE: 'FORM.CHOOSE_INVOICES.MAIN_INVOICE',
      NO_LATE_FEE_CLAIMED: 'FORM.CHOOSE_INVOICES.NO_LATE_FEE_CLAIMED',
      REMAINING_AMOUNT: 'FORM.CHOOSE_INVOICES.REMAINING_AMOUNT',
      TITLE: 'FORM.CHOOSE_INVOICES.TITLE',
      UPDATE_FEES: 'FORM.CHOOSE_INVOICES.UPDATE_FEES',
    },
    CHOOSE_MEDIA: 'FORM.CHOOSE_MEDIA',
    CHOOSE_THIRD_PARTY_TYPE: {
      DESCRIPTION: 'FORM.CHOOSE_THIRD_PARTY_TYPE.DESCRIPTION',
      TITLE: 'FORM.CHOOSE_THIRD_PARTY_TYPE.TITLE',
    },
    CLIENT: {
      ADD_BANK_ACCOUNT: 'FORM.CLIENT.ADD_BANK_ACCOUNT',
      ADD_EMAIL: 'FORM.CLIENT.ADD_EMAIL',
      ADD_PHONE: 'FORM.CLIENT.ADD_PHONE',
      COCONTRACTOR_VAT0: 'FORM.CLIENT.COCONTRACTOR_VAT0',
      CONTACT_LANG: 'FORM.CLIENT.CONTACT_LANG',
      CREATED: 'FORM.CLIENT.CREATED',
      CURRENCY: 'FORM.CLIENT.CURRENCY',
      CUSTOM_VARIABLES_UPDATED: 'FORM.CLIENT.CUSTOM_VARIABLES_UPDATED',
      EDIT_ALL_INVOICES_ADDRESS: 'FORM.CLIENT.EDIT_ALL_INVOICES_ADDRESS',
      EDIT_ALL_INVOICES_EMAIL: 'FORM.CLIENT.EDIT_ALL_INVOICES_EMAIL',
      EDIT_ALL_INVOICES_SENDING_MEDIUM: 'FORM.CLIENT.EDIT_ALL_INVOICES_SENDING_MEDIUM',
      EDIT_RECORD: 'FORM.CLIENT.EDIT_RECORD',
      EDIT_SENDING_OPTIONS: 'FORM.CLIENT.EDIT_SENDING_OPTIONS',
      EDIT_SENDING_OPTIONS_SUMMARY: 'FORM.CLIENT.EDIT_SENDING_OPTIONS_SUMMARY',
      FULL_NAME: 'FORM.CLIENT.FULL_NAME',
      INFO_UPDATED: 'FORM.CLIENT.INFO_UPDATED',
      INTRA_COMMUNITY_VAT0: 'FORM.CLIENT.INTRA_COMMUNITY_VAT0',
      LEGAL_ENTITY: 'FORM.CLIENT.LEGAL_ENTITY',
      PLACEHOLDER: {
        ADDITIONAL_LINE_1: 'FORM.CLIENT.PLACEHOLDER.ADDITIONAL_LINE_1',
        ADDITIONAL_LINE_2: 'FORM.CLIENT.PLACEHOLDER.ADDITIONAL_LINE_2',
        BIC: 'FORM.CLIENT.PLACEHOLDER.BIC',
        CITY: 'FORM.CLIENT.PLACEHOLDER.CITY',
        COUNTRY: 'FORM.CLIENT.PLACEHOLDER.COUNTRY',
        CURRENCY: 'FORM.CLIENT.PLACEHOLDER.CURRENCY',
        CUSTOM_VARIABLE_NUMBER: 'FORM.CLIENT.PLACEHOLDER.CUSTOM_VARIABLE_NUMBER',
        CUSTOM_VARIABLE_TEXT: 'FORM.CLIENT.PLACEHOLDER.CUSTOM_VARIABLE_TEXT',
        EMAIL: 'FORM.CLIENT.PLACEHOLDER.EMAIL',
        ENTER_VALUE: 'FORM.CLIENT.PLACEHOLDER.ENTER_VALUE',
        FULL_NAME: 'FORM.CLIENT.PLACEHOLDER.FULL_NAME',
        IBAN: 'FORM.CLIENT.PLACEHOLDER.IBAN',
        JOB_TITLE: 'FORM.CLIENT.PLACEHOLDER.JOB_TITLE',
        LOCALE: 'FORM.CLIENT.PLACEHOLDER.LOCALE',
        PHONE: 'FORM.CLIENT.PLACEHOLDER.PHONE',
        POSTAL_CODE: 'FORM.CLIENT.PLACEHOLDER.POSTAL_CODE',
        REFERENCE: 'FORM.CLIENT.PLACEHOLDER.REFERENCE',
        STREET: 'FORM.CLIENT.PLACEHOLDER.STREET',
        STREET_BOX: 'FORM.CLIENT.PLACEHOLDER.STREET_BOX',
        STREET_NUMBER: 'FORM.CLIENT.PLACEHOLDER.STREET_NUMBER',
        VAT_NUMBER: 'FORM.CLIENT.PLACEHOLDER.VAT_NUMBER',
      },
      PREFILL_VAT: 'FORM.CLIENT.PREFILL_VAT',
      PRE_FILL: 'FORM.CLIENT.PRE_FILL',
      SELECT_RADIO_BUTTON: 'FORM.CLIENT.SELECT_RADIO_BUTTON',
      VAT_TOOLTIP: 'FORM.CLIENT.VAT_TOOLTIP',
    },
    CLIENT_IMPORT: {
      CSV_FILE_FORMAT: 'FORM.CLIENT_IMPORT.CSV_FILE_FORMAT',
      IMPORT_CLIENTS_LIST: 'FORM.CLIENT_IMPORT.IMPORT_CLIENTS_LIST',
      TITLE: 'FORM.CLIENT_IMPORT.TITLE',
    },
    COMPANY: {
      CURRENCY: 'FORM.COMPANY.CURRENCY',
      CURRENCY_CONVERSION_DATE: 'FORM.COMPANY.CURRENCY_CONVERSION_DATE',
      DEFAULT_ACCOUNT: 'FORM.COMPANY.DEFAULT_ACCOUNT',
      LANG: 'FORM.COMPANY.LANG',
      LEGAL_NAME: 'FORM.COMPANY.LEGAL_NAME',
    },
    CONFIRM_BAILIFF: {
      AYS_SEND_CONTESTED_INVOICE: 'FORM.CONFIRM_BAILIFF.AYS_SEND_CONTESTED_INVOICE',
      BAILIFF_CHOICE: 'FORM.CONFIRM_BAILIFF.BAILIFF_CHOICE',
      CHECK_INCONTESTED: 'FORM.CONFIRM_BAILIFF.CHECK_INCONTESTED',
      DESCRIPTION: 'FORM.CONFIRM_BAILIFF.DESCRIPTION',
      INVOICE_UNCONTESTABLE: 'FORM.CONFIRM_BAILIFF.INVOICE_UNCONTESTABLE',
      IS_INVOICE_CONTESTABLE: 'FORM.CONFIRM_BAILIFF.IS_INVOICE_CONTESTABLE',
      MODERO: 'FORM.CONFIRM_BAILIFF.MODERO',
      READ_AND_APPROVE: 'FORM.CONFIRM_BAILIFF.READ_AND_APPROVE',
    },
    CONFIRM_LEGALCITY: {
      PRICING_INFO: 'FORM.CONFIRM_LEGALCITY.PRICING_INFO',
      READ_AND_APPROVE: 'FORM.CONFIRM_LEGALCITY.READ_AND_APPROVE',
    },
    CONFIRM_EMAIL: 'FORM.CONFIRM_EMAIL',
    CONFIRM_PASSWORD: 'FORM.CONFIRM_PASSWORD',
    CONFIRM_VALUE: 'FORM.CONFIRM_VALUE',
    CUSTOM_VARIABLES: {
      CREATED: 'FORM.CUSTOM_VARIABLES.CREATED',
      TITLE: {
        EDIT: 'FORM.CUSTOM_VARIABLES.TITLE.EDIT',
        NEW: 'FORM.CUSTOM_VARIABLES.TITLE.NEW',
      },
    },
    DATEPICKER_RANGE: 'FORM.DATEPICKER_RANGE',
    DAY_OF_DELAY: 'FORM.DAY_OF_DELAY',
    DBASICS: {
      IRREVERSIBLE_ACTION: 'FORM.DBASICS.IRREVERSIBLE_ACTION',
      SELECT_COMPANY: 'FORM.DBASICS.SELECT_COMPANY',
      SUMMARY: 'FORM.DBASICS.SUMMARY',
    },
    DEBT_COLLECTOR_TITLE: 'FORM.DEBT_COLLECTOR_TITLE',
    DELETE_FILTERS: 'FORM.DELETE_FILTERS',
    DESELECT_ALL: 'FORM.DESELECT_ALL',
    EDIT_STAFF: {
      TITLE: 'FORM.EDIT_STAFF.TITLE',
    },
    END_DATE: 'FORM.END_DATE',
    ENTER_NAME: 'FORM.ENTER_NAME',
    EXACT: {
      IRREVERSIBLE_ACTION: 'FORM.EXACT.IRREVERSIBLE_ACTION',
      SELECT_COMPANY: 'FORM.EXACT.SELECT_COMPANY',
      SUMMARY: 'FORM.EXACT.SUMMARY',
    },
    EXPORT_RECOVR_PAYMENTS: 'FORM.EXPORT_RECOVR_PAYMENTS',
    FILE_FORMAT_PDF: 'FORM.FILE_FORMAT_PDF',
    FIRSTNAME: 'FORM.FIRSTNAME',
    FORMAL_NOTICE: {
      CAN_EDIT: 'FORM.FORMAL_NOTICE.CAN_EDIT',
      CONFIRM: 'FORM.FORMAL_NOTICE.CONFIRM',
      EMAIL_TO_SEND: 'FORM.FORMAL_NOTICE.EMAIL_TO_SEND',
      SEND_BY_MAIL_TOO: 'FORM.FORMAL_NOTICE.SEND_BY_MAIL_TOO',
      SHIPPING_ADDRESS: 'FORM.FORMAL_NOTICE.SHIPPING_ADDRESS',
      SIGNATORY_NAME: 'FORM.FORMAL_NOTICE.SIGNATORY_NAME',
    },
    FROM: 'FORM.FROM',
    GENERAL_CONDITIONS_OF_USE: 'FORM.GENERAL_CONDITIONS_OF_USE',
    HISTORY: {
      PARTIALLY_MATCHED_WITH: 'FORM.HISTORY.PARTIALLY_MATCHED_WITH',
      PAYMENT_HISTORY: 'FORM.HISTORY.PAYMENT_HISTORY',
      PAYMENT_NO_RECONCILE: 'FORM.HISTORY.PAYMENT_NO_RECONCILE',
      RECONCILE_WITH: 'FORM.HISTORY.RECONCILE_WITH',
      SENDER: 'FORM.HISTORY.SENDER',
      TRANSACTION_NUMBER: 'FORM.HISTORY.TRANSACTION_NUMBER',
    },
    HORUS: {
      IRREVERSIBLE_ACTION: 'FORM.HORUS.IRREVERSIBLE_ACTION',
      SELECT_COMPANY: 'FORM.HORUS.SELECT_COMPANY',
      SUMMARY: 'FORM.HORUS.SUMMARY',
    },
    IMPORT_CLIENT_CONDITIONS: 'FORM.IMPORT_CLIENT_CONDITIONS',
    INTEGRATION: {
      AUTOMATIC_SYNC: 'FORM.INTEGRATION.AUTOMATIC_SYNC',
      AYS_TO_CHANGE_DATE: 'FORM.INTEGRATION.AYS_TO_CHANGE_DATE',
      CONNECT_ACCOUNT: 'FORM.INTEGRATION.CONNECT_ACCOUNT',
      EXPORT: 'FORM.INTEGRATION.EXPORT',
      IMPORT: 'FORM.INTEGRATION.IMPORT',
      INVOICE_ISSUE_DATE_TO_IMPORT: 'FORM.INTEGRATION.INVOICE_ISSUE_DATE_TO_IMPORT',
      LAST_IMPORT_THE: 'FORM.INTEGRATION.LAST_IMPORT_THE',
      MANUAL_SYNC_DESCRIPTION: 'FORM.INTEGRATION.MANUAL_SYNC_DESCRIPTION',
      NEXT_IMPORT_THE: 'FORM.INTEGRATION.NEXT_IMPORT_THE',
      PRIORITIZE_INTEGRATION: 'FORM.INTEGRATION.PRIORITIZE_INTEGRATION',
      PRIORITIZE_RECOVR: 'FORM.INTEGRATION.PRIORITIZE_RECOVR',
      RESET_ACCOUNTING_INTEGRATION: 'FORM.INTEGRATION.RESET_ACCOUNTING_INTEGRATION',
    },
    INTEREST_RATE: 'FORM.INTEREST_RATE',
    INVITE_STAFF: {
      RESEND_INVITATION: 'FORM.INVITE_STAFF.RESEND_INVITATION',
      TITLE: 'FORM.INVITE_STAFF.TITLE',
    },
    INVOICE_REFERENCE: 'FORM.INVOICE_REFERENCE',
    INVOICING: {
      ADD_EMAIL: 'FORM.INVOICING.ADD_EMAIL',
      ADD_LOG: 'FORM.INVOICING.ADD_LOG',
      ADD_NEW_BOOK: 'FORM.INVOICING.ADD_NEW_BOOK',
      LOG_NOT_DELETABLE: 'FORM.INVOICING.LOG_NOT_DELETABLE',
      AUTO: 'FORM.INVOICING.AUTO',
      BLACK: 'FORM.INVOICING.BLACK',
      CURRENT_COUNTER: 'FORM.INVOICING.CURRENT_COUNTER',
      CUSTOM_INVOICE: 'FORM.INVOICING.CUSTOM_INVOICE',
      FILE_FORMAT: 'FORM.INVOICING.FILE_FORMAT',
      FORCE_BALANCE_UPDATE: 'FORM.INVOICING.FORCE_BALANCE_UPDATE',
      IMPORT_LOGO: 'FORM.INVOICING.IMPORT_LOGO',
      INVOICING_BOOK: 'FORM.INVOICING.INVOICING_BOOK',
      NEXT_INVOICE: 'FORM.INVOICING.NEXT_INVOICE',
      NEXT_INVOICE_REFRENCE: 'FORM.INVOICING.NEXT_INVOICE_REFRENCE',
      NO_BILLING_LOG: 'FORM.INVOICING.NO_BILLING_LOG',
      PREFIX: 'FORM.INVOICING.PREFIX',
      PREVIEW: 'FORM.INVOICING.PREVIEW',
      STRUCTURED_COMMUNICATION: 'FORM.INVOICING.STRUCTURED_COMMUNICATION',
      VAT_COCONTRACTOR: 'FORM.INVOICING.VAT_COCONTRACTOR',
      VAT_INTRACOM: 'FORM.INVOICING.VAT_INTRACOM',
      WHITE: 'FORM.INVOICING.WHITE',
      YOUR_COLOR: 'FORM.INVOICING.YOUR_COLOR',
      YOUR_LOGO: 'FORM.INVOICING.YOUR_LOGO',
      YOUR_TEXT_COLOR: 'FORM.INVOICING.YOUR_TEXT_COLOR',
    },
    JOB_TITLE: 'FORM.JOB_TITLE',
    LASTNAME: 'FORM.LASTNAME',
    LAWYER_TITLE: 'FORM.LAWYER_TITLE',
    MAX: 'FORM.MAX',
    MIN: 'FORM.MIN',
    MIN_PENALTY_CLAUSE: 'FORM.MIN_PENALTY_CLAUSE',
    NEW_PASSWORD: 'FORM.NEW_PASSWORD',
    NOTIFICATIONS: 'FORM.NOTIFICATIONS',
    NUMBER: 'FORM.NUMBER',
    PAYMENT_DATE: 'FORM.PAYMENT_DATE',
    PAYMENT_DELAY: {
      AUTHORIZED_DELAY: 'FORM.PAYMENT_DELAY.AUTHORIZED_DELAY',
      IMPORT_CLIENT_CONDITIONS: 'FORM.PAYMENT_DELAY.IMPORT_CLIENT_CONDITIONS',
      INTEREST_RATE: 'FORM.PAYMENT_DELAY.INTEREST_RATE',
      READ_CONDITIONS_PDF: 'FORM.PAYMENT_DELAY.READ_CONDITIONS_PDF',
    },
    PAYMENT_PLAN: {
      ADD_PAYMENT_STEP: 'FORM.PAYMENT_PLAN.ADD_PAYMENT_STEP',
      EDIT: {
        TITLE: 'FORM.PAYMENT_PLAN.EDIT.TITLE',
        WARNING: 'FORM.PAYMENT_PLAN.EDIT.WARNING',
      },
      NEW: {
        TITLE: 'FORM.PAYMENT_PLAN.NEW.TITLE',
        WARNING: 'FORM.PAYMENT_PLAN.NEW.WARNING',
      },
      PROPERTIES: {
        ADDED_INVOICES: 'FORM.PAYMENT_PLAN.PROPERTIES.ADDED_INVOICES',
        NEW_BALANCE: 'FORM.PAYMENT_PLAN.PROPERTIES.NEW_BALANCE',
        OLD_BALANCE: 'FORM.PAYMENT_PLAN.PROPERTIES.OLD_BALANCE',
      },
      STEP_CALCULATION: {
        ADD_NEW_STEPS: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.ADD_NEW_STEPS',
        ADJUST_NEXT_AMOUNTS: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.ADJUST_NEXT_AMOUNTS',
        ADJUST_NEXT_DATES: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.ADJUST_NEXT_DATES',
        CALCULATE: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.CALCULATE',
        DEADLINE_AMOUNT: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.DEADLINE_AMOUNT',
        DEADLINE_COUNT: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.DEADLINE_COUNT',
        DELAY: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.DELAY',
        DUE_DATE: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.DUE_DATE',
        RECALCULATE: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.RECALCULATE',
        SPREAD_TO_EXISTING: 'FORM.PAYMENT_PLAN.STEP_CALCULATION.SPREAD_TO_EXISTING',
      },
      USED_WORKFLOW: 'FORM.PAYMENT_PLAN.USED_WORKFLOW',
    },
    PENALTY_CLAUSE: 'FORM.PENALTY_CLAUSE',
    PREFERENCES: {
      SENDING_PREFERENCES: {
        COPY_SECTION: 'FORM.PREFERENCES.SENDING_PREFERENCES.COPY_SECTION',
        RECIPIENTS_SECTION: 'FORM.PREFERENCES.SENDING_PREFERENCES.RECIPIENTS_SECTION',
        SEND_COPY: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_COPY',
        SEND_COPY_EMAILS: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_COPY_EMAILS',
        SEND_COPY_EMAILS_HINT: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_COPY_EMAILS_HINT',
        SEND_COPY_HINT: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_COPY_HINT',
        SEND_TO_ALL_EMAILS: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_TO_ALL_EMAILS',
        SEND_TO_ALL_EMAILS_HINT: 'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_TO_ALL_EMAILS_HINT',
        SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL:
          'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL',
        SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL_HINT:
          'FORM.PREFERENCES.SENDING_PREFERENCES.SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL_HINT',
        TITLE: 'FORM.PREFERENCES.SENDING_PREFERENCES.TITLE',
      },
      ALLOWED: 'FORM.PREFERENCES.ALLOWED',
      ALLOW_PAYMENT_PLANS: 'FORM.PREFERENCES.ALLOW_PAYMENT_PLANS',
      ALLOW_PAYMENT_PLANS_DEBTOR: 'FORM.PREFERENCES.ALLOW_PAYMENT_PLANS_DEBTOR',
      AMOUNT_EURO: 'FORM.PREFERENCES.AMOUNT_EURO',
      ANNUAL_INTEREST_RATE: 'FORM.PREFERENCES.ANNUAL_INTEREST_RATE',
      AUTOMATIC: 'FORM.PREFERENCES.AUTOMATIC',
      AYS_AUTOMATIC_REMINDER_MODE: 'FORM.PREFERENCES.AYS_AUTOMATIC_REMINDER_MODE',
      AYS_MANUAL_REMINDER_MODE: 'FORM.PREFERENCES.AYS_MANUAL_REMINDER_MODE',
      BALANCE_THRESHOLD: 'FORM.PREFERENCES.BALANCE_THRESHOLD',
      BALANCE_THRESHOLD_TYPE: 'FORM.PREFERENCES.BALANCE_THRESHOLD_TYPE',
      CLAIM_THE_ADDITIONAL_COSTS: 'FORM.PREFERENCES.CLAIM_THE_ADDITIONAL_COSTS',
      CLAUSE_TYPE: 'FORM.PREFERENCES.CLAUSE_TYPE',
      COLOR: 'FORM.PREFERENCES.COLOR',
      CREDIT_NOTE_TEMPLATE: 'FORM.PREFERENCES.CREDIT_NOTE_TEMPLATE',
      CUSTOM_RECOVERY: 'FORM.PREFERENCES.CUSTOM_RECOVERY',
      DAILY_SUMMARY: 'FORM.PREFERENCES.DAILY_SUMMARY',
      DAYS_AFTER_DEADLINE: 'FORM.PREFERENCES.DAYS_AFTER_DEADLINE',
      DAYS_BETWEEN_REMINDERS: 'FORM.PREFERENCES.DAYS_BETWEEN_REMINDERS',
      DAYS_BETWEEN_TWO_REMINDERS: 'FORM.PREFERENCES.DAYS_BETWEEN_TWO_REMINDERS',
      DAYS_SUFFIX: 'FORM.PREFERENCES.DAYS_SUFFIX',
      DEFAULT_PAYMENT_DELAY: 'FORM.PREFERENCES.DEFAULT_PAYMENT_DELAY',
      DEFAULT_PLACEHOLDER: 'FORM.PREFERENCES.DEFAULT_PLACEHOLDER',
      DONT_SEND_REMINDER_TO_DEBTOR_UNDER: 'FORM.PREFERENCES.DONT_SEND_REMINDER_TO_DEBTOR_UNDER',
      DONT_SEND_REMINDER_UNDER: 'FORM.PREFERENCES.DONT_SEND_REMINDER_UNDER',
      ENTER_VALUE_IN_CURRENCY: 'FORM.PREFERENCES.ENTER_VALUE_IN_CURRENCY',
      FIX_FEE: 'FORM.PREFERENCES.FIX_FEE',
      FORBIDDEN: 'FORM.PREFERENCES.FORBIDDEN',
      HOW_SEND_REMINDERS: 'FORM.PREFERENCES.HOW_SEND_REMINDERS',
      IMPORT_GENERAL_CONDITIONS: 'FORM.PREFERENCES.IMPORT_GENERAL_CONDITIONS',
      INTEREST: 'FORM.PREFERENCES.INTEREST',
      INVOICE_TEMPLATE: 'FORM.PREFERENCES.INVOICE_TEMPLATE',
      INVOICE_THRESHOLD: 'FORM.PREFERENCES.INVOICE_THRESHOLD',
      MANUAL: 'FORM.PREFERENCES.MANUAL',
      MARK_PAID_ON_NO_BALANCE: 'FORM.PREFERENCES.MARK_PAID_ON_NO_BALANCE',
      MARK_PAID_ON_NO_BALANCE_TOOLTIP: 'FORM.PREFERENCES.MARK_PAID_ON_NO_BALANCE_TOOLTIP',
      MINIMUM_BALANCE: 'FORM.PREFERENCES.MINIMUM_BALANCE',
      MIN_DAYS_BETWEEN_REMINDER: 'FORM.PREFERENCES.MIN_DAYS_BETWEEN_REMINDER',
      NEW_REACTION_DEBTOR: 'FORM.PREFERENCES.NEW_REACTION_DEBTOR',
      NEW_THIRD_PARTY_MESSAGE: 'FORM.PREFERENCES.NEW_THIRD_PARTY_MESSAGE',
      NEXT_WORKING_DAY: 'FORM.PREFERENCES.NEXT_WORKING_DAY',
      NEXT_WORKING_DAYS: 'FORM.PREFERENCES.NEXT_WORKING_DAYS',
      NOTIF_BY_EMAIL: 'FORM.PREFERENCES.NOTIF_BY_EMAIL',
      NOT_ALLOWED: 'FORM.PREFERENCES.NOT_ALLOWED',
      OVERDUE_BALANCE: 'FORM.PREFERENCES.OVERDUE_BALANCE',
      PAYMENT_PLAN_ACCESS: 'FORM.PREFERENCES.PAYMENT_PLAN_ACCESS',
      PENALTY_CLAUSE_MIN: 'FORM.PREFERENCES.PENALTY_CLAUSE_MIN',
      PENALTY_CLAUSE_VALUE: 'FORM.PREFERENCES.PENALTY_CLAUSE_VALUE',
      PERIODICITY: 'FORM.PREFERENCES.PERIODICITY',
      PREFERENCES_POSTAL_SEND: 'FORM.PREFERENCES.PREFERENCES_POSTAL_SEND',
      PREFERENCES_SEND: 'FORM.PREFERENCES.PREFERENCES_SEND',
      PRINTING: 'FORM.PREFERENCES.PRINTING',
      RANDOM_VALUE_ON_DEBTOR: 'FORM.PREFERENCES.RANDOM_VALUE_ON_DEBTOR',
      READ_CONDITIONS: 'FORM.PREFERENCES.READ_CONDITIONS',
      RECEIVE_COPY: 'FORM.PREFERENCES.RECEIVE_COPY',
      RECEIVE_ON: 'FORM.PREFERENCES.RECEIVE_ON',
      RECONCILIATION: 'FORM.PREFERENCES.RECONCILIATION',
      RECOVERY_SETTINGS: 'FORM.PREFERENCES.RECOVERY_SETTINGS',
      REMAINING_BALANCE: 'FORM.PREFERENCES.REMAINING_BALANCE',
      REMINDERS: 'FORM.PREFERENCES.REMINDERS',
      REMINDER_MANAGEMENT: 'FORM.PREFERENCES.REMINDER_MANAGEMENT',
      SEND_AUTOMATIC_REMINDERS: 'FORM.PREFERENCES.SEND_AUTOMATIC_REMINDERS',
      SEND_CONDITION_EACH_INVOICE: 'FORM.PREFERENCES.SEND_CONDITION_EACH_INVOICE',
      REMINDER_THRESHOLDS: 'FORM.PREFERENCES.REMINDER_THRESHOLDS',
      REMINDER_THRESHOLDS_DESCRIPTION: 'FORM.PREFERENCES.REMINDER_THRESHOLDS_DESCRIPTION',
      REMINDER_TIME_SLOT: 'FORM.PREFERENCES.REMINDER_TIME_SLOT',
      SEND_TO_ALL_EMAILS: 'FORM.PREFERENCES.SEND_TO_ALL_EMAILS',
      SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL:
        'FORM.PREFERENCES.SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL',
      SUCCESSFULL_CG_UPDATE: 'FORM.PREFERENCES.SUCCESSFULL_CG_UPDATE',
      SUCCESSFULL_LOGO_UPDATE: 'FORM.PREFERENCES.SUCCESSFULL_LOGO_UPDATE',
      TASKS: {
        AUTO_UPDATE_LABEL: 'FORM.PREFERENCES.TASKS.AUTO_UPDATE_LABEL',
        AUTO_UPDATE_HINT: 'FORM.PREFERENCES.TASKS.AUTO_UPDATE_HINT',
        SUCCESSFULLY_UPDATE: 'FORM.PREFERENCES.TASKS.SUCCESSFULLY_UPDATE',
        TITLE: 'FORM.PREFERENCES.TASKS.TITLE',
      },
      THRESHOLD: 'FORM.PREFERENCES.THRESHOLD',
      TOOLTIP: {
        ALLOW_PAYMENT_PLANS: 'FORM.PREFERENCES.TOOLTIP.ALLOW_PAYMENT_PLANS',
        CLAIM_THE_ADDITIONAL_COSTS: 'FORM.PREFERENCES.TOOLTIP.CLAIM_THE_ADDITIONAL_COSTS',
        DONT_SEND_REMINDER_UNDER: 'FORM.PREFERENCES.TOOLTIP.DONT_SEND_REMINDER_UNDER',
        HOW_SEND_REMINDERS: 'FORM.PREFERENCES.TOOLTIP.HOW_SEND_REMINDERS',
        ONLY_ADMIN_CAN_CHANGE_ACCOUNT_MANAGER:
          'FORM.PREFERENCES.TOOLTIP.ONLY_ADMIN_CAN_CHANGE_ACCOUNT_MANAGER',
        RECEIVE_COPY: 'FORM.PREFERENCES.TOOLTIP.RECEIVE_COPY',
        SEND_CONDITION_EACH_INVOICE: 'FORM.PREFERENCES.TOOLTIP.SEND_CONDITION_EACH_INVOICE',
        SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL:
          'FORM.PREFERENCES.TOOLTIP.SEND_TO_CONTACT_PERSON_AND_DEBTOR_EMAIL',
      },
      WEEKLY_SUMMARY: 'FORM.PREFERENCES.WEEKLY_SUMMARY',
      HINT: {
        ALLOW_PAYMENT_PLANS: 'FORM.PREFERENCES.HINT.ALLOW_PAYMENT_PLANS',
      },
      PRINT_COLORS: {
        BW: 'FORM.PREFERENCES.PRINT_COLORS.BW',
        COLOR: 'FORM.PREFERENCES.PRINT_COLORS.COLOR',
      },
      PRINT_MODES: {
        ONE_SIDE: 'FORM.PREFERENCES.PRINT_MODES.ONE_SIDE',
        TWO_SIDE: 'FORM.PREFERENCES.PRINT_MODES.TWO_SIDE',
      },
      COMMUNICATION_LANGUAGES: {
        CLIENTS_COUNT: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.CLIENTS_COUNT',
        CONFIRM_BODY: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.CONFIRM_BODY',
        CONFIRM_TITLE: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.CONFIRM_TITLE',
        CONTACT_PERSONS_COUNT: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.CONTACT_PERSONS_COUNT',
        DEFAULT_HINT: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.DEFAULT_HINT',
        DESCRIPTION: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.DESCRIPTION',
        ENABLED_HINT: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.ENABLED_HINT',
        TITLE: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.TITLE',
        USED_BY: 'FORM.PREFERENCES.COMMUNICATION_LANGUAGES.USED_BY',
      },
    },
    PRODUCT: {
      EDIT: 'FORM.PRODUCT.EDIT',
      NAME: 'FORM.PRODUCT.NAME',
      PLACEHOLDER: {
        NAME: 'FORM.PRODUCT.PLACEHOLDER.NAME',
        DESCRIPTION: 'FORM.PRODUCT.PLACEHOLDER.DESCRIPTION',
        PRICE: 'FORM.PRODUCT.PLACEHOLDER.PRICE',
        VAT_RATE: 'FORM.PRODUCT.PLACEHOLDER.VAT_RATE',
      },
      NOTIFICATIONS: {
        SAVED_SUCCESSFULL: 'FORM.PRODUCT.NOTIFICATIONS.SAVED_SUCCESSFULL',
        UPDATE_SUCCESSFULL: 'FORM.PRODUCT.NOTIFICATIONS.UPDATE_SUCCESSFULL',
      },
    },
    QUICK_SEARCH: {
      PLACEHOLDER: 'FORM.QUICK_SEARCH.PLACEHOLDER',
      TOOLTIP: {
        DEBTOR: 'FORM.QUICK_SEARCH.TOOLTIP.DEBTOR',
        INVOICE: 'FORM.QUICK_SEARCH.TOOLTIP.INVOICE',
        TASK: 'FORM.QUICK_SEARCH.TOOLTIP.TASK',
      },
    },
    QUIT_WITHOUT_SAVING: 'FORM.QUIT_WITHOUT_SAVING',
    READ_CONDITIONS_PDF: 'FORM.READ_CONDITIONS_PDF',
    REASON: 'FORM.REASON',
    RECOVER_STEP: {
      TYPE: {
        AI_CALL: 'FORM.RECOVER_STEP.TYPE.AI_CALL',
        CREATE_TASK: 'FORM.RECOVER_STEP.TYPE.CREATE_TASK',
        SEND_REMINDER: 'FORM.RECOVER_STEP.TYPE.SEND_REMINDER',
      },
      TYPE_LABEL: 'FORM.RECOVER_STEP.TYPE_LABEL',
    },
    AI_CALL: {
      FOLLOW_UP: 'FORM.AI_CALL.FOLLOW_UP',
    },
    REFERENCE: 'FORM.REFERENCE',
    RESEARCH: 'FORM.RESEARCH',
    SAVE_AND_QUIT: 'FORM.SAVE_AND_QUIT',
    SEARCH: 'FORM.SEARCH',
    SELECT_ALL: 'FORM.SELECT_ALL',
    SELECT_AT_LEAST_ONE: 'FORM.SELECT_AT_LEAST_ONE',
    SELECT_DATE: 'FORM.SELECT_DATE',
    SELECT_REASON: 'FORM.SELECT_REASON',
    SELECT_TYPE: 'FORM.SELECT_TYPE',
    SEND_INVOICE: {
      CAN_VALID_WITHOUT_SEND: 'FORM.SEND_INVOICE.CAN_VALID_WITHOUT_SEND',
      DESCRIPTION: 'FORM.SEND_INVOICE.DESCRIPTION',
      FORCE_SENDING_MEDIUM: 'FORM.SEND_INVOICE.FORCE_SENDING_MEDIUM',
      FRONT_OR_BACK: 'FORM.SEND_INVOICE.FRONT_OR_BACK',
      SELECT_SEND_METHOD: 'FORM.SEND_INVOICE.SELECT_SEND_METHOD',
      SENDING_MEDIUM_REQUIRED: 'FORM.SEND_INVOICE.SENDING_MEDIUM_REQUIRED',
      SEND_ADDITIONAL_FILE: 'FORM.SEND_INVOICE.SEND_ADDITIONAL_FILE',
      SEND_ADDITIONAL_FILES: 'FORM.SEND_INVOICE.SEND_ADDITIONAL_FILES',
      SEND_BY_EMAIL: 'FORM.SEND_INVOICE.SEND_BY_EMAIL',
      SEND_BY_MAIL: 'FORM.SEND_INVOICE.SEND_BY_MAIL',
      SEND_REMINDERS: 'FORM.SEND_INVOICE.SEND_REMINDERS',
      TITLE: 'FORM.SEND_INVOICE.TITLE',
      VALID_WITHOUT_SEND: 'FORM.SEND_INVOICE.VALID_WITHOUT_SEND',
    },
    SIDE_MENU: {
      LOST_INFO: 'FORM.SIDE_MENU.LOST_INFO',
    },
    SIGNUP: {
      CONFIRM_PASSWORD: 'FORM.SIGNUP.CONFIRM_PASSWORD',
    },
    START_DATE: 'FORM.START_DATE',
    STRIPE: {
      ADD_PAYMENT_METHOD: 'FORM.STRIPE.ADD_PAYMENT_METHOD',
      CARD_NUMBER: 'FORM.STRIPE.CARD_NUMBER',
      CVC: 'FORM.STRIPE.CVC',
      EXPIRATION: 'FORM.STRIPE.EXPIRATION',
      FULL_NAME: 'FORM.STRIPE.FULL_NAME',
    },
    SUCCESSFULLY_CONNEXION: 'FORM.SUCCESSFULLY_CONNEXION',
    TASK: {
      EDIT: 'FORM.TASK.EDIT',
      GROUP_SAME_DEBTOR: 'FORM.TASK.GROUP_SAME_DEBTOR',
      NEW: 'FORM.TASK.NEW',
    },
    TEAMLEADER: {
      DESCRIPTION: 'FORM.TEAMLEADER.DESCRIPTION',
      SUMMARY: 'FORM.TEAMLEADER.SUMMARY',
    },
    THIRD_PARTY_CASES_FILTERS: {
      UNREAD_MESSAGES: 'FORM.THIRD_PARTY_CASES_FILTERS.UNREAD_MESSAGES',
    },
    TO: 'FORM.TO',
    TYPE: 'FORM.TYPE',
    UNTREATED: 'FORM.UNTREATED',
    USER_SETTINGS: {
      INTERFACE_LANG: 'FORM.USER_SETTINGS.INTERFACE_LANG',
      NEW_PASSWORD: 'FORM.USER_SETTINGS.NEW_PASSWORD',
      OLD_PASSWORD: 'FORM.USER_SETTINGS.OLD_PASSWORD',
      PAGINATION: 'FORM.USER_SETTINGS.PAGINATION',
      PREFERENCES: 'FORM.USER_SETTINGS.PREFERENCES',
      UPLOAD_BUTTON: 'FORM.USER_SETTINGS.UPLOAD_BUTTON',
    },
    USE_PAYMENT_MATCHING: 'FORM.USE_PAYMENT_MATCHING',
    VALIDATE: 'FORM.VALIDATE',
    VALIDATE_AND_SEND: 'FORM.VALIDATE_AND_SEND',
    VAT: 'FORM.VAT',
    VAT_FORMAT: 'FORM.VAT_FORMAT',
    WARNING_IRREVERSIBLE_ACTION: 'FORM.WARNING_IRREVERSIBLE_ACTION',
    YUKI: {
      ADMIN_KEY: 'FORM.YUKI.ADMIN_KEY',
      API_KEY: 'FORM.YUKI.API_KEY',
      BASED_ON: 'FORM.YUKI.BASED_ON',
      CASH_ACCOUNT: 'FORM.YUKI.CASH_ACCOUNT',
      EXPORT_ON_YUKI: 'FORM.YUKI.EXPORT_ON_YUKI',
      IMPORT_ON_RECOVR: 'FORM.YUKI.IMPORT_ON_RECOVR',
      SUMMARY: 'FORM.YUKI.SUMMARY',
    },
  },
  FROM: 'FROM',
  FULL_BILLING_STATEMENT: 'FULL_BILLING_STATEMENT',
  GENERAL_CONDITIONS: 'GENERAL_CONDITIONS',
  GROUP: {
    FEEDBACK: {
      TITLE: 'GROUP.FEEDBACK.TITLE',
      DESCRIPTION: 'GROUP.FEEDBACK.DESCRIPTION',
    },
    AGED_BALANCE_COMPUTED_AT: 'GROUP.AGED_BALANCE_COMPUTED_AT',
    ALL_CLEAR: 'GROUP.ALL_CLEAR',
    ANALYTICS_UNAVAILABLE: 'GROUP.ANALYTICS_UNAVAILABLE',
    BY_COMPANY: 'GROUP.BY_COMPANY',
    BY_COMPANY_SUBTITLE: 'GROUP.BY_COMPANY_SUBTITLE',
    CLEAR_FILTER: 'GROUP.CLEAR_FILTER',
    CLEAR_SEARCH: 'GROUP.CLEAR_SEARCH',
    CLIENTS_TO_TREAT: 'GROUP.CLIENTS_TO_TREAT',
    CLIENT_COUNT: 'GROUP.CLIENT_COUNT',
    COMPANIES: 'GROUP.COMPANIES',
    COMPANIES_REACHED: 'GROUP.COMPANIES_REACHED',
    COMPANY_COUNT: 'GROUP.COMPANY_COUNT',
    COMPANY_DSO: 'GROUP.COMPANY_DSO',
    COMPANY_WITHOUT_AGED_BALANCE: 'GROUP.COMPANY_WITHOUT_AGED_BALANCE',
    ADD_MEMBER: 'GROUP.ADD_MEMBER',
    COMPUTED_AT: 'GROUP.COMPUTED_AT',
    COUNTED_COMPANIES: 'GROUP.COUNTED_COMPANIES',
    COUNTS_UNAVAILABLE: 'GROUP.COUNTS_UNAVAILABLE',
    EXCLUDED_COMPANIES: 'GROUP.EXCLUDED_COMPANIES',
    FILTER_COMPANIES: 'GROUP.FILTER_COMPANIES',
    MEMBERS: 'GROUP.MEMBERS',
    MEMBER_TO_ADD: 'GROUP.MEMBER_TO_ADD',
    NAV_LABEL: 'GROUP.NAV_LABEL',
    NO_STORED_AGED_BALANCE: 'GROUP.NO_STORED_AGED_BALANCE',
    OLDEST_COMPUTED_AT: 'GROUP.OLDEST_COMPUTED_AT',
    REMOVE_MEMBER: 'GROUP.REMOVE_MEMBER',
    ROLE: 'GROUP.ROLE',
    ROLES: {
      ADMIN: 'GROUP.ROLES.ADMIN',
      MEMBER: 'GROUP.ROLES.MEMBER',
    },
    SEARCH_PLACEHOLDER: 'GROUP.SEARCH_PLACEHOLDER',
    SHARE_OF_GROUP: 'GROUP.SHARE_OF_GROUP',
    TOTAL_OVERDUE: 'GROUP.TOTAL_OVERDUE',
    VIEW: 'GROUP.VIEW',
    WORST_PAYMENT_DELAY: 'GROUP.WORST_PAYMENT_DELAY',
    WORST_PAYMENT_DELAY_SHORT: 'GROUP.WORST_PAYMENT_DELAY_SHORT',
    TOUR: {
      START: 'GROUP.TOUR.START',
      SKIP: 'GROUP.TOUR.SKIP',
      FINISH: 'GROUP.TOUR.FINISH',
      WELCOME: {
        TITLE: 'GROUP.TOUR.WELCOME.TITLE',
        BODY: 'GROUP.TOUR.WELCOME.BODY',
      },
      NEXT: 'GROUP.TOUR.NEXT',
      BACK: 'GROUP.TOUR.BACK',
      FILTER: {
        TITLE: 'GROUP.TOUR.FILTER.TITLE',
        BODY: 'GROUP.TOUR.FILTER.BODY',
      },
      COMPUTED_AT: {
        TITLE: 'GROUP.TOUR.COMPUTED_AT.TITLE',
        BODY: 'GROUP.TOUR.COMPUTED_AT.BODY',
      },
      OUTSTANDING: {
        TITLE: 'GROUP.TOUR.OUTSTANDING.TITLE',
        BODY: 'GROUP.TOUR.OUTSTANDING.BODY',
      },
      BY_COMPANY: {
        TITLE: 'GROUP.TOUR.BY_COMPANY.TITLE',
        BODY: 'GROUP.TOUR.BY_COMPANY.BODY',
      },
      AGED_BALANCE: {
        TITLE: 'GROUP.TOUR.AGED_BALANCE.TITLE',
        BODY: 'GROUP.TOUR.AGED_BALANCE.BODY',
      },
      PERFORMANCE: {
        TITLE: 'GROUP.TOUR.PERFORMANCE.TITLE',
        BODY: 'GROUP.TOUR.PERFORMANCE.BODY',
      },
      NAVIGATION: {
        TITLE: 'GROUP.TOUR.NAVIGATION.TITLE',
        BODY: 'GROUP.TOUR.NAVIGATION.BODY',
      },
      FEEDBACK: {
        TITLE: 'GROUP.TOUR.FEEDBACK.TITLE',
        BODY: 'GROUP.TOUR.FEEDBACK.BODY',
      },
    },
  },
  HEADER: {
    USER_ACTIONS: {
      EDIT_PROFILE: 'HEADER.USER_ACTIONS.EDIT_PROFILE',
      LOGOUT: 'HEADER.USER_ACTIONS.LOGOUT',
      SPACES: 'HEADER.USER_ACTIONS.SPACES',
    },
  },
  HIDE_PAID_INVOICES: 'HIDE_PAID_INVOICES',
  IF_NOT: 'IF_NOT',
  IGNORE_LATE_FEES: 'IGNORE_LATE_FEES',
  IMPORT: 'IMPORT',
  IMPORT_CSV: 'IMPORT_CSV',
  IMPORT_EXPORT: 'IMPORT_EXPORT',
  IMPORT_TO_CONFIRM: 'IMPORT_TO_CONFIRM',
  INCLUDE_NDC_PAYMENT: 'INCLUDE_NDC_PAYMENT',
  INCLUDE_ONLY_INVOICE_BALANCE: 'INCLUDE_ONLY_INVOICE_BALANCE',
  INCOMPLETE_ADRESS: 'INCOMPLETE_ADRESS',
  INTEREST_CALCULATION_TYPE: {
    FIX: 'INTEREST_CALCULATION_TYPE.FIX',
    PERCENTAGE: 'INTEREST_CALCULATION_TYPE.PERCENTAGE',
  },
  INVITE: 'INVITE',
  INVOICE: {
    ACTIVITIES: 'INVOICE.ACTIVITIES',
    ADDITIONAL_DOCUMENT: 'INVOICE.ADDITIONAL_DOCUMENT',
    ADD_ADDITIONAL_DOCUMENT: 'INVOICE.ADD_ADDITIONAL_DOCUMENT',
    ADD_PAYMENT: 'INVOICE.ADD_PAYMENT',
    AMOUNT_DUE: 'INVOICE.AMOUNT_DUE',
    AMOUNT_LINKED: 'INVOICE.AMOUNT_LINKED',
    AVERAGE_AUTHORIZED_DELAY: 'INVOICE.AVERAGE_AUTHORIZED_DELAY',
    AYS_TO_DELETE_CREDIT_NOTE: 'INVOICE.AYS_TO_DELETE_CREDIT_NOTE',
    AYS_TO_PAUSE: 'INVOICE.AYS_TO_PAUSE',
    AYS_TO_UNPAUSE: 'INVOICE.AYS_TO_UNPAUSE',
    BAILIFF_CASE: 'INVOICE.BAILIFF_CASE',
    BALANCE_CREDIT_NOTE: 'INVOICE.BALANCE_CREDIT_NOTE',
    BALANCE_FEES: 'INVOICE.BALANCE_FEES',
    BALANCE_INC_FEES: 'INVOICE.BALANCE_INC_FEES',
    CALCULATE_DATE: 'INVOICE.CALCULATE_DATE',
    CHANGE_STATUS: 'INVOICE.CHANGE_STATUS',
    CLIENT_SUMMARY: 'INVOICE.CLIENT_SUMMARY',
    COMMENT: 'INVOICE.COMMENT',
    CREATE_CREDIT_NOTE: 'INVOICE.CREATE_CREDIT_NOTE',
    CREDIT_NOTE_DETAIL: 'INVOICE.CREDIT_NOTE_DETAIL',
    CREDIT_NOTE_STATUS: 'INVOICE.CREDIT_NOTE_STATUS',
    DAY_OF_DELAY: 'INVOICE.DAY_OF_DELAY',
    DELETE: 'INVOICE.DELETE',
    DELETED: 'INVOICE.DELETED',
    DELETE_MULTIPLE: 'INVOICE.DELETE_MULTIPLE',
    DETAILS: 'INVOICE.DETAILS',
    DISCOUNT: 'INVOICE.DISCOUNT',
    DISPUTED: 'INVOICE.DISPUTED',
    DISPUTED_REASON: 'INVOICE.DISPUTED_REASON',
    DOWNLOAD_CSV: 'INVOICE.DOWNLOAD_CSV',
    DOWNLOAD_PDF: 'INVOICE.DOWNLOAD_PDF',
    DRAFT: 'INVOICE.DRAFT',
    DUE_AMOUNT: 'INVOICE.DUE_AMOUNT',
    DUE_ON: 'INVOICE.DUE_ON',
    EDIT_ORGINAL_FILE: 'INVOICE.EDIT_ORGINAL_FILE',
    EDIT_SENDING_OPTIONS: 'INVOICE.EDIT_SENDING_OPTIONS',
    EDIT_SENDING_OPTIONS_SUMMARY: 'INVOICE.EDIT_SENDING_OPTIONS_SUMMARY',
    ESTIMATED_PAYMENT_DATE: 'INVOICE.ESTIMATED_PAYMENT_DATE',
    EXPORT: 'INVOICE.EXPORT',
    EXCLUDE_FROM_RECOVERY_PLAN: 'INVOICE.EXCLUDE_FROM_RECOVERY_PLAN',
    FILES_JOIN: 'INVOICE.FILES_JOIN',
    FILE_JOIN: 'INVOICE.FILE_JOIN',
    IMPORT_JOIN_NEW_DOC: 'INVOICE.IMPORT_JOIN_NEW_DOC',
    IMPORT_NEW_DOC: 'INVOICE.IMPORT_NEW_DOC',
    INTEREST: 'INVOICE.INTEREST',
    INTRACOMMUNITY: 'INVOICE.INTRACOMMUNITY',
    INVOICE_DETAIL: 'INVOICE.INVOICE_DETAIL',
    UNRECOVERABLE: 'INVOICE.UNRECOVERABLE',
    INVOICE_PRODUCTS: 'INVOICE.INVOICE_PRODUCTS',
    INVOICE_STATUS: 'INVOICE.INVOICE_STATUS',
    IN_PROGRESS: 'INVOICE.IN_PROGRESS',
    ISSUE_ON: 'INVOICE.ISSUE_ON',
    INCLUDE_IN_RECOVERY_PLAN: 'INVOICE.INCLUDE_IN_RECOVERY_PLAN',
    IN_PAYMENT_PLAN: 'INVOICE.IN_PAYMENT_PLAN',
    JOIN_FILE: 'INVOICE.JOIN_FILE',
    LATE: 'INVOICE.LATE',
    LATE_ONLY: 'INVOICE.LATE_ONLY',
    LAWYER_CASE: 'INVOICE.LAWYER_CASE',
    LINK_INVOICE: 'INVOICE.LINK_INVOICE',
    LINK_INVOICES: 'INVOICE.LINK_INVOICES',
    LINK_TO_INVOICE: 'INVOICE.LINK_TO_INVOICE',
    UNRECOVERABLE_REASON: 'INVOICE.UNRECOVERABLE_REASON',
    MARK_AS_DISPUTED: 'INVOICE.MARK_AS_DISPUTED',
    MARK_AS_UNRECOVERABLE: 'INVOICE.MARK_AS_UNRECOVERABLE',
    MARK_AS_PAID: 'INVOICE.MARK_AS_PAID',
    MAX_DAYS_LATE: 'INVOICE.MAX_DAYS_LATE',
    MIN_DAYS_LATE: 'INVOICE.MIN_DAYS_LATE',
    MOVE_PLAN: 'INVOICE.MOVE_PLAN',
    NEW_COMMENT: 'INVOICE.NEW_COMMENT',
    NEXT_STEP: 'INVOICE.NEXT_STEP',
    NOT_IMPORTED: 'INVOICE.NOT_IMPORTED',
    NO_PAYMENT_METHOD: 'INVOICE.NO_PAYMENT_METHOD',
    OPEN_CASE: 'INVOICE.OPEN_CASE',
    ORIGINAL_FILE: 'INVOICE.ORIGINAL_FILE',
    OTHER_ACTIONS: 'INVOICE.OTHER_ACTIONS',
    PAID: 'INVOICE.PAID',
    PAIDS: 'INVOICE.PAIDS',
    PAUSE_THE_FOLLOW_UP: 'INVOICE.PAUSE_THE_FOLLOW_UP',
    PAYMENT_INFO: 'INVOICE.PAYMENT_INFO',
    PREVIEW: 'INVOICE.PREVIEW',
    PRODUCT: 'INVOICE.PRODUCT',
    QTE: 'INVOICE.QTE',
    RECOVER_ACTIONS: 'INVOICE.RECOVER_ACTIONS',
    RESUME_FOLLUW_UP: 'INVOICE.RESUME_FOLLUW_UP',
    REVENUES: 'INVOICE.REVENUES',
    REVERSE_CHARGE_COCONTRACTOR: 'INVOICE.REVERSE_CHARGE_COCONTRACTOR',
    SELECTED_ONLY: 'INVOICE.SELECTED_ONLY',
    SENDING_OPTIONS: 'INVOICE.SENDING_OPTIONS',
    SENDING_OPTIONS_BATCH_SUMMARY: 'INVOICE.SENDING_OPTIONS_BATCH_SUMMARY',
    SENDING_OPTIONS_SUMMARY: 'INVOICE.SENDING_OPTIONS_SUMMARY',
    SEND_REMINDER: 'INVOICE.SEND_REMINDER',
    SEND_REMINDERS_BY: 'INVOICE.SEND_REMINDERS_BY',
    SEND_WITH: 'INVOICE.SEND_WITH',
    SEND_WITH_INVOICE: 'INVOICE.SEND_WITH_INVOICE',
    SETTLE: 'INVOICE.SETTLE',
    SEE_PAYMENTS: 'INVOICE.SEE_PAYMENTS',
    SUCCESSFULLY_ADDED_PAYMENT: 'INVOICE.SUCCESSFULLY_ADDED_PAYMENT',
    SUCCESSFULLY_MESSAGE_SENT: 'INVOICE.SUCCESSFULLY_MESSAGE_SENT',
    SUCCESSFUL_CN_SENT: 'INVOICE.SUCCESSFUL_CN_SENT',
    SUCCESSFUL_CN_UPDATE: 'INVOICE.SUCCESSFUL_CN_UPDATE',
    SUCCESSFUL_CREATION: 'INVOICE.SUCCESSFUL_CREATION',
    SUCCESSFUL_IMPORT: 'INVOICE.SUCCESSFUL_IMPORT',
    SUCCESSFUL_UPDATE: 'INVOICE.SUCCESSFUL_UPDATE',
    TEMPLATE: 'INVOICE.TEMPLATE',
    TOTAL_IGNORED_LATE_FEES: 'INVOICE.TOTAL_IGNORED_LATE_FEES',
    TOTAL_LATE_FEES: 'INVOICE.TOTAL_LATE_FEES',
    UNDO_DISPUTED: 'INVOICE.UNDO_DISPUTED',
    UNLINK: 'INVOICE.UNLINK',
    UNMATCH_PAYMENT: {
      AYS_TO_DELETE: 'INVOICE.UNMATCH_PAYMENT.AYS_TO_DELETE',
      AYS_TO_UNMATCH: 'INVOICE.UNMATCH_PAYMENT.AYS_TO_UNMATCH',
      CANCEL_PAYMENT: 'INVOICE.UNMATCH_PAYMENT.CANCEL_PAYMENT',
      CREDIT_NOTES: 'INVOICE.UNMATCH_PAYMENT.CREDIT_NOTES',
      PAYMENTS_ADDED_MANUALLY: 'INVOICE.UNMATCH_PAYMENT.PAYMENTS_ADDED_MANUALLY',
      PAYMENT_AMOUNT: 'INVOICE.UNMATCH_PAYMENT.PAYMENT_AMOUNT',
      RECONCILED_PAYMENTS: 'INVOICE.UNMATCH_PAYMENT.RECONCILED_PAYMENTS',
      RECONCILIATION_AMOUNT: 'INVOICE.UNMATCH_PAYMENT.RECONCILIATION_AMOUNT',
      RECONCILIATION_NOT_ACTIVE_ANYMORE:
        'INVOICE.UNMATCH_PAYMENT.RECONCILIATION_NOT_ACTIVE_ANYMORE',
      SUCCESSFULLY_DELETE_PAYMENT: 'INVOICE.UNMATCH_PAYMENT.SUCCESSFULLY_DELETE_PAYMENT',
      SUCCESSFULLY_UNMATCH_PAYMENT: 'INVOICE.UNMATCH_PAYMENT.SUCCESSFULLY_UNMATCH_PAYMENT',
      UNMATCH_PAYMENT: 'INVOICE.UNMATCH_PAYMENT.UNMATCH_PAYMENT',
    },
    VAT_RATE: 'INVOICE.VAT_RATE',
    VIEW_PDF: 'INVOICE.VIEW_PDF',
    YOUR_INVOICE_FOR: 'INVOICE.YOUR_INVOICE_FOR',
  },
  INVOICES: 'INVOICES',
  INVOICE_COUNT: 'INVOICE_COUNT',
  INVOICES_IMPORT: 'INVOICES_IMPORT',
  INVOICE_BALANCE: 'INVOICE_BALANCE',
  INVOICE_BILLING_STATEMENT: 'INVOICE_BILLING_STATEMENT',
  INVOICE_IMPORT: 'INVOICE_IMPORT',
  INVOICE_NUMBER: 'INVOICE_NUMBER',
  INVOICE_SENDING_MEDIUM: 'INVOICE_SENDING_MEDIUM',
  INVOICE_TO_PROCESS: 'INVOICE_TO_PROCESS',
  CLIENTS_TO_PROCESS: 'CLIENTS_TO_PROCESS',
  INVOICING: {
    ACTION: 'INVOICING.ACTION',
    ADD_CREDIT_NOTE: 'INVOICING.ADD_CREDIT_NOTE',
    ADD_REFERENCE: 'INVOICING.ADD_REFERENCE',
    ALREADY_PAID: 'INVOICING.ALREADY_PAID',
    CREATE: {
      ADD_PRODUCT: 'INVOICING.CREATE.ADD_PRODUCT',
      BILLING_BOOK: 'INVOICING.CREATE.BILLING_BOOK',
      BOOK: 'INVOICING.CREATE.BOOK',
      CHOOSE_PRODUCT: 'INVOICING.CREATE.CHOOSE_PRODUCT',
      DISCOUNT_PERCENTAGE: 'INVOICING.CREATE.DISCOUNT_PERCENTAGE',
      EDIT_CREDIT_NOTE: 'INVOICING.CREATE.EDIT_CREDIT_NOTE',
      ERROR: {
        CHOOSE_BOOK: 'INVOICING.CREATE.ERROR.CHOOSE_BOOK',
        CHOOSE_CLIENT: 'INVOICING.CREATE.ERROR.CHOOSE_CLIENT',
        CHOOSE_INVOICE: 'INVOICING.CREATE.ERROR.CHOOSE_INVOICE',
      },
      NOTES_COMMENTS: 'INVOICING.CREATE.NOTES_COMMENTS',
      ORDER_REFERENCE: 'INVOICING.CREATE.ORDER_REFERENCE',
      SELECT_CLIENT: 'INVOICING.CREATE.SELECT_CLIENT',
      VAT_APPLIED_0: 'INVOICING.CREATE.VAT_APPLIED_0',
      VAT_PERCENTAGE: 'INVOICING.CREATE.VAT_PERCENTAGE',
    },
    CREDIT_NOTE_BOOK: 'INVOICING.CREDIT_NOTE_BOOK',
    CREDIT_NOTE_TEMPLATE: 'INVOICING.CREDIT_NOTE_TEMPLATE',
    DONT_CHANGE: 'INVOICING.DONT_CHANGE',
    EDIT_INVOICE: 'INVOICING.EDIT_INVOICE',
    EXPORT_CSV: {
      CANNOT_EXPORT: 'INVOICING.EXPORT_CSV.CANNOT_EXPORT',
      CLIENT_DATA: 'INVOICING.EXPORT_CSV.CLIENT_DATA',
      CUSTOM_DATA: 'INVOICING.EXPORT_CSV.CUSTOM_DATA',
      DEBTOR_CUSTOM_DATA: 'INVOICING.EXPORT_CSV.DEBTOR_CUSTOM_DATA',
      EXPORT_ALL_CREDIT_NOTE: 'INVOICING.EXPORT_CSV.EXPORT_ALL_CREDIT_NOTE',
      EXPORT_ALL_DEBTOR: 'INVOICING.EXPORT_CSV.EXPORT_ALL_DEBTOR',
      EXPORT_ALL_INVOICE: 'INVOICING.EXPORT_CSV.EXPORT_ALL_INVOICE',
      EXPORT_ALL_PAYMENT_PLANS: 'INVOICING.EXPORT_CSV.EXPORT_ALL_PAYMENT_PLANS',
      EXPORT_ALL_TASKS: 'INVOICING.EXPORT_CSV.EXPORT_ALL_TASKS',
      EXPORT_FILTERED_CREDIT_NOTE: 'INVOICING.EXPORT_CSV.EXPORT_FILTERED_CREDIT_NOTE',
      EXPORT_FILTERED_DEBTOR: 'INVOICING.EXPORT_CSV.EXPORT_FILTERED_DEBTOR',
      EXPORT_FILTERED_INVOICE: 'INVOICING.EXPORT_CSV.EXPORT_FILTERED_INVOICE',
      EXPORT_FILTERED_PAYMENT_PLANS: 'INVOICING.EXPORT_CSV.EXPORT_FILTERED_PAYMENT_PLANS',
      EXPORT_FILTERED_TASKS: 'INVOICING.EXPORT_CSV.EXPORT_FILTERED_TASKS',
      FINANCIAL_DATA: 'INVOICING.EXPORT_CSV.FINANCIAL_DATA',
      PLEASE_SELECT_FIELDS: 'INVOICING.EXPORT_CSV.PLEASE_SELECT_FIELDS',
    },
    IMPENDING_REMINDERS: {
      CANCEL_REMINDER: 'INVOICING.IMPENDING_REMINDERS.CANCEL_REMINDER',
      INVOICES_TO_POSTPONE: 'INVOICING.IMPENDING_REMINDERS.INVOICES_TO_POSTPONE',
      INVOICE_TO_POSTPONE: 'INVOICING.IMPENDING_REMINDERS.INVOICE_TO_POSTPONE',
      LEAVE_ON: 'INVOICING.IMPENDING_REMINDERS.LEAVE_ON',
      POSTPONE_ALL: 'INVOICING.IMPENDING_REMINDERS.POSTPONE_ALL',
      POSTPONE_REMINDER: 'INVOICING.IMPENDING_REMINDERS.POSTPONE_REMINDER',
      WAITING_VALIDATION: 'INVOICING.IMPENDING_REMINDERS.WAITING_VALIDATION',
    },
    IMPORT: {
      AMOUNT_ALREADY_PAID: 'INVOICING.IMPORT.AMOUNT_ALREADY_PAID',
      AMOUNT_ALREADY_PAID_CURRENCY: 'INVOICING.IMPORT.AMOUNT_ALREADY_PAID_CURRENCY',
      CSV_INVOICES: 'INVOICING.IMPORT.CSV_INVOICES',
      DELETE_ALL: 'INVOICING.IMPORT.DELETE_ALL',
      DELETE_ALL_EMPTY_COL: 'INVOICING.IMPORT.DELETE_ALL_EMPTY_COL',
      EDIT_SUMMARY: 'INVOICING.IMPORT.EDIT_SUMMARY',
      GO_TO_VALIDATION_PAGE: 'INVOICING.IMPORT.GO_TO_VALIDATION_PAGE',
      LINE: 'INVOICING.IMPORT.LINE',
      LINES: 'INVOICING.IMPORT.LINES',
      MATCH_WITH: 'INVOICING.IMPORT.MATCH_WITH',
      MUST_BE_LOWER_EQUAL: 'INVOICING.IMPORT.MUST_BE_LOWER_EQUAL',
      ORIGINAL_FILE: 'INVOICING.IMPORT.ORIGINAL_FILE',
      PAYMENT_DONE: 'INVOICING.IMPORT.PAYMENT_DONE',
      PDF_INVOICES: 'INVOICING.IMPORT.PDF_INVOICES',
      PUT_LINE_AS_HEADER: 'INVOICING.IMPORT.PUT_LINE_AS_HEADER',
      SEE_INVOICES_TO_CONFIRM: 'INVOICING.IMPORT.SEE_INVOICES_TO_CONFIRM',
      SELECT_ALL_REQUIRED_FIELDS: 'INVOICING.IMPORT.SELECT_ALL_REQUIRED_FIELDS',
      SUMMARY: 'INVOICING.IMPORT.SUMMARY',
      UBL_INVOICES: 'INVOICING.IMPORT.UBL_INVOICES',
      UBL_UPLOAD: {
        DROP_TITLE: 'INVOICING.IMPORT.UBL_UPLOAD.DROP_TITLE',
        DROP_SUBTITLE: 'INVOICING.IMPORT.UBL_UPLOAD.DROP_SUBTITLE',
        ADD_MORE: 'INVOICING.IMPORT.UBL_UPLOAD.ADD_MORE',
        FILES_SELECTED: 'INVOICING.IMPORT.UBL_UPLOAD.FILES_SELECTED',
        IMPORTING: 'INVOICING.IMPORT.UBL_UPLOAD.IMPORTING',
        SUBTITLE: 'INVOICING.IMPORT.UBL_UPLOAD.SUBTITLE',
        FILTER_PLACEHOLDER: 'INVOICING.IMPORT.UBL_UPLOAD.FILTER_PLACEHOLDER',
        NO_MATCH: 'INVOICING.IMPORT.UBL_UPLOAD.NO_MATCH',
        IMPORT_FAILED: 'INVOICING.IMPORT.UBL_UPLOAD.IMPORT_FAILED',
        KEEP_OPEN: 'INVOICING.IMPORT.UBL_UPLOAD.KEEP_OPEN',
      },
      VALIDATE_ALL: 'INVOICING.IMPORT.VALIDATE_ALL',
    },
    INVOICES_BOOK: 'INVOICING.INVOICES_BOOK',
    INVOICES_TO_CONFIRM: 'INVOICING.INVOICES_TO_CONFIRM',
    INVOICE_DATE: 'INVOICING.INVOICE_DATE',
    INVOICE_TEXT: {
      BEFORE_DEADLINE: 'INVOICING.INVOICE_TEXT.BEFORE_DEADLINE',
      GIVE_THE_AMOUNT: 'INVOICING.INVOICE_TEXT.GIVE_THE_AMOUNT',
      WITH_COMMUNICATION: 'INVOICING.INVOICE_TEXT.WITH_COMMUNICATION',
    },
    PLANNED_REMINDER: 'INVOICING.PLANNED_REMINDER',
    PRODUCT: {
      AYS_TO_DELETE: 'INVOICING.PRODUCT.AYS_TO_DELETE',
      TITLE: 'INVOICING.PRODUCT.TITLE',
      TAB_ACTIVE: 'INVOICING.PRODUCT.TAB_ACTIVE',
      TAB_ARCHIVED: 'INVOICING.PRODUCT.TAB_ARCHIVED',
      ARCHIVED_BADGE: 'INVOICING.PRODUCT.ARCHIVED_BADGE',
      ARCHIVE: 'INVOICING.PRODUCT.ARCHIVE',
      UNARCHIVE: 'INVOICING.PRODUCT.UNARCHIVE',
      ACTIVE: 'INVOICING.PRODUCT.ACTIVE',
      EMPTY: 'INVOICING.PRODUCT.EMPTY',
      EMPTY_ARCHIVED: 'INVOICING.PRODUCT.EMPTY_ARCHIVED',
    },
    RECOVERY: 'INVOICING.RECOVERY',
    SEE_DETAIL: 'INVOICING.SEE_DETAIL',
    SEE_INVOICE: 'INVOICING.SEE_INVOICE',
    SEE_INVOICES: 'INVOICING.SEE_INVOICES',
    SELECT_INVOICE: 'INVOICING.SELECT_INVOICE',
    SEND_CREDIT_NOTE: 'INVOICING.SEND_CREDIT_NOTE',
    SUCCESSFULLY_PRODUCT_CREATION: 'INVOICING.SUCCESSFULLY_PRODUCT_CREATION',
    SUCCESSFULLY_PRODUCT_UPDATE: 'INVOICING.SUCCESSFULLY_PRODUCT_UPDATE',
    TOTAL_OUTSTANDING_PAYMENTS: 'INVOICING.TOTAL_OUTSTANDING_PAYMENTS',
    TOTAL_VAT_PRICE_CURRENCY: 'INVOICING.TOTAL_VAT_PRICE_CURRENCY',
    VALIDATE_INVOICE: 'INVOICING.VALIDATE_INVOICE',
  },
  CURRENT_DATE: 'CURRENT_DATE',
  IN_CENTS: 'IN_CENTS',
  IN_PROGRESS: 'IN_PROGRESS',
  ISSUE_DATE: 'ISSUE_DATE',
  ISSUE_DATE_SHORT: 'ISSUE_DATE_SHORT',
  IS_USED: 'IS_USED',
  KANBAN: {
    BALANCE: 'KANBAN.BALANCE',
    DEBTOR: {
      TITLE: 'KANBAN.DEBTOR.TITLE',
    },
    FILTERS: {
      CLIENT_NAME: 'KANBAN.FILTERS.CLIENT_NAME',
      CLIENT_NAME_PH: 'KANBAN.FILTERS.CLIENT_NAME_PH',
      DEBTOR_UNPAUSED: 'KANBAN.FILTERS.DEBTOR_UNPAUSED',
      INVOICE_NAME: 'KANBAN.FILTERS.INVOICE_NAME',
      INVOICE_NAME_PH: 'KANBAN.FILTERS.INVOICE_NAME_PH',
      INVOICE_UNPAUSED: 'KANBAN.FILTERS.INVOICE_UNPAUSED',
      LESS_THAN: 'KANBAN.FILTERS.LESS_THAN',
      MAX_BALANCE: 'KANBAN.FILTERS.MAX_BALANCE',
      MAX_DAYS_LATE: 'KANBAN.FILTERS.MAX_DAYS_LATE',
      MAX_DAYS_LATE_PH: 'KANBAN.FILTERS.MAX_DAYS_LATE_PH',
      MIN_BALANCE: 'KANBAN.FILTERS.MIN_BALANCE',
      MIN_DAYS_LATE: 'KANBAN.FILTERS.MIN_DAYS_LATE',
      MIN_DAYS_LATE_PH: 'KANBAN.FILTERS.MIN_DAYS_LATE_PH',
      MORE_THAN: 'KANBAN.FILTERS.MORE_THAN',
      OPERATOR: 'KANBAN.FILTERS.OPERATOR',
    },
    INVOICE: {
      TITLE: 'KANBAN.INVOICE.TITLE',
    },
    LATE_INVOICES: 'KANBAN.LATE_INVOICES',
  },
  LAST_ISSUE_DATE: 'LAST_ISSUE_DATE',
  LAST_UPDATE: 'LAST_UPDATE',
  LATE: 'LATE',
  LATE_FEES: 'LATE_FEES',
  LATE_FEES_INCLUDED: 'LATE_FEES_INCLUDED',
  LINKED_PAYMENT: 'LINKED_PAYMENT',
  LOADING: 'LOADING',
  LOGIN: {
    ASK_ACCOUNT: 'LOGIN.ASK_ACCOUNT',
    BAD_SUBDOMAIN: 'LOGIN.BAD_SUBDOMAIN',
    CHANGE_PASSWORD: 'LOGIN.CHANGE_PASSWORD',
    CREATE_PASSWORD: 'LOGIN.CREATE_PASSWORD',
    MFA_FAILED: 'LOGIN.MFA_FAILED',
    NOT_YET_ACCOUNT: 'LOGIN.NOT_YET_ACCOUNT',
    PASSWORD_EDITED: 'LOGIN.PASSWORD_EDITED',
    RESET_PASSWORD: 'LOGIN.RESET_PASSWORD',
    TITLE: 'LOGIN.TITLE',
    VERIFY_SUBDOMAIN: 'LOGIN.VERIFY_SUBDOMAIN',
    YOUR_PASSWORD: 'LOGIN.YOUR_PASSWORD',
    YOU_FORGOT: 'LOGIN.YOU_FORGOT',
  },
  LOG_IN: 'LOG_IN',
  LOST_SUM: 'LOST_SUM',
  MAILS: {
    HISTORY: 'MAILS.HISTORY',
    INBOX: 'MAILS.INBOX',
    DRAFT: 'MAILS.DRAFT',
    NAV: 'MAILS.NAV',
    NEW: 'MAILS.NEW',
    SENT: 'MAILS.SENT',
    STATUS: {
      BOUNCE: 'MAILS.STATUS.BOUNCE',
      CLICK: 'MAILS.STATUS.CLICK',
      DEFERRED: 'MAILS.STATUS.DEFERRED',
      DELIVERED: 'MAILS.STATUS.DELIVERED',
      DROPPED: 'MAILS.STATUS.DROPPED',
      OPEN: 'MAILS.STATUS.OPEN',
      PROCESSED: 'MAILS.STATUS.PROCESSED',
      READ: 'MAILS.STATUS.READ',
      UNPROCESSED: 'MAILS.STATUS.UNPROCESSED',
      UNREAD: 'MAILS.STATUS.UNREAD',
    },
  },
  MAIN: 'MAIN',
  MAINTENANCE: {
    DESC_1: 'MAINTENANCE.DESC_1',
    DESC_2: 'MAINTENANCE.DESC_2',
    TITLE: 'MAINTENANCE.TITLE',
  },
  MARK_AS_DISPUTED: 'MARK_AS_DISPUTED',
  MARK_AS_UNRECOVERABLE: 'MARK_AS_UNRECOVERABLE',
  MARK_AS_PAID: 'MARK_AS_PAID',
  MENU_TAG: {
    NEW: 'MENU_TAG.NEW',
  },
  MERGE_CLIENT: 'MERGE_CLIENT',
  MERGE_CLIENTS: 'MERGE_CLIENTS',
  MIN_SALDO_SENDING: 'MIN_SALDO_SENDING',
  MISSING_DATA: 'MISSING_DATA',
  MISSING_EMAIL: 'MISSING_EMAIL',
  MISSING_VAR: 'MISSING_VAR',
  MODALITY: 'MODALITY',
  MODULES: {
    AT_RISK: {
      TITLE: 'MODULES.AT_RISK.TITLE',
      TAB_TITLE: 'MODULES.AT_RISK.TAB_TITLE',
      INDEX_TITLE: 'MODULES.AT_RISK.INDEX_TITLE',
      COLUMNS: {
        CLIENT: 'MODULES.AT_RISK.COLUMNS.CLIENT',
        AVERAGE_PAYMENT_DELAY: 'MODULES.AT_RISK.COLUMNS.AVERAGE_PAYMENT_DELAY',
        REMAINING_BALANCE: 'MODULES.AT_RISK.COLUMNS.REMAINING_BALANCE',
      },
      NEXT_ACTION: {
        TITLE: 'MODULES.AT_RISK.NEXT_ACTION.TITLE',
        DESCRIPTION_PREFIX: 'MODULES.AT_RISK.NEXT_ACTION.DESCRIPTION_PREFIX',
        DESCRIPTION_SUFFIX: 'MODULES.AT_RISK.NEXT_ACTION.DESCRIPTION_SUFFIX',
        NEXT_CLIENT: 'MODULES.AT_RISK.NEXT_ACTION.NEXT_CLIENT',
        BACK_TO_LIST: 'MODULES.AT_RISK.NEXT_ACTION.BACK_TO_LIST',
      },
      CLIENT_SNAPSHOT: {
        TITLE: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.TITLE',
        UNDER_ACTIVE_RECOVERY: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.UNDER_ACTIVE_RECOVERY',
        IN_PAYMENT_PLAN: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.IN_PAYMENT_PLAN',
        NOT_DUE_YET: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.NOT_DUE_YET',
        AVG_PAYMENT_DELAY: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.AVG_PAYMENT_DELAY',
        INVOICES_PAID_LATE: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.INVOICES_PAID_LATE',
        THIRD_PARTY_CASES: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.THIRD_PARTY_CASES',
        WIDER_CONTEXT: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.WIDER_CONTEXT',
        OPEN: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.OPEN',
        MAX_DAYS: 'MODULES.AT_RISK.CLIENT_SNAPSHOT.MAX_DAYS',
      },
      DEBT_COLLECTOR: 'MODULES.AT_RISK.DEBT_COLLECTOR',
      ACTION_GROUPS: {
        CASE_STATUS: 'MODULES.AT_RISK.ACTION_GROUPS.CASE_STATUS',
        DUNNING: 'MODULES.AT_RISK.ACTION_GROUPS.DUNNING',
        THIRD_PARTIES: 'MODULES.AT_RISK.ACTION_GROUPS.THIRD_PARTIES',
      },
      OVERVIEW: {
        UNHANDLED_OUT_OF: 'MODULES.AT_RISK.OVERVIEW.UNHANDLED_OUT_OF',
        TO_BE_RECEIVED: 'MODULES.AT_RISK.OVERVIEW.TO_BE_RECEIVED',
        PORTFOLIO: 'MODULES.AT_RISK.OVERVIEW.PORTFOLIO',
        INVOICES_COUNT: 'MODULES.AT_RISK.OVERVIEW.INVOICES_COUNT',
        UNHANDLED: 'MODULES.AT_RISK.OVERVIEW.UNHANDLED',
        IN_PLAN: 'MODULES.AT_RISK.OVERVIEW.IN_PLAN',
        NOT_DUE: 'MODULES.AT_RISK.OVERVIEW.NOT_DUE',
        DUE: 'MODULES.AT_RISK.OVERVIEW.DUE',
        TO_HANDLE: 'MODULES.AT_RISK.OVERVIEW.TO_HANDLE',
        IN_PROGRESS: 'MODULES.AT_RISK.OVERVIEW.IN_PROGRESS',
        CREDITED: 'MODULES.AT_RISK.OVERVIEW.CREDITED',
        OUT_OF: 'MODULES.AT_RISK.OVERVIEW.OUT_OF',
        SELECT_ACTION: 'MODULES.AT_RISK.OVERVIEW.SELECT_ACTION',
      },
      DIRECT_CONTACT: {
        TITLE: 'MODULES.AT_RISK.DIRECT_CONTACT.TITLE',
        CALL: 'MODULES.AT_RISK.DIRECT_CONTACT.CALL',
        EMAIL: 'MODULES.AT_RISK.DIRECT_CONTACT.EMAIL',
        NO_EMAIL: 'MODULES.AT_RISK.DIRECT_CONTACT.NO_EMAIL',
        NO_PHONE: 'MODULES.AT_RISK.DIRECT_CONTACT.NO_PHONE',
        NO_MAILBOX: 'MODULES.AT_RISK.DIRECT_CONTACT.NO_MAILBOX',
        PAUSE_AFTER_CALL: 'MODULES.AT_RISK.DIRECT_CONTACT.PAUSE_AFTER_CALL',
      },
      REGISTERED_POST_MANDATORY: 'MODULES.AT_RISK.REGISTERED_POST_MANDATORY',
      MARK_AS_PAID_SYNCED: 'MODULES.AT_RISK.MARK_AS_PAID_SYNCED',
      SELECTION_NEXT_STEP: 'MODULES.AT_RISK.SELECTION_NEXT_STEP',
      FEEDBACK: {
        QUESTION: 'MODULES.AT_RISK.FEEDBACK.QUESTION',
        DESCRIPTION: 'MODULES.AT_RISK.FEEDBACK.DESCRIPTION',
      },
    },
    IMPORT: {
      AVAILABLE_FIELDS: 'MODULES.IMPORT.AVAILABLE_FIELDS',
      MANDATORY_FIELDS: {
        DEBTORS: {
          IDENTIFIER: 'MODULES.IMPORT.MANDATORY_FIELDS.DEBTORS.IDENTIFIER',
        },
        INVOICES: {
          AMOUNT: 'MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.AMOUNT',
          ISSUE_DATE: 'MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.ISSUE_DATE',
          NAME: 'MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.NAME',
          REFERENCE: 'MODULES.IMPORT.MANDATORY_FIELDS.INVOICES.REFERENCE',
        },
      },
      REQUIRED_FIELDS: 'MODULES.IMPORT.REQUIRED_FIELDS',
      SELECT: 'MODULES.IMPORT.SELECT',
    },
  },
  MONTH: 'MONTH',
  MORE_INFO: 'MORE_INFO',
  MORNING: 'MORNING',
  NAME: 'NAME',
  NAV: {
    ACTIVITY_BOOK: 'NAV.ACTIVITY_BOOK',
    CONNECTED: 'NAV.CONNECTED',
    CREDIT_NOTES: 'NAV.CREDIT_NOTES',
    CUSTOMIZATION: 'NAV.CUSTOMIZATION',
    IMINENT_REMINDERS: 'NAV.IMINENT_REMINDERS',
    INVOICES: 'NAV.INVOICES',
    MY_FOLLOW_UP: 'NAV.MY_FOLLOW_UP',
    NEEDS_HANDLING: 'NAV.NEEDS_HANDLING',
    PAYMENT_BOOK: 'NAV.PAYMENT_BOOK',
    PAYMENT_PLAN: 'NAV.PAYMENT_PLAN',
    PRODUCTS: 'NAV.PRODUCTS',
    QUICK_ACTION: {
      ADD_LABEL: 'NAV.QUICK_ACTION.ADD_LABEL',
      CLIENT: 'NAV.QUICK_ACTION.CLIENT',
      CREDIT_NOTE: 'NAV.QUICK_ACTION.CREDIT_NOTE',
      IMPORT_CLIENTS: 'NAV.QUICK_ACTION.IMPORT_CLIENTS',
      IMPORT_INVOICES: 'NAV.QUICK_ACTION.IMPORT_INVOICES',
      IMPORT_LABEL: 'NAV.QUICK_ACTION.IMPORT_LABEL',
      INVOICE: 'NAV.QUICK_ACTION.INVOICE',
      LABEL: 'NAV.QUICK_ACTION.LABEL',
      PRODUCT: 'NAV.QUICK_ACTION.PRODUCT',
      TASK: 'NAV.QUICK_ACTION.TASK',
    },
    RECONCILIATION: 'NAV.RECONCILIATION',
    SETTINGS: 'NAV.SETTINGS',
    SUMMARY_TABLE: 'NAV.SUMMARY_TABLE',
    SYNC: {
      NEVER_SYNCED: 'NAV.SYNC.NEVER_SYNCED',
      RUNNING: 'NAV.SYNC.RUNNING',
      FAILING: 'NAV.SYNC.FAILING',
      INTEGRATIONS: 'NAV.SYNC.INTEGRATIONS',
      MAILBOX: 'NAV.SYNC.MAILBOX',
      TITLE: 'NAV.SYNC.TITLE',
      LAST_SYNC_NEVER: 'NAV.SYNC.LAST_SYNC_NEVER',
      LAST_SYNC_YESTERDAY: 'NAV.SYNC.LAST_SYNC_YESTERDAY',
      LAST_SYNC_WEEKDAY: 'NAV.SYNC.LAST_SYNC_WEEKDAY',
      LAST_SYNC_DATE: 'NAV.SYNC.LAST_SYNC_DATE',
      FAILURE: 'NAV.SYNC.FAILURE',
      FAILURES: 'NAV.SYNC.FAILURES',
    },
    TASKS: 'NAV.TASKS',
    THIRDPARTY: 'NAV.THIRDPARTY',
    UPSELL: 'NAV.UPSELL',
  },
  NEW_ADDRESS: 'NEW_ADDRESS',
  NEW_CLIENT: 'NEW_CLIENT',
  NEW_CREDIT_NOTE: 'NEW_CREDIT_NOTE',
  NEW_INVOICE: 'NEW_INVOICE',
  NEW_MESSAGE: 'NEW_MESSAGE',
  NEW_NOTE: 'NEW_NOTE',
  NEW_PAYMENT_PLAN: 'NEW_PAYMENT_PLAN',
  NEW_PRODUCT: 'NEW_PRODUCT',
  NEW_TASK: 'NEW_TASK',
  NEW_TEMPLATE: 'NEW_TEMPLATE',
  NEXT: 'NEXT',
  NEXT_DEADLINE: 'NEXT_DEADLINE',
  NEXT_STEP: 'NEXT_STEP',
  NEXT_STEP_DATE: 'NEXT_STEP_DATE',
  NO: 'NO',
  NONE: 'NONE',
  NOTES: 'NOTES',
  NOT_ASSIGNED: 'NOT_ASSIGNED',
  NOT_INCLUDED: 'NOT_INCLUDED',
  NO_AVAILABLE_ACTIONS: 'NO_AVAILABLE_ACTIONS',
  NO_PAYMENT_METHOD: 'NO_PAYMENT_METHOD',
  NO_RESULT: 'NO_RESULT',
  NO_RESULT_FOR_THIS_SEARCH: 'NO_RESULT_FOR_THIS_SEARCH',
  NO_SIGNATURE: 'NO_SIGNATURE',
  NO_STATEMENT: 'NO_STATEMENT',
  NO_TEXT: 'NO_TEXT',
  NR: 'NR',
  NUMBER: 'NUMBER',
  N_DAYS_AFTER_CREATION: 'N_DAYS_AFTER_CREATION',
  N_STEP: 'N_STEP',
  OF: 'OF',
  OFF_BALANCE: 'OFF_BALANCE',
  ONBOARDING: {
    '0': {
      PROCEED_TO_DASHBOARD: 'ONBOARDING.0.PROCEED_TO_DASHBOARD',
      TERMS_AND_CONDITIONS: {
        AGREEMENT: 'ONBOARDING.0.TERMS_AND_CONDITIONS.AGREEMENT',
        LINK: 'ONBOARDING.0.TERMS_AND_CONDITIONS.LINK',
      },
      TITLE: 'ONBOARDING.0.TITLE',
    },
    '1': {
      AYS_TO_NOT_ADD_PAYMENT_METHOD: 'ONBOARDING.1.AYS_TO_NOT_ADD_PAYMENT_METHOD',
      CREDIT_CARD: {
        DESCRIPTION: 'ONBOARDING.1.CREDIT_CARD.DESCRIPTION',
        TITLE: 'ONBOARDING.1.CREDIT_CARD.TITLE',
      },
      DIRECT_DEBIT: {
        CLICK_ON_LINK: 'ONBOARDING.1.DIRECT_DEBIT.CLICK_ON_LINK',
        CONFIRM: 'ONBOARDING.1.DIRECT_DEBIT.CONFIRM',
        DESCRIPTION: 'ONBOARDING.1.DIRECT_DEBIT.DESCRIPTION',
        TITLE: 'ONBOARDING.1.DIRECT_DEBIT.TITLE',
        TO_CONTINUE: 'ONBOARDING.1.DIRECT_DEBIT.TO_CONTINUE',
      },
      TITLE: 'ONBOARDING.1.TITLE',
    },
    '2': {
      CODABOX: {
        CLICK_TO_RECEIVE_TOKEN: 'ONBOARDING.2.CODABOX.CLICK_TO_RECEIVE_TOKEN',
        CODE_SENT_BY_EMAIL: 'ONBOARDING.2.CODABOX.CODE_SENT_BY_EMAIL',
        DESCRIPTION: 'ONBOARDING.2.CODABOX.DESCRIPTION',
        EASY_TO_VALID: 'ONBOARDING.2.CODABOX.EASY_TO_VALID',
        ENTER_TOKEN_BELOW: 'ONBOARDING.2.CODABOX.ENTER_TOKEN_BELOW',
        FIRSTLY: 'ONBOARDING.2.CODABOX.FIRSTLY',
        TITLE: 'ONBOARDING.2.CODABOX.TITLE',
      },
      NO_BANK_CONNEXION: 'ONBOARDING.2.NO_BANK_CONNEXION',
      PAYMENT_ACCOUNT: 'ONBOARDING.2.PAYMENT_ACCOUNT',
      TITLE: 'ONBOARDING.2.TITLE',
    },
    '3': {
      DESCRIPTION_STEP1: 'ONBOARDING.3.DESCRIPTION_STEP1',
      DESCRIPTION_STEP1_2: 'ONBOARDING.3.DESCRIPTION_STEP1_2',
      DESCRIPTION_STEP2: 'ONBOARDING.3.DESCRIPTION_STEP2',
      DESCRIPTION_STEP3: 'ONBOARDING.3.DESCRIPTION_STEP3',
      DESCRIPTION_STEP4: 'ONBOARDING.3.DESCRIPTION_STEP4',
      TITLE: 'ONBOARDING.3.TITLE',
    },
    '4': {
      TITLE: 'ONBOARDING.4.TITLE',
    },
    '5': {
      CONFIGURATION_DONE: 'ONBOARDING.5.CONFIGURATION_DONE',
      SUMMARY: 'ONBOARDING.5.SUMMARY',
      TITLE: 'ONBOARDING.5.TITLE',
    },
    '6': {
      BUTTON: 'ONBOARDING.6.BUTTON',
      TITLE: 'ONBOARDING.6.TITLE',
    },
    API: {
      STEP_1: 'ONBOARDING.API.STEP_1',
      STEP_2: 'ONBOARDING.API.STEP_2',
      STEP_3: 'ONBOARDING.API.STEP_3',
    },
    NEXT_STEP: 'ONBOARDING.NEXT_STEP',
    SIGNUP_ACCOUNT_TITLE: 'ONBOARDING.SIGNUP_ACCOUNT_TITLE',
    SIGNUP_COMPANY_TITLE: 'ONBOARDING.SIGNUP_COMPANY_TITLE',
    STEP: 'ONBOARDING.STEP',
    TITLE: 'ONBOARDING.TITLE',
  },
  ONE_DAY: 'ONE_DAY',
  ONGOING_PAYMENT_PLAN: 'ONGOING_PAYMENT_PLAN',
  ONLINE_PAYMENT: 'ONLINE_PAYMENT',
  OPTIONAL: 'OPTIONAL',
  OR: 'OR',
  OTHER: 'OTHER',
  OTHERWISE: 'OTHERWISE',
  OVERDUE_BALANCE: 'OVERDUE_BALANCE',
  OVER_ONE_YEAR: 'OVER_ONE_YEAR',
  PAIDS: 'PAIDS',
  PASSWORD: 'PASSWORD',
  PAYMENT: 'PAYMENT',
  PAYMENTS: 'PAYMENTS',
  PAYMENT_BANNER: {
    GO_TO_PAYMENT_PORTAL: 'PAYMENT_BANNER.GO_TO_PAYMENT_PORTAL',
    LATE_PAYMENT_BANNER_TEXT: 'PAYMENT_BANNER.LATE_PAYMENT_BANNER_TEXT',
    TITLE: 'PAYMENT_BANNER.TITLE',
  },
  PAYMENT_PLAN: {
    ATTRIBUTES: {
      COMMUNICATION: 'PAYMENT_PLAN.ATTRIBUTES.COMMUNICATION',
      CREATED_AT: 'PAYMENT_PLAN.ATTRIBUTES.CREATED_AT',
      NEXT_DUE_DATE: 'PAYMENT_PLAN.ATTRIBUTES.NEXT_DUE_DATE',
      PAYMENT_STEPS: 'PAYMENT_PLAN.ATTRIBUTES.PAYMENT_STEPS',
    },
    CANCELLATION: {
      CONFIRM: 'PAYMENT_PLAN.CANCELLATION.CONFIRM',
      KEEP_INVOICES_PAUSED: 'PAYMENT_PLAN.CANCELLATION.KEEP_INVOICES_PAUSED',
      RESUME_WORKFLOW: 'PAYMENT_PLAN.CANCELLATION.RESUME_WORKFLOW',
      TEMPLATE_LABEL: 'PAYMENT_PLAN.CANCELLATION.TEMPLATE_LABEL',
      TITLE: 'PAYMENT_PLAN.CANCELLATION.TITLE',
    },
    ERROR: 'PAYMENT_PLAN.ERROR',
    FILTERS: {
      LATE: 'PAYMENT_PLAN.FILTERS.LATE',
    },
    MODAL: {
      BUTTON_LABEL: 'PAYMENT_PLAN.MODAL.BUTTON_LABEL',
      DESCRIPTION: 'PAYMENT_PLAN.MODAL.DESCRIPTION',
      ERROR: 'PAYMENT_PLAN.MODAL.ERROR',
      FULL_AMOUNT: 'PAYMENT_PLAN.MODAL.FULL_AMOUNT',
      PARTIAL_AMOUNT: 'PAYMENT_PLAN.MODAL.PARTIAL_AMOUNT',
      RECONCILE: 'PAYMENT_PLAN.MODAL.RECONCILE',
      SUCCESS: 'PAYMENT_PLAN.MODAL.SUCCESS',
      TITLE: 'PAYMENT_PLAN.MODAL.TITLE',
    },
    TITLE: {
      EDIT: 'PAYMENT_PLAN.TITLE.EDIT',
      MANY: 'PAYMENT_PLAN.TITLE.MANY',
      NEW: 'PAYMENT_PLAN.TITLE.NEW',
      ONE: 'PAYMENT_PLAN.TITLE.ONE',
    },
    UTILS: {
      NO_NEXT_STEP: 'PAYMENT_PLAN.UTILS.NO_NEXT_STEP',
    },
    WIZARD: {
      STEP1: {
        CLIENT: 'PAYMENT_PLAN.WIZARD.STEP1.CLIENT',
        CLIENT_PLACEHOLDER: 'PAYMENT_PLAN.WIZARD.STEP1.CLIENT_PLACEHOLDER',
        NEXT: 'PAYMENT_PLAN.WIZARD.STEP1.NEXT',
        WORKFLOW: 'PAYMENT_PLAN.WIZARD.STEP1.WORKFLOW',
      },
      STEP2: {
        AMOUNT: 'PAYMENT_PLAN.WIZARD.STEP2.AMOUNT',
        BALANCE: 'PAYMENT_PLAN.WIZARD.STEP2.BALANCE',
        DUE_DATE: 'PAYMENT_PLAN.WIZARD.STEP2.DUE_DATE',
        INVOICES: 'PAYMENT_PLAN.WIZARD.STEP2.INVOICES',
        NEXT: 'PAYMENT_PLAN.WIZARD.STEP2.NEXT',
        RECEIVED_AT: 'PAYMENT_PLAN.WIZARD.STEP2.RECEIVED_AT',
        REFERENCE: 'PAYMENT_PLAN.WIZARD.STEP2.REFERENCE',
        TOTAL_SELECTED: 'PAYMENT_PLAN.WIZARD.STEP2.TOTAL_SELECTED',
      },
      STEP3: {
        AMOUNT_PER_INSTALLMENT: 'PAYMENT_PLAN.WIZARD.STEP3.AMOUNT_PER_INSTALLMENT',
        DAY_OF_MONTH_FOR_INSTALLMENTS: 'PAYMENT_PLAN.WIZARD.STEP3.DAY_OF_MONTH_FOR_INSTALLMENTS',
        DAYS_BETWEEN_INSTALLMENTS: 'PAYMENT_PLAN.WIZARD.STEP3.DAYS_BETWEEN_INSTALLMENTS',
        DAYS_SUFFIX: 'PAYMENT_PLAN.WIZARD.STEP3.DAYS_SUFFIX',
        FIRST_INSTALLMENT_DATE: 'PAYMENT_PLAN.WIZARD.STEP3.FIRST_INSTALLMENT_DATE',
        INCLUDE_LATE_FEES: 'PAYMENT_PLAN.WIZARD.STEP3.INCLUDE_LATE_FEES',
        INSTALLMENT_TYPE: 'PAYMENT_PLAN.WIZARD.STEP3.INSTALLMENT_TYPE',
        LAST_DAY_DISCLAIMER: 'PAYMENT_PLAN.WIZARD.STEP3.LAST_DAY_DISCLAIMER',
        MONTHLY_END_OF_MONTH_DISCLAIMER:
          'PAYMENT_PLAN.WIZARD.STEP3.MONTHLY_END_OF_MONTH_DISCLAIMER',
        NEXT: 'PAYMENT_PLAN.WIZARD.STEP3.NEXT',
        NUMBER_OF_INSTALLMENTS: 'PAYMENT_PLAN.WIZARD.STEP3.NUMBER_OF_INSTALLMENTS',
      },
      STEP4: {
        ADJUST: 'PAYMENT_PLAN.WIZARD.STEP4.ADJUST',
        ADJUST_DATES: 'PAYMENT_PLAN.WIZARD.STEP4.ADJUST_DATES',
        ADJUST_TOOLTIP: 'PAYMENT_PLAN.WIZARD.STEP4.ADJUST_TOOLTIP',
        CLIENT: 'PAYMENT_PLAN.WIZARD.STEP4.CLIENT',
        CREDIT_NOTES: 'PAYMENT_PLAN.WIZARD.STEP4.CREDIT_NOTES',
        DAYS_SUFFIX: 'PAYMENT_PLAN.WIZARD.STEP4.DAYS_SUFFIX',
        DEADLINE_DELAY: 'PAYMENT_PLAN.WIZARD.STEP4.DEADLINE_DELAY',
        DO_NOT_ADJUST: 'PAYMENT_PLAN.WIZARD.STEP4.DO_NOT_ADJUST',
        FIRST_DEADLINE: 'PAYMENT_PLAN.WIZARD.STEP4.FIRST_DEADLINE',
        INVOICES: 'PAYMENT_PLAN.WIZARD.STEP4.INVOICES',
        ITEMS_INCLUDED: 'PAYMENT_PLAN.WIZARD.STEP4.ITEMS_INCLUDED',
        LAUNCH: 'PAYMENT_PLAN.WIZARD.STEP4.LAUNCH',
        OVER: 'PAYMENT_PLAN.WIZARD.STEP4.OVER',
        OVERVIEW: 'PAYMENT_PLAN.WIZARD.STEP4.OVERVIEW',
        PAYMENTS: 'PAYMENT_PLAN.WIZARD.STEP4.PAYMENTS',
        TOTAL: 'PAYMENT_PLAN.WIZARD.STEP4.TOTAL',
        TOTAL_MESSAGE: 'PAYMENT_PLAN.WIZARD.STEP4.TOTAL_MESSAGE',
        UNDER: 'PAYMENT_PLAN.WIZARD.STEP4.UNDER',
        WITH_LATE_FEES: 'PAYMENT_PLAN.WIZARD.STEP4.WITH_LATE_FEES',
        WORKFLOW: 'PAYMENT_PLAN.WIZARD.STEP4.WORKFLOW',
      },
      STEPS: {
        CLIENT_AND_WORKFLOW: 'PAYMENT_PLAN.WIZARD.STEPS.CLIENT_AND_WORKFLOW',
        INSTALLMENTS: 'PAYMENT_PLAN.WIZARD.STEPS.INSTALLMENTS',
        INVOICES: 'PAYMENT_PLAN.WIZARD.STEPS.INVOICES',
        OVERVIEW: 'PAYMENT_PLAN.WIZARD.STEPS.OVERVIEW',
      },
    },
    WORKFLOW_LABEL: 'PAYMENT_PLAN.WORKFLOW_LABEL',
  },
  PENALTY_CLAUSE: 'PENALTY_CLAUSE',
  PENDING_IMPORT: 'PENDING_IMPORT',
  PERCENTAGE: 'PERCENTAGE',
  PERIOD: {
    ANNUAL: 'PERIOD.ANNUAL',
    INTRODUCTION: 'PERIOD.INTRODUCTION',
    MONTHLY: 'PERIOD.MONTHLY',
  },
  PERSONAL_INFO: 'PERSONAL_INFO',
  PERSONAL_PREFENCES: 'PERSONAL_PREFENCES',
  PER_PAGE: 'PER_PAGE',
  PHONE: 'PHONE',
  PHONES: 'PHONES',
  PLAN: {
    ADD_PREVENTIVE_REMINDER: 'PLAN.ADD_PREVENTIVE_REMINDER',
    ADD_STEP: 'PLAN.ADD_STEP',
    ASSOCIATE_ALL_STEPS: 'PLAN.ASSOCIATE_ALL_STEPS',
    CLIENTS_NUMBER_INCLUDED: 'PLAN.CLIENTS_NUMBER_INCLUDED',
    EDITION_STEP: 'PLAN.EDITION_STEP',
    EDITION_TASK: 'PLAN.EDITION_TASK',
    EXECUTED: 'PLAN.EXECUTED',
    INVOICES: 'PLAN.INVOICES',
    INVOICES_EXECUTED_STEP: 'PLAN.INVOICES_EXECUTED_STEP',
    INVOICES_NUMBER_INCLUDED: 'PLAN.INVOICES_NUMBER_INCLUDED',
    MOVE_DEBTOR: 'PLAN.MOVE_DEBTOR',
    MOVE_INVOICES: 'PLAN.MOVE_INVOICES',
    MOVE_INVOICES_IN_NEW_PLAN: 'PLAN.MOVE_INVOICES_IN_NEW_PLAN',
    NAME: 'PLAN.NAME',
    SELECT_PLAN: 'PLAN.SELECT_PLAN',
    SELECT_STEP: 'PLAN.SELECT_STEP',
    SELECT_TEMPLATE: 'PLAN.SELECT_TEMPLATE',
    SET_AS_DEFAULT: 'PLAN.SET_AS_DEFAULT',
    STEP_MUST_BE_CREATED: 'PLAN.STEP_MUST_BE_CREATED',
    TRANSFERT_INVOICES: 'PLAN.TRANSFERT_INVOICES',
    WHERE_MOVE_INVOICES: 'PLAN.WHERE_MOVE_INVOICES',
  },
  PONTO_NOT_SYNCED: 'PONTO_NOT_SYNCED',
  POST: 'POST',
  POSTPONE: 'POSTPONE',
  PREFERENCES: 'PREFERENCES',
  PREVIOUS: 'PREVIOUS',
  PRICE: 'PRICE',
  PROCESS: 'PROCESS',
  PUBLIC: 'PUBLIC',
  READ_AND_APPROVE: 'READ_AND_APPROVE',
  REASON: 'REASON',
  REASONS: 'REASONS',
  RECEIVED_PAYMENT_S: 'RECEIVED_PAYMENT_S',
  RECONCILE: 'RECONCILE',
  RECOVERY_IN_PAUSE: 'RECOVERY_IN_PAUSE',
  RECOVERY_PLAN: 'RECOVERY_PLAN',
  RECOVERY_PLANS: 'RECOVERY_PLANS',
  RECOVR: 'RECOVR',
  REFETCH: 'REFETCH',
  REGISTERED: 'REGISTERED',
  REMAINING_BALANCE_WITH_LATE_FEES: 'REMAINING_BALANCE_WITH_LATE_FEES',
  REMAINING_LATE_FEES: 'REMAINING_LATE_FEES',
  REMINDER: {
    AI_CALL_DATE: 'REMINDER.AI_CALL_DATE',
    AI_CALL_END_REASON: 'REMINDER.AI_CALL_END_REASON',
    AI_CALL_NO_CONTENT_AVAILABLE: 'REMINDER.AI_CALL_NO_CONTENT_AVAILABLE',
    AI_CALL_NO_OUTCOME_AVAILABLE: 'REMINDER.AI_CALL_NO_OUTCOME_AVAILABLE',
    AI_CALL_NO_SUMMARY_AVAILABLE: 'REMINDER.AI_CALL_NO_SUMMARY_AVAILABLE',
    AI_CALL_NO_TRANSCRIPT_AVAILABLE: 'REMINDER.AI_CALL_NO_TRANSCRIPT_AVAILABLE',
    AI_CALL_OUTCOME: 'REMINDER.AI_CALL_OUTCOME',
    AI_CALL_PHONE: 'REMINDER.AI_CALL_PHONE',
    AI_CALL_STATUS: 'REMINDER.AI_CALL_STATUS',
    AI_CALL_SUMMARY: 'REMINDER.AI_CALL_SUMMARY',
    AI_CALL_TRANSCRIPT: 'REMINDER.AI_CALL_TRANSCRIPT',
    CHOOSE_PDF: 'REMINDER.CHOOSE_PDF',
    CLIENT: 'REMINDER.CLIENT',
    DATE_SENT: 'REMINDER.DATE_SENT',
    DELIVERY_STATUS: 'REMINDER.DELIVERY_STATUS',
    NO_TRACKING_LINK: 'REMINDER.NO_TRACKING_LINK',
    PLAY_RECORDING: 'REMINDER.PLAY_RECORDING',
    REMINDER: 'REMINDER.REMINDER',
    RETRY_COUNT: 'REMINDER.RETRY_COUNT',
    SEE_DELIVERY_HISTORY: 'REMINDER.SEE_DELIVERY_HISTORY',
    SEE_REMINDER_DETAILS: 'REMINDER.SEE_REMINDER_DETAILS',
    SEND_AGAIN: {
      BUTTON: 'REMINDER.SEND_AGAIN.BUTTON',
      FORWARD: 'REMINDER.SEND_AGAIN.FORWARD',
      FORWARD_DESCRIPTION: 'REMINDER.SEND_AGAIN.FORWARD_DESCRIPTION',
      FORWARD_EMAILS_LABEL: 'REMINDER.SEND_AGAIN.FORWARD_EMAILS_LABEL',
      FORWARD_INFO: 'REMINDER.SEND_AGAIN.FORWARD_INFO',
      FORWARD_MODAL_TITLE: 'REMINDER.SEND_AGAIN.FORWARD_MODAL_TITLE',
      FORWARD_SUBMIT: 'REMINDER.SEND_AGAIN.FORWARD_SUBMIT',
      RESEND: 'REMINDER.SEND_AGAIN.RESEND',
      RESEND_DESCRIPTION: 'REMINDER.SEND_AGAIN.RESEND_DESCRIPTION',
    },
    SENT_TO: 'REMINDER.SENT_TO',
    SUBJECT: 'REMINDER.SUBJECT',
    TRACKING_LINK: 'REMINDER.TRACKING_LINK',
  },
  REMINDERS: 'REMINDERS',
  REMINDERS_MENU: 'REMINDERS_MENU',
  REMINDER_LIST: {
    AUTOMATICALLY_RESENT_BY_POST: 'REMINDER_LIST.AUTOMATICALLY_RESENT_BY_POST',
    BADGE: {
      EMAIL: 'REMINDER_LIST.BADGE.EMAIL',
      MISSING_INFORMATION: 'REMINDER_LIST.BADGE.MISSING_INFORMATION',
      POST: 'REMINDER_LIST.BADGE.POST',
      AI_CALL: 'REMINDER_LIST.BADGE.AI_CALL',
      REGISTERED_POST: 'REMINDER_LIST.BADGE.REGISTERED_POST',
    },
    EMPTY_INDEX: 'REMINDER_LIST.EMPTY_INDEX',
    FAILED_REMINDER_LABEL: 'REMINDER_LIST.FAILED_REMINDER_LABEL',
    FILTERS: {
      LABELS: {
        ACCOUNT_MANAGER_REFERENCE: 'REMINDER_LIST.FILTERS.LABELS.ACCOUNT_MANAGER_REFERENCE',
        DEBTOR_REFERENCE: 'REMINDER_LIST.FILTERS.LABELS.DEBTOR_REFERENCE',
        INVOICE_REFERENCE: 'REMINDER_LIST.FILTERS.LABELS.INVOICE_REFERENCE',
        REMINDER_TYPE: 'REMINDER_LIST.FILTERS.LABELS.REMINDER_TYPE',
        SENT_AFTER: 'REMINDER_LIST.FILTERS.LABELS.SENT_AFTER',
        SENT_BEFORE: 'REMINDER_LIST.FILTERS.LABELS.SENT_BEFORE',
        SENT_MEDIA: 'REMINDER_LIST.FILTERS.LABELS.SENT_MEDIA',
        SHOW_UNDELIVERED: 'REMINDER_LIST.FILTERS.LABELS.SHOW_UNDELIVERED',
      },
      NOT_FOUND_DESCRIPTION: 'REMINDER_LIST.FILTERS.NOT_FOUND_DESCRIPTION',
      NOT_FOUND_TITLE: 'REMINDER_LIST.FILTERS.NOT_FOUND_TITLE',
      PLACEHOLDERS: {
        ACCOUNT_MANAGER_REFERENCE: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.ACCOUNT_MANAGER_REFERENCE',
        DEBTOR_REFERENCE: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.DEBTOR_REFERENCE',
        INVOICE_REFERENCE: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.INVOICE_REFERENCE',
        REMINDER_TYPE: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.REMINDER_TYPE',
        SENT_AFTER: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.SENT_AFTER',
        SENT_BEFORE: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.SENT_BEFORE',
        SENT_MEDIA: 'REMINDER_LIST.FILTERS.PLACEHOLDERS.SENT_MEDIA',
      },
      REMINDER_TYPES: {
        ADDITIONAL_REMINDER: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.ADDITIONAL_REMINDER',
        FIRST_REMINDER: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.FIRST_REMINDER',
        FORMAL_NOTICE: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.FORMAL_NOTICE',
        INITIATE_AI_CALL: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.INITIATE_AI_CALL',
        INTERMEDIATE_REMINDER: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.INTERMEDIATE_REMINDER',
        LAST_REMINDER: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.LAST_REMINDER',
        PLAN_CANCEL: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.PLAN_CANCEL',
        PLAN_CREATION: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.PLAN_CREATION',
        PLAN_UPDATE: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.PLAN_UPDATE',
        PREVENTIVE_REMINDER: 'REMINDER_LIST.FILTERS.REMINDER_TYPES.PREVENTIVE_REMINDER',
      },
      SENT_MEDIA: {
        EMAIL: 'REMINDER_LIST.FILTERS.SENT_MEDIA.EMAIL',
        POST: 'REMINDER_LIST.FILTERS.SENT_MEDIA.POST',
        REGISTERED_POST: 'REMINDER_LIST.FILTERS.SENT_MEDIA.REGISTERED_POST',
      },
      TITLE: 'REMINDER_LIST.FILTERS.TITLE',
    },
    HEADERS: {
      DEBTOR: 'REMINDER_LIST.HEADERS.DEBTOR',
      REFERENCE: 'REMINDER_LIST.HEADERS.REFERENCE',
      REMINDER_TYPE: 'REMINDER_LIST.HEADERS.REMINDER_TYPE',
      SENT_AT: 'REMINDER_LIST.HEADERS.SENT_AT',
      SENT_MEDIA: 'REMINDER_LIST.HEADERS.SENT_MEDIA',
    },
    TITLE: 'REMINDER_LIST.TITLE',
  },
  REMINDER_SALE_CONDITION: 'REMINDER_SALE_CONDITION',
  REMINDER_TABLE: {
    DEBTOR: 'REMINDER_TABLE.DEBTOR',
    REFERENCE: 'REMINDER_TABLE.REFERENCE',
    REMINDER_TYPE: 'REMINDER_TABLE.REMINDER_TYPE',
    SENT_AT: 'REMINDER_TABLE.SENT_AT',
    TITLE: 'REMINDER_TABLE.TITLE',
  },
  REPLIES: 'REPLIES',
  REPLY: 'REPLY',
  REPLY_TO: 'REPLY_TO',
  REPORTS: {
    INDEX: {
      ACTIONS: {
        EDIT: 'REPORTS.INDEX.ACTIONS.EDIT',
      },
      EXECUTION_DATE: {
        NOT_EXECUTED: 'REPORTS.INDEX.EXECUTION_DATE.NOT_EXECUTED',
      },
      ROWS: {
        ACTIONS: 'REPORTS.INDEX.ROWS.ACTIONS',
        EXECUTION_DATE: 'REPORTS.INDEX.ROWS.EXECUTION_DATE',
        NAME: 'REPORTS.INDEX.ROWS.NAME',
        PERIODICITY: 'REPORTS.INDEX.ROWS.PERIODICITY',
      },
      TITLE: 'REPORTS.INDEX.TITLE',
    },
    NEW: {
      ACTION_BUTTON: 'REPORTS.NEW.ACTION_BUTTON',
      CANCEL: 'REPORTS.NEW.CANCEL',
      STEPS: {
        ADVANCE: 'REPORTS.NEW.STEPS.ADVANCE',
        CREATE: 'REPORTS.NEW.STEPS.CREATE',
        DATA: {
          RESOURCE_TYPE: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPE',
          RESOURCE_TYPES: {
            ACTIONABLE_INVOICES: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.ACTIONABLE_INVOICES',
            CREDIT_NOTES: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.CREDIT_NOTES',
            DEBTORS: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.DEBTORS',
            INVOICES: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.INVOICES',
            REMINDERS: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.REMINDERS',
            TASKS: 'REPORTS.NEW.STEPS.DATA.RESOURCE_TYPES.TASKS',
          },
          VIEW: 'REPORTS.NEW.STEPS.DATA.VIEW',
          VIEW_SUBTITLE: 'REPORTS.NEW.STEPS.DATA.VIEW_SUBTITLE',
        },
        NAME: {
          DUPLICATED_NAME: 'REPORTS.NEW.STEPS.NAME.DUPLICATED_NAME',
          FORM_SUBTITLE: 'REPORTS.NEW.STEPS.NAME.FORM_SUBTITLE',
          FORM_TITLE: 'REPORTS.NEW.STEPS.NAME.FORM_TITLE',
          PLACEHOLDER: 'REPORTS.NEW.STEPS.NAME.PLACEHOLDER',
        },
        RECIPIENTS: {
          COLLABORATORS: 'REPORTS.NEW.STEPS.RECIPIENTS.COLLABORATORS',
          COLLABORATORS_PLACEHOLDER: 'REPORTS.NEW.STEPS.RECIPIENTS.COLLABORATORS_PLACEHOLDER',
          EXTERNAL: 'REPORTS.NEW.STEPS.RECIPIENTS.EXTERNAL',
          EXTERNAL_PLACEHOLDER: 'REPORTS.NEW.STEPS.RECIPIENTS.EXTERNAL_PLACEHOLDER',
          EXTERNAL_SUBMIT_HINT: 'REPORTS.NEW.STEPS.RECIPIENTS.EXTERNAL_SUBMIT_HINT',
          INVALID_EMAIL: 'REPORTS.NEW.STEPS.RECIPIENTS.INVALID_EMAIL',
          TITLE: 'REPORTS.NEW.STEPS.RECIPIENTS.TITLE',
        },
        RECURRENCE: {
          LAST_DAY_DISCLAIMER: 'REPORTS.NEW.STEPS.RECURRENCE.LAST_DAY_DISCLAIMER',
          MONTHLY_END_OF_MONTH_DISCLAIMER:
            'REPORTS.NEW.STEPS.RECURRENCE.MONTHLY_END_OF_MONTH_DISCLAIMER',
          MONTHLY_TITLE: 'REPORTS.NEW.STEPS.RECURRENCE.MONTHLY_TITLE',
          WEEKLY_TITLE: 'REPORTS.NEW.STEPS.RECURRENCE.WEEKLY_TITLE',
        },
      },
      STEP_LABELS: {
        DATA: 'REPORTS.NEW.STEP_LABELS.DATA',
        NAME: 'REPORTS.NEW.STEP_LABELS.NAME',
        RECIPIENTS: 'REPORTS.NEW.STEP_LABELS.RECIPIENTS',
        RECURRENCE: 'REPORTS.NEW.STEP_LABELS.RECURRENCE',
      },
      TITLE: 'REPORTS.NEW.TITLE',
    },
    RECURRENCE: {
      MONTHLY: 'REPORTS.RECURRENCE.MONTHLY',
      WEEKLY: 'REPORTS.RECURRENCE.WEEKLY',
    },
    SHOW: {
      AYS_DELETE: 'REPORTS.SHOW.AYS_DELETE',
      DELETE_REPORT: 'REPORTS.SHOW.DELETE_REPORT',
      DETAILS: 'REPORTS.SHOW.DETAILS',
      DOWNLOAD_CSV: 'REPORTS.SHOW.DOWNLOAD_CSV',
      DOWNLOAD_XLSX: 'REPORTS.SHOW.DOWNLOAD_XLSX',
      NAME: 'REPORTS.SHOW.NAME',
      NO_EXPORTS_YET: 'REPORTS.SHOW.NO_EXPORTS_YET',
      NO_REPORTS_YET: 'REPORTS.SHOW.NO_REPORTS_YET',
      RECIPIENTS: 'REPORTS.SHOW.RECIPIENTS',
      RECURRENCE: 'REPORTS.SHOW.RECURRENCE',
    },
  },
  RESET: 'RESET',
  RESULT: 'RESULT',
  UNDISPUTED: 'UNDISPUTED',
  SALE_CONDITION: 'SALE_CONDITION',
  SALE_CONDITION_APPLIED: 'SALE_CONDITION_APPLIED',
  SALE_CONDITION_DEFAULT: 'SALE_CONDITION_DEFAULT',
  SAVE: 'SAVE',
  SAVE_FILTERS: 'SAVE_FILTERS',
  SEARCH: 'SEARCH',
  SEE_ALL: 'SEE_ALL',
  SEE_ALL_M: 'SEE_ALL_M',
  SEE_FILE: 'SEE_FILE',
  SEE_LESS: 'SEE_LESS',
  SEE_MORE: 'SEE_MORE',
  SELECT: 'SELECT',
  SELECTED_ELEMENT: 'SELECTED_ELEMENT',
  SELECTED_ELEMENTS: 'SELECTED_ELEMENTS',
  SELECT_ELEMENT: 'SELECT_ELEMENT',
  SELECT_ELEMENTS: 'SELECT_ELEMENTS',
  SELECT_BAILIFF: 'SELECT_BAILIFF',
  SELECT_DEBT_COLLECTOR: 'SELECT_DEBT_COLLECTOR',
  SELECT_LAWYER: 'SELECT_LAWYER',
  SENDING_MEDIUM_MANAGER: {
    DEFAULT_USAGE_DESCRIPTION: 'SENDING_MEDIUM_MANAGER.DEFAULT_USAGE_DESCRIPTION',
    FALLBACK_MEDIUM_EXPLANATION: 'SENDING_MEDIUM_MANAGER.FALLBACK_MEDIUM_EXPLANATION',
    INFORMATION_TITLE: 'SENDING_MEDIUM_MANAGER.INFORMATION_TITLE',
    LOGIC_LABEL: 'SENDING_MEDIUM_MANAGER.LOGIC_LABEL',
    NOTHING_SET_BY_DEFAULT: 'SENDING_MEDIUM_MANAGER.NOTHING_SET_BY_DEFAULT',
    TOOLTIP: {
      AND_DESCRIPTION: 'SENDING_MEDIUM_MANAGER.TOOLTIP.AND_DESCRIPTION',
      OR_DESCRIPTION: 'SENDING_MEDIUM_MANAGER.TOOLTIP.OR_DESCRIPTION',
    },
  },
  SENDING_SETTINGS: 'SENDING_SETTINGS',
  SEND_FULL_BILLING_STATEMENT: 'SEND_FULL_BILLING_STATEMENT',
  SERVICE_UNAVAILABLE_UNTIL: 'SERVICE_UNAVAILABLE_UNTIL',
  SETTINGS: {
    AUTOMATIC_ASSIGNATION: {
      ASSIGNATION_CONDITIONS: 'SETTINGS.AUTOMATIC_ASSIGNATION.ASSIGNATION_CONDITIONS',
      ASSIGN_TO: 'SETTINGS.AUTOMATIC_ASSIGNATION.ASSIGN_TO',
      CLIENT_PLAN: 'SETTINGS.AUTOMATIC_ASSIGNATION.CLIENT_PLAN',
      CLIENT_USER: 'SETTINGS.AUTOMATIC_ASSIGNATION.CLIENT_USER',
      INV_PLAN: 'SETTINGS.AUTOMATIC_ASSIGNATION.INV_PLAN',
      INV_USER: 'SETTINGS.AUTOMATIC_ASSIGNATION.INV_USER',
      MODEL_TO_ASSIGN: 'SETTINGS.AUTOMATIC_ASSIGNATION.MODEL_TO_ASSIGN',
      ORDER: 'SETTINGS.AUTOMATIC_ASSIGNATION.ORDER',
    },
    CLIENT_ID: 'SETTINGS.CLIENT_ID',
    COMPANY: {
      API_NOT_ENABLED: 'SETTINGS.COMPANY.API_NOT_ENABLED',
      API_TITLE: 'SETTINGS.COMPANY.API_TITLE',
      ARCHIVE_BANK_ACCOUNT: 'SETTINGS.COMPANY.ARCHIVE_BANK_ACCOUNT',
      AYS_RESET_SECRET_ID: 'SETTINGS.COMPANY.AYS_RESET_SECRET_ID',
      BANK_ACCOUNT_DESCRIPTION: 'SETTINGS.COMPANY.BANK_ACCOUNT_DESCRIPTION',
      DEFAULT_BANK_ACCOUNT: 'SETTINGS.COMPANY.DEFAULT_BANK_ACCOUNT',
      NEW_SECRET_ID: 'SETTINGS.COMPANY.NEW_SECRET_ID',
      NOT_SHOW_SECRET_ID_ANYMORE: 'SETTINGS.COMPANY.NOT_SHOW_SECRET_ID_ANYMORE',
      PROFILE: 'SETTINGS.COMPANY.PROFILE',
      RESET_SECRET_ID: 'SETTINGS.COMPANY.RESET_SECRET_ID',
      SECRET_ID: 'SETTINGS.COMPANY.SECRET_ID',
      SET_DEFAULT_BANK_ACCOUNT: 'SETTINGS.COMPANY.SET_DEFAULT_BANK_ACCOUNT',
      SUCCESSFULLY_UPDATE: 'SETTINGS.COMPANY.SUCCESSFULLY_UPDATE',
      TITLE: 'SETTINGS.COMPANY.TITLE',
    },
    CUSTOMIZATION: {
      EMPTY_STATE: {
        CUSTOM_VARIABLES_TITLE: 'SETTINGS.CUSTOMIZATION.EMPTY_STATE.CUSTOM_VARIABLES_TITLE',
        CUSTOM_VARIABLES_DESCRIPTION:
          'SETTINGS.CUSTOMIZATION.EMPTY_STATE.CUSTOM_VARIABLES_DESCRIPTION',
        TASK_TYPES_TITLE: 'SETTINGS.CUSTOMIZATION.EMPTY_STATE.TASK_TYPES_TITLE',
        TASK_TYPES_DESCRIPTION: 'SETTINGS.CUSTOMIZATION.EMPTY_STATE.TASK_TYPES_DESCRIPTION',
        REASONS_TITLE: 'SETTINGS.CUSTOMIZATION.EMPTY_STATE.REASONS_TITLE',
        REASONS_DESCRIPTION: 'SETTINGS.CUSTOMIZATION.EMPTY_STATE.REASONS_DESCRIPTION',
      },
      TABS: {
        CUSTOM_VARIABLES: 'SETTINGS.CUSTOMIZATION.TABS.CUSTOM_VARIABLES',
        REASONS: 'SETTINGS.CUSTOMIZATION.TABS.REASONS',
        TASK_TYPES: 'SETTINGS.CUSTOMIZATION.TABS.TASK_TYPES',
      },
    },
    CUSTOM_VARIABLES: {
      API: 'SETTINGS.CUSTOM_VARIABLES.API',
      AYS_TO_DELETE: 'SETTINGS.CUSTOM_VARIABLES.AYS_TO_DELETE',
      COLUMN_NAME: 'SETTINGS.CUSTOM_VARIABLES.COLUMN_NAME',
      DEFAULT_VALUE: 'SETTINGS.CUSTOM_VARIABLES.DEFAULT_VALUE',
      DISPLAY: 'SETTINGS.CUSTOM_VARIABLES.DISPLAY',
      LONG_TITLE: 'SETTINGS.CUSTOM_VARIABLES.LONG_TITLE',
      MODEL_TYPE: 'SETTINGS.CUSTOM_VARIABLES.MODEL_TYPE',
      NAME: 'SETTINGS.CUSTOM_VARIABLES.NAME',
      NAME_PLACEHOLDER: 'SETTINGS.CUSTOM_VARIABLES.NAME_PLACEHOLDER',
      TITLE: 'SETTINGS.CUSTOM_VARIABLES.TITLE',
      VAR_TYPE: 'SETTINGS.CUSTOM_VARIABLES.VAR_TYPE',
      WEBHOOK: 'SETTINGS.CUSTOM_VARIABLES.WEBHOOK',
    },
    EXTERNAL_MAILBOX: {
      ADD: 'SETTINGS.EXTERNAL_MAILBOX.ADD',
      CONNECT: 'SETTINGS.EXTERNAL_MAILBOX.CONNECT',
      CREATE_ERROR: 'SETTINGS.EXTERNAL_MAILBOX.CREATE_ERROR',
      CREATE_SUCCESS: 'SETTINGS.EXTERNAL_MAILBOX.CREATE_SUCCESS',
      DELETE: 'SETTINGS.EXTERNAL_MAILBOX.DELETE',
      EDIT: 'SETTINGS.EXTERNAL_MAILBOX.EDIT',
      HOST: 'SETTINGS.EXTERNAL_MAILBOX.HOST',
      ID: 'SETTINGS.EXTERNAL_MAILBOX.ID',
      LIMIT_EXCEEDED: 'SETTINGS.EXTERNAL_MAILBOX.LIMIT_EXCEEDED',
      LOGIN: 'SETTINGS.EXTERNAL_MAILBOX.LOGIN',
      MANUAL_SETUP: 'SETTINGS.EXTERNAL_MAILBOX.MANUAL_SETUP',
      PASSWORD: 'SETTINGS.EXTERNAL_MAILBOX.PASSWORD',
      PORT: 'SETTINGS.EXTERNAL_MAILBOX.PORT',
      QUICK_SETUP: 'SETTINGS.EXTERNAL_MAILBOX.QUICK_SETUP',
      KIND: {
        OWN: 'SETTINGS.EXTERNAL_MAILBOX.KIND.OWN',
        SHARED: 'SETTINGS.EXTERNAL_MAILBOX.KIND.SHARED',
      },
      SHARED_ADDRESS: 'SETTINGS.EXTERNAL_MAILBOX.SHARED_ADDRESS',
      SHARED_ADDRESS_HINT: 'SETTINGS.EXTERNAL_MAILBOX.SHARED_ADDRESS_HINT',
      SIGN_IN_WITH: {
        MICROSOFT: 'SETTINGS.EXTERNAL_MAILBOX.SIGN_IN_WITH.MICROSOFT',
        MICROSOFT_SHARED: 'SETTINGS.EXTERNAL_MAILBOX.SIGN_IN_WITH.MICROSOFT_SHARED',
      },
      SSL: 'SETTINGS.EXTERNAL_MAILBOX.SSL',
      TITLE: 'SETTINGS.EXTERNAL_MAILBOX.TITLE',
      SHARED: 'SETTINGS.EXTERNAL_MAILBOX.SHARED',
      PASSWORD_HINT: 'SETTINGS.EXTERNAL_MAILBOX.PASSWORD_HINT',
      RECONNECT: 'SETTINGS.EXTERNAL_MAILBOX.RECONNECT',
      EMPTY_STATE: {
        TITLE: 'SETTINGS.EXTERNAL_MAILBOX.EMPTY_STATE.TITLE',
        DESCRIPTION: 'SETTINGS.EXTERNAL_MAILBOX.EMPTY_STATE.DESCRIPTION',
      },
      CARD_TITLE: 'SETTINGS.EXTERNAL_MAILBOX.CARD_TITLE',
    },
    INTEGRATIONS: {
      ACCOUNTING: 'SETTINGS.INTEGRATIONS.ACCOUNTING',
      ALL: 'SETTINGS.INTEGRATIONS.ALL',
      BANKING: 'SETTINGS.INTEGRATIONS.BANKING',
      CATEGORIES: 'SETTINGS.INTEGRATIONS.CATEGORIES',
      EXCLUDED_ACCOUNTS: {
        TITLE: 'SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.TITLE',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.DESCRIPTION',
        LABEL: 'SETTINGS.INTEGRATIONS.EXCLUDED_ACCOUNTS.LABEL',
      },
      EXCLUDED_DAYBOOKS: {
        TITLE: 'SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.TITLE',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.DESCRIPTION',
        LABEL: 'SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.LABEL',
      },
      EXCLUDED_DEBTORS: {
        TITLE: 'SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.TITLE',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.DESCRIPTION',
        LABEL: 'SETTINGS.INTEGRATIONS.EXCLUDED_DEBTORS.LABEL',
      },
      CHIFT: {
        AUTOMATIC_SYNC: 'SETTINGS.INTEGRATIONS.CHIFT.AUTOMATIC_SYNC',
        CONNECT_CHIFT: 'SETTINGS.INTEGRATIONS.CHIFT.CONNECT_CHIFT',
        DATEPICKER_PLACEHOLDER: 'SETTINGS.INTEGRATIONS.CHIFT.DATEPICKER_PLACEHOLDER',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.CHIFT.DESCRIPTION',
        ERROR_MISSING_DATE: 'SETTINGS.INTEGRATIONS.CHIFT.ERROR_MISSING_DATE',
        FETCH_PDF: 'SETTINGS.INTEGRATIONS.CHIFT.FETCH_PDF',
        FETCH_RAW_DATA: 'SETTINGS.INTEGRATIONS.CHIFT.FETCH_RAW_DATA',
        IMPORT_INVOICES: 'SETTINGS.INTEGRATIONS.CHIFT.IMPORT_INVOICES',
        IMPORT_INVOICES_FROM: 'SETTINGS.INTEGRATIONS.CHIFT.IMPORT_INVOICES_FROM',
        PAYMENT_MATCHING: 'SETTINGS.INTEGRATIONS.CHIFT.PAYMENT_MATCHING',
        UNPOSTED_ALLOWED: 'SETTINGS.INTEGRATIONS.CHIFT.UNPOSTED_ALLOWED',
        DAILY_PDFS_SYNC: 'SETTINGS.INTEGRATIONS.CHIFT.DAILY_PDFS_SYNC',
      },
      CODABOX: {
        ALERT_NEW_TOKEN: 'SETTINGS.INTEGRATIONS.CODABOX.ALERT_NEW_TOKEN',
        ASK_TOKEN: 'SETTINGS.INTEGRATIONS.CODABOX.ASK_TOKEN',
        CODABOX_TOKEN: 'SETTINGS.INTEGRATIONS.CODABOX.CODABOX_TOKEN',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.CODABOX.DESCRIPTION',
      },
      COMPANYWEB: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.COMPANYWEB.DESCRIPTION',
        INTERCOM_MORE_INFO: 'SETTINGS.INTEGRATIONS.COMPANYWEB.INTERCOM_MORE_INFO',
      },
      DBASICS: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.DBASICS.DESCRIPTION',
      },
      DIGITEAL: {
        ACCEPT_CGV: 'SETTINGS.INTEGRATIONS.DIGITEAL.ACCEPT_CGV',
        AYS_TO_ACTIVATE: 'SETTINGS.INTEGRATIONS.DIGITEAL.AYS_TO_ACTIVATE',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.DIGITEAL.DESCRIPTION',
        EMAIL_TO_ACTIVATE: 'SETTINGS.INTEGRATIONS.DIGITEAL.EMAIL_TO_ACTIVATE',
        MAKE_AVAILABLE: 'SETTINGS.INTEGRATIONS.DIGITEAL.MAKE_AVAILABLE',
        MAKE_UNAVAILABLE: 'SETTINGS.INTEGRATIONS.DIGITEAL.MAKE_UNAVAILABLE',
        SIGNUP_TO_CONTINUE: 'SETTINGS.INTEGRATIONS.DIGITEAL.SIGNUP_TO_CONTINUE',
        SUMMARY: 'SETTINGS.INTEGRATIONS.DIGITEAL.SUMMARY',
      },
      ERP: 'SETTINGS.INTEGRATIONS.ERP',
      EXACT: {
        COLUMN_DESCRIPTION: 'SETTINGS.INTEGRATIONS.EXACT.COLUMN_DESCRIPTION',
        COLUMN_REFERENCE: 'SETTINGS.INTEGRATIONS.EXACT.COLUMN_REFERENCE',
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.EXACT.DESCRIPTION',
        SELECT_COLUMN: 'SETTINGS.INTEGRATIONS.EXACT.SELECT_COLUMN',
      },
      HORUS: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.HORUS.DESCRIPTION',
        SUMMARY: 'SETTINGS.INTEGRATIONS.HORUS.SUMMARY',
      },
      MY_INTEGRATIONS: 'SETTINGS.INTEGRATIONS.MY_INTEGRATIONS',
      PONTO: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.PONTO.DESCRIPTION',
        SECRET_CODE: 'SETTINGS.INTEGRATIONS.PONTO.SECRET_CODE',
        SUMMARY: 'SETTINGS.INTEGRATIONS.PONTO.SUMMARY',
      },
      TEAMLEADER: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.TEAMLEADER.DESCRIPTION',
      },
      TITLE: 'SETTINGS.INTEGRATIONS.TITLE',
      YUKI: {
        DESCRIPTION: 'SETTINGS.INTEGRATIONS.YUKI.DESCRIPTION',
      },
    },
    INVOICING: {
      APPEARANCE: 'SETTINGS.INVOICING.APPEARANCE',
      AYS_DELETE_LOGO: 'SETTINGS.INVOICING.AYS_DELETE_LOGO',
      FOOTER: {
        CLICK_TO_EDIT: 'SETTINGS.INVOICING.FOOTER.CLICK_TO_EDIT',
        COMPANY_INFO: 'SETTINGS.INVOICING.FOOTER.COMPANY_INFO',
        CUSTOM_TEXT: 'SETTINGS.INVOICING.FOOTER.CUSTOM_TEXT',
        DESCRIPTION: 'SETTINGS.INVOICING.FOOTER.DESCRIPTION',
        EMPTY: 'SETTINGS.INVOICING.FOOTER.EMPTY',
        ENTER_TEXT: 'SETTINGS.INVOICING.FOOTER.ENTER_TEXT',
        MODAL_TITLE: 'SETTINGS.INVOICING.FOOTER.MODAL_TITLE',
        SELECT_FIELD: 'SETTINGS.INVOICING.FOOTER.SELECT_FIELD',
        TITLE: 'SETTINGS.INVOICING.FOOTER.TITLE',
      },
      TITLE: 'SETTINGS.INVOICING.TITLE',
    },
    PACKAGE: {
      ACCEPT_CGV: 'SETTINGS.PACKAGE.ACCEPT_CGV',
      ACCOUNT_SUMMARY: 'SETTINGS.PACKAGE.ACCOUNT_SUMMARY',
      ALL_PRICES_EXCL_VAT: 'SETTINGS.PACKAGE.ALL_PRICES_EXCL_VAT',
      CLICK_TO_BE_CONTACTED: 'SETTINGS.PACKAGE.CLICK_TO_BE_CONTACTED',
      EDIT_BANKING_INFO: 'SETTINGS.PACKAGE.EDIT_BANKING_INFO',
      FOR_1_YEAR: 'SETTINGS.PACKAGE.FOR_1_YEAR',
      MORE_FUNCTIONNALITIES: 'SETTINGS.PACKAGE.MORE_FUNCTIONNALITIES',
      NUMBER_LEGAL_CREDITS: 'SETTINGS.PACKAGE.NUMBER_LEGAL_CREDITS',
      NUMBER_PHONE_BY_MONTH: 'SETTINGS.PACKAGE.NUMBER_PHONE_BY_MONTH',
      PAYMENT_BY_INTEGRATOR: 'SETTINGS.PACKAGE.PAYMENT_BY_INTEGRATOR',
      PAYMENT_METHOD: 'SETTINGS.PACKAGE.PAYMENT_METHOD',
      PAYMENT_PERIOD: 'SETTINGS.PACKAGE.PAYMENT_PERIOD',
      SEPA_MANDATE_VIA_TWIKEY: 'SETTINGS.PACKAGE.SEPA_MANDATE_VIA_TWIKEY',
      SUMMARY: 'SETTINGS.PACKAGE.SUMMARY',
      TITLE: 'SETTINGS.PACKAGE.TITLE',
      YEARLY_COMMITMENT: 'SETTINGS.PACKAGE.YEARLY_COMMITMENT',
      YOUR_PACKAGE: 'SETTINGS.PACKAGE.YOUR_PACKAGE',
    },
    PREFERENCES: {
      TITLE: 'SETTINGS.PREFERENCES.TITLE',
      TERMS_AND_CONDITIONS: {
        ADD_SET: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.ADD_SET',
        CANNOT_DELETE_SET: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.CANNOT_DELETE_SET',
        DAYS_SUFFIX: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.DAYS_SUFFIX',
        DELETE_SET: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.DELETE_SET',
        FIX_FEE_HINT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.FIX_FEE_HINT',
        INTEREST_HINT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.INTEREST_HINT',
        IS_DEFAULT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.IS_DEFAULT',
        MINIMUM_PREFIX: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.MINIMUM_PREFIX',
        NAME_MUST_BE_UNIQUE: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.NAME_MUST_BE_UNIQUE',
        PAYMENT_PERIOD: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.PAYMENT_PERIOD',
        PENALTY_CLAUSE_HINT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.PENALTY_CLAUSE_HINT',
        REMOVE_PDF: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.REMOVE_PDF',
        REPLACE_PDF: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.REPLACE_PDF',
        SET_AS_DEFAULT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.SET_AS_DEFAULT',
        UPLOAD_PDF: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.UPLOAD_PDF',
        UPLOAD_PDF_HINT: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.UPLOAD_PDF_HINT',
        VIEW_PDF: 'SETTINGS.PREFERENCES.TERMS_AND_CONDITIONS.VIEW_PDF',
      },
    },
    PROFILE: {
      EDIT: 'SETTINGS.PROFILE.EDIT',
      SUCCESSFULLY_UPDATE: 'SETTINGS.PROFILE.SUCCESSFULLY_UPDATE',
      TITLE: 'SETTINGS.PROFILE.TITLE',
      HOTKEYS: {
        TITLE: 'SETTINGS.PROFILE.HOTKEYS.TITLE',
        LABEL: 'SETTINGS.PROFILE.HOTKEYS.LABEL',
        DESCRIPTION: 'SETTINGS.PROFILE.HOTKEYS.DESCRIPTION',
      },
    },
    STAFF: {
      ACTIVE: 'SETTINGS.STAFF.ACTIVE',
      PENDING: 'SETTINGS.STAFF.PENDING',
      COLLABORATOR_NAME: 'SETTINGS.STAFF.COLLABORATOR_NAME',
      DAILY: 'SETTINGS.STAFF.DAILY',
      INACTIVE: 'SETTINGS.STAFF.INACTIVE',
      NOTIFICATION: 'SETTINGS.STAFF.NOTIFICATION',
      PERMISSIONS: 'SETTINGS.STAFF.PERMISSIONS',
      RECEIVE_EMAIL: 'SETTINGS.STAFF.RECEIVE_EMAIL',
      SUCCESSFULLY_UPDATE: 'SETTINGS.STAFF.SUCCESSFULLY_UPDATE',
      TASK: 'SETTINGS.STAFF.TASK',
      TITLE: 'SETTINGS.STAFF.TITLE',
      WEEKLY: 'SETTINGS.STAFF.WEEKLY',
      YOUR_STAFF: 'SETTINGS.STAFF.YOUR_STAFF',
    },
    TASKS: {
      DEFAULT_DESCRIPTION: 'SETTINGS.TASKS.DEFAULT_DESCRIPTION',
      DEFAULT_DESCRIPTION_PLACEHOLDER: 'SETTINGS.TASKS.DEFAULT_DESCRIPTION_PLACEHOLDER',
      DEFAULT_DUE_OFFSET_DAYS: 'SETTINGS.TASKS.DEFAULT_DUE_OFFSET_DAYS',
      DEFAULT_TITLE: 'SETTINGS.TASKS.DEFAULT_TITLE',
      DEFAULT_TITLE_PLACEHOLDER: 'SETTINGS.TASKS.DEFAULT_TITLE_PLACEHOLDER',
      NAME_PLACEHOLDER: 'SETTINGS.TASKS.NAME_PLACEHOLDER',
      TASK_CUSTOM: 'SETTINGS.TASKS.TASK_CUSTOM',
      TASK_DEFAULT: 'SETTINGS.TASKS.TASK_DEFAULT',
      TASK_ID: 'SETTINGS.TASKS.TASK_ID',
      TASK_TYPE: 'SETTINGS.TASKS.TASK_TYPE',
      TASK_TYPE_TITLE: 'SETTINGS.TASKS.TASK_TYPE_TITLE',
      TASK_VALUE: 'SETTINGS.TASKS.TASK_VALUE',
      TEMPLATE_HINT: 'SETTINGS.TASKS.TEMPLATE_HINT',
      TITLE: 'SETTINGS.TASKS.TITLE',
    },
    TEMPLATES: {
      TABS: {
        RECOVERY: 'SETTINGS.TEMPLATES.TABS.RECOVERY',
      },
    },
    WORKFLOWS: {
      ACTIVE_PLANS: 'SETTINGS.WORKFLOWS.ACTIVE_PLANS',
      DEFAULT: 'SETTINGS.WORKFLOWS.DEFAULT',
      LAST_EDITED: 'SETTINGS.WORKFLOWS.LAST_EDITED',
      PLAN_LIMIT_REACHED: 'SETTINGS.WORKFLOWS.PLAN_LIMIT_REACHED',
      STEPS: 'SETTINGS.WORKFLOWS.STEPS',
    },
  },
  SET_ACCOUNT_MANAGER: 'SET_ACCOUNT_MANAGER',
  SET_DEFAULT_PLAN: 'SET_DEFAULT_PLAN',
  SHARED: {
    CUSTOM_TABLE: {
      LOAD_MORE: 'SHARED.CUSTOM_TABLE.LOAD_MORE',
    },
    ENCODE_PAYMENT: {
      AMOUNT_WITHOUT_FEES: 'SHARED.ENCODE_PAYMENT.AMOUNT_WITHOUT_FEES',
      CUSTOM_AMOUNT: 'SHARED.ENCODE_PAYMENT.CUSTOM_AMOUNT',
      FULL_AMOUNT: 'SHARED.ENCODE_PAYMENT.FULL_AMOUNT',
      PERCENTAGE: 'SHARED.ENCODE_PAYMENT.PERCENTAGE',
      TITLE: 'SHARED.ENCODE_PAYMENT.TITLE',
    },
  },
  SHOW_CGV: 'SHOW_CGV',
  SHOW_CONVERSATION: 'SHOW_CONVERSATION',
  SHOW_DOCUMENT: 'SHOW_DOCUMENT',
  SHOW_TEMPLATE: 'SHOW_TEMPLATE',
  SIGNATURE: 'SIGNATURE',
  SLOGAN: 'SLOGAN',
  SPOTLIGHT: {
    PLACEHOLDER: 'SPOTLIGHT.PLACEHOLDER',
    SET_LOCALE: 'SPOTLIGHT.SET_LOCALE',
    NO_RESULTS: 'SPOTLIGHT.NO_RESULTS',
    TYPE: 'SPOTLIGHT.TYPE',
    FOR_CLIENTS: 'SPOTLIGHT.FOR_CLIENTS',
    FOR_INVOICES: 'SPOTLIGHT.FOR_INVOICES',
    NEW_TASK: 'SPOTLIGHT.NEW_TASK',
    LOGOUT: 'SPOTLIGHT.LOGOUT',
  },
  STATEMENT: 'STATEMENT',
  STATUS: 'STATUS',
  SUBJECT: 'SUBJECT',
  SUBJECT_VARIABLES: 'SUBJECT_VARIABLES',
  SUBMIT: 'SUBMIT',
  SUCCESS: 'SUCCESS',
  SUCCESSFULLY_FILE_UPLOAD: 'SUCCESSFULLY_FILE_UPLOAD',
  SUCCESSFULL_ACTIONS: 'SUCCESSFULL_ACTIONS',
  SUCCESSFUL_ACTION: 'SUCCESSFUL_ACTION',
  SYNCHRONIZE: 'SYNCHRONIZE',
  SYNCHRONIZE_PDFS: 'SYNCHRONIZE_PDFS',
  TASK: {
    ACTIONS: {
      ASSIGN: 'TASK.ACTIONS.ASSIGN',
      ASSIGN_TO_ACCOUNT_MANAGER: 'TASK.ACTIONS.ASSIGN_TO_ACCOUNT_MANAGER',
      COMPLETE: 'TASK.ACTIONS.COMPLETE',
      DELETE: 'TASK.ACTIONS.DELETE',
      POSTPONE: 'TASK.ACTIONS.POSTPONE',
      REVERT: 'TASK.ACTIONS.REVERT',
      SKIP: 'TASK.ACTIONS.SKIP',
    },
    ATTRIBUTES: {
      ADDITIONAL_ASSIGNEES: 'TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES',
      ADDITIONAL_ASSIGNEES_PLACEHOLDER: 'TASK.ATTRIBUTES.ADDITIONAL_ASSIGNEES_PLACEHOLDER',
      ACCOUNT_MANAGER_OPTION: 'TASK.ATTRIBUTES.ACCOUNT_MANAGER_OPTION',
      ADD_START_DATE: 'TASK.ATTRIBUTES.ADD_START_DATE',
      ASSIGNEE: 'TASK.ATTRIBUTES.ASSIGNEE',
      ASSIGNEES: 'TASK.ATTRIBUTES.ASSIGNEES',
      DAYS_BEFORE_DUE_DATE: 'TASK.ATTRIBUTES.DAYS_BEFORE_DUE_DATE',
      DEBTOR: 'TASK.ATTRIBUTES.DEBTOR',
      INVOICE: 'TASK.ATTRIBUTES.INVOICE',
      INVOICE_PLACEHOLDER: 'TASK.ATTRIBUTES.INVOICE_PLACEHOLDER',
      ASSIGNEE_PLACEHOLDER: 'TASK.ATTRIBUTES.ASSIGNEE_PLACEHOLDER',
      DESCRIPTION_PLACEHOLDER: 'TASK.ATTRIBUTES.DESCRIPTION_PLACEHOLDER',
      DUE_DATE_PLACEHOLDER: 'TASK.ATTRIBUTES.DUE_DATE_PLACEHOLDER',
      MANDATORY: 'TASK.ATTRIBUTES.MANDATORY',
      MANDATORY_PLACEHOLDER: 'TASK.ATTRIBUTES.MANDATORY_PLACEHOLDER',
      START_OFFSET_DAYS: 'TASK.ATTRIBUTES.START_OFFSET_DAYS',
      START_DATE_TOOLTIP: 'TASK.ATTRIBUTES.START_DATE_TOOLTIP',
      STATUS: 'TASK.ATTRIBUTES.STATUS',
      TASK_TYPE: 'TASK.ATTRIBUTES.TASK_TYPE',
      TASK_TYPE_PLACEHOLDER: 'TASK.ATTRIBUTES.TASK_TYPE_PLACEHOLDER',
      TITLE: 'TASK.ATTRIBUTES.TITLE',
      TITLE_PLACEHOLDER: 'TASK.ATTRIBUTES.TITLE_PLACEHOLDER',
    },
    EMPTY_STATE: {
      NO_COMPLETED_TASKS: 'TASK.EMPTY_STATE.NO_COMPLETED_TASKS',
      NO_IGNORED_TASKS: 'TASK.EMPTY_STATE.NO_IGNORED_TASKS',
      NO_PENDING_TASKS: 'TASK.EMPTY_STATE.NO_PENDING_TASKS',
    },
    EXPORT_CSV: {
      DEBTOR_CUSTOM_VARIABLES: 'TASK.EXPORT_CSV.DEBTOR_CUSTOM_VARIABLES',
    },
    PAYMENT_PLAN: {
      ACCEPT: 'TASK.PAYMENT_PLAN.ACCEPT',
      DECLINE: 'TASK.PAYMENT_PLAN.DECLINE',
    },
    STATUS: {
      ALL: 'TASK.STATUS.ALL',
      DONE: 'TASK.STATUS.DONE',
      PENDING: 'TASK.STATUS.PENDING',
      SKIPPED: 'TASK.STATUS.SKIPPED',
    },
    TITLE: 'TASK.TITLE',
  },
  TASK_GENERATION: 'TASK_GENERATION',
  TEMPLATE: {
    ACCOUNT_MANAGER_EMAIL_FIELD: 'TEMPLATE.ACCOUNT_MANAGER_EMAIL_FIELD',
    ACCOUNT_MANAGER_NAME_FIELD: 'TEMPLATE.ACCOUNT_MANAGER_NAME_FIELD',
    ACTIONS: {
      CHANGE_NAME: 'TEMPLATE.ACTIONS.CHANGE_NAME',
      CHANGE_NAME_TITLE: 'TEMPLATE.ACTIONS.CHANGE_NAME_TITLE',
      CHANGE_TYPE: 'TEMPLATE.ACTIONS.CHANGE_TYPE',
      CHANGE_TYPE_TITLE: 'TEMPLATE.ACTIONS.CHANGE_TYPE_TITLE',
      MORE: 'TEMPLATE.ACTIONS.MORE',
      PREVIEW: 'TEMPLATE.ACTIONS.PREVIEW',
    },
    ADD_CHANNEL: 'TEMPLATE.ADD_CHANNEL',
    ATTACHMENTS: 'TEMPLATE.ATTACHMENTS',
    ATTACH_FILE: 'TEMPLATE.ATTACH_FILE',
    BLANK_BODY_BLOCKS_SAVE: 'TEMPLATE.BLANK_BODY_BLOCKS_SAVE',
    BLANK_BODY_DISABLE_HINT: 'TEMPLATE.BLANK_BODY_DISABLE_HINT',
    BLANK_SUBJECT_BLOCKS_SAVE: 'TEMPLATE.BLANK_SUBJECT_BLOCKS_SAVE',
    CAN_USE_VARIABLE: 'TEMPLATE.CAN_USE_VARIABLE',
    CREATE_CHANNELS: 'TEMPLATE.CREATE_CHANNELS',
    DELETE_CHANNEL_BODIES: 'TEMPLATE.DELETE_CHANNEL_BODIES',
    DELETE_CHANNEL_BODIES_TITLE: 'TEMPLATE.DELETE_CHANNEL_BODIES_TITLE',
    EMPTY_CHANNELS_DESCRIPTION: 'TEMPLATE.EMPTY_CHANNELS_DESCRIPTION',
    EMPTY_CHANNELS_TITLE: 'TEMPLATE.EMPTY_CHANNELS_TITLE',
    FULL_DEBTOR_BALANCE: 'TEMPLATE.FULL_DEBTOR_BALANCE',
    INSERT_VARIABLE_HINT: 'TEMPLATE.INSERT_VARIABLE_HINT',
    LAST_UPDATED: 'TEMPLATE.LAST_UPDATED',
    MISSING_VARIABLES_IN_LANGUAGES: 'TEMPLATE.MISSING_VARIABLES_IN_LANGUAGES',
    MISSING_VARIABLES_LANGUAGE: 'TEMPLATE.MISSING_VARIABLES_LANGUAGE',
    NO_CHANNELS: 'TEMPLATE.NO_CHANNELS',
    NO_CONTENT_LANGUAGE: 'TEMPLATE.NO_CONTENT_LANGUAGE',
    OVERDUE_DEBTOR_BALANCE: 'TEMPLATE.OVERDUE_DEBTOR_BALANCE',
    PASTE_DIALOG: {
      CLEAN_UP_FORMATTING: 'TEMPLATE.PASTE_DIALOG.CLEAN_UP_FORMATTING',
      FORMATTED_MESSAGE: 'TEMPLATE.PASTE_DIALOG.FORMATTED_MESSAGE',
      FORMATTED_TITLE: 'TEMPLATE.PASTE_DIALOG.FORMATTED_TITLE',
      KEEP_FORMATTING: 'TEMPLATE.PASTE_DIALOG.KEEP_FORMATTING',
      PLAIN_TEXT: 'TEMPLATE.PASTE_DIALOG.PLAIN_TEXT',
      WORD_MESSAGE: 'TEMPLATE.PASTE_DIALOG.WORD_MESSAGE',
      WORD_TITLE: 'TEMPLATE.PASTE_DIALOG.WORD_TITLE',
    },
    RECOMMENDED_VARIABLES_UNUSED_ONE: 'TEMPLATE.RECOMMENDED_VARIABLES_UNUSED_ONE',
    RECOMMENDED_VARIABLES_UNUSED_OTHER: 'TEMPLATE.RECOMMENDED_VARIABLES_UNUSED_OTHER',
    SAVE_STATUS: {
      SAVED: 'TEMPLATE.SAVE_STATUS.SAVED',
      SAVING: 'TEMPLATE.SAVE_STATUS.SAVING',
      UNSAVED: 'TEMPLATE.SAVE_STATUS.UNSAVED',
    },
    SELECT_STATEMENT: 'TEMPLATE.SELECT_STATEMENT',
    SENDING_OPTIONS: {
      DEFAULT_ADDRESS: 'TEMPLATE.SENDING_OPTIONS.DEFAULT_ADDRESS',
      FROM: 'TEMPLATE.SENDING_OPTIONS.FROM',
      REPLY_TO: 'TEMPLATE.SENDING_OPTIONS.REPLY_TO',
      SUBJECT: 'TEMPLATE.SENDING_OPTIONS.SUBJECT',
    },
    STATEMENT_OF_ACCOUNT: {
      APPLY: 'TEMPLATE.STATEMENT_OF_ACCOUNT.APPLY',
      MODAL_DESCRIPTION: 'TEMPLATE.STATEMENT_OF_ACCOUNT.MODAL_DESCRIPTION',
      NO_STATEMENT_DESCRIPTION: 'TEMPLATE.STATEMENT_OF_ACCOUNT.NO_STATEMENT_DESCRIPTION',
      TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TITLE',
      TYPES: {
        FULL_BALANCE_DESCRIPTION: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.FULL_BALANCE_DESCRIPTION',
        FULL_BALANCE_TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.FULL_BALANCE_TITLE',
        OPEN_INVOICES_DESCRIPTION: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OPEN_INVOICES_DESCRIPTION',
        OPEN_INVOICES_TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OPEN_INVOICES_TITLE',
        OVERDUE_BALANCE_DESCRIPTION:
          'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OVERDUE_BALANCE_DESCRIPTION',
        OVERDUE_BALANCE_TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OVERDUE_BALANCE_TITLE',
        OVERDUE_INVOICES_DESCRIPTION:
          'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OVERDUE_INVOICES_DESCRIPTION',
        OVERDUE_INVOICES_TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.OVERDUE_INVOICES_TITLE',
        PREVENTIVE_SAME_DAY_DESCRIPTION:
          'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.PREVENTIVE_SAME_DAY_DESCRIPTION',
        PREVENTIVE_SAME_DAY_TITLE: 'TEMPLATE.STATEMENT_OF_ACCOUNT.TYPES.PREVENTIVE_SAME_DAY_TITLE',
      },
    },
    TEMPLATE: 'TEMPLATE.TEMPLATE',
    WHICH_TO_INCLUDE: 'TEMPLATE.WHICH_TO_INCLUDE',
  },
  TEMPLATES: 'TEMPLATES',
  TEMPLATE_EDITION: 'TEMPLATE_EDITION',
  TEMPLATE_NAME: 'TEMPLATE_NAME',
  TEMPLATE_TYPE: 'TEMPLATE_TYPE',
  TEMPLATE_TYPES: {
    ADDITIONAL_REMINDER: 'TEMPLATE_TYPES.ADDITIONAL_REMINDER',
    CREDIT_NOTE: 'TEMPLATE_TYPES.CREDIT_NOTE',
    FIRST_REMINDER: 'TEMPLATE_TYPES.FIRST_REMINDER',
    FORMAL_NOTICE: 'TEMPLATE_TYPES.FORMAL_NOTICE',
    INTERMEDIATE_REMINDER: 'TEMPLATE_TYPES.INTERMEDIATE_REMINDER',
    INVOICE: 'TEMPLATE_TYPES.INVOICE',
    LAST_REMINDER: 'TEMPLATE_TYPES.LAST_REMINDER',
    PLAN_CANCEL: 'TEMPLATE_TYPES.PLAN_CANCEL',
    PLAN_CREATION: 'TEMPLATE_TYPES.PLAN_CREATION',
    PLAN_UPDATE: 'TEMPLATE_TYPES.PLAN_UPDATE',
    PREVENTIVE_REMINDER: 'TEMPLATE_TYPES.PREVENTIVE_REMINDER',
  },
  TEMPLATE_WITH_LATE_FEES: 'TEMPLATE_WITH_LATE_FEES',
  TEST_PERIOD: 'TEST_PERIOD',
  THE_DATE: 'THE_DATE',
  THIRD_PARTY_CASES: {
    ACTIONS: {
      CASE_CLOSED: 'THIRD_PARTY_CASES.ACTIONS.CASE_CLOSED',
      CLOSE: 'THIRD_PARTY_CASES.ACTIONS.CLOSE',
      CLOSE_CASE: 'THIRD_PARTY_CASES.ACTIONS.CLOSE_CASE',
      CLOSE_CASE_DESCRIPTION: 'THIRD_PARTY_CASES.ACTIONS.CLOSE_CASE_DESCRIPTION',
      CONFIRM_CLOSE: 'THIRD_PARTY_CASES.ACTIONS.CONFIRM_CLOSE',
      CONFIRM_CLOSE_DESCRIPTION: 'THIRD_PARTY_CASES.ACTIONS.CONFIRM_CLOSE_DESCRIPTION',
      DOWNLOAD_DESCRIPTION: 'THIRD_PARTY_CASES.ACTIONS.DOWNLOAD_DESCRIPTION',
      SENT_LETTER: 'THIRD_PARTY_CASES.ACTIONS.SENT_LETTER',
      TITLE: 'THIRD_PARTY_CASES.ACTIONS.TITLE',
    },
    CASE_TYPE: {
      BAILIFF: 'THIRD_PARTY_CASES.CASE_TYPE.BAILIFF',
      DEBT_COLLECTOR: 'THIRD_PARTY_CASES.CASE_TYPE.DEBT_COLLECTOR',
      LAWYER: 'THIRD_PARTY_CASES.CASE_TYPE.LAWYER',
    },
    ALL: 'THIRD_PARTY_CASES.ALL',
    CLOSED: 'THIRD_PARTY_CASES.CLOSED',
    CONVERSATION: 'THIRD_PARTY_CASES.CONVERSATION',
    CURRENT: 'THIRD_PARTY_CASES.CURRENT',
    CURRENTLY_PROCESSED: 'THIRD_PARTY_CASES.CURRENTLY_PROCESSED',
    CURRENT_CASES: 'THIRD_PARTY_CASES.CURRENT_CASES',
    EMPTY_STATE: {
      CURRENT_TITLE: 'THIRD_PARTY_CASES.EMPTY_STATE.CURRENT_TITLE',
      CURRENT_DESCRIPTION: 'THIRD_PARTY_CASES.EMPTY_STATE.CURRENT_DESCRIPTION',
      CLOSED_TITLE: 'THIRD_PARTY_CASES.EMPTY_STATE.CLOSED_TITLE',
      CLOSED_DESCRIPTION: 'THIRD_PARTY_CASES.EMPTY_STATE.CLOSED_DESCRIPTION',
      NO_MATCH_TITLE: 'THIRD_PARTY_CASES.EMPTY_STATE.NO_MATCH_TITLE',
      NO_MATCH_DESCRIPTION: 'THIRD_PARTY_CASES.EMPTY_STATE.NO_MATCH_DESCRIPTION',
    },
    FILTERS: {
      INVOICE_NUMBER: 'THIRD_PARTY_CASES.FILTERS.INVOICE_NUMBER',
      UNREAD_MESSAGES: 'THIRD_PARTY_CASES.FILTERS.UNREAD_MESSAGES',
      PLACEHOLDERS: {
        REFERENCE: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.REFERENCE',
        CLIENT: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.CLIENT',
        INVOICE_NUMBER: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.INVOICE_NUMBER',
        CASE_TYPE: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.CASE_TYPE',
        STATUS: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.STATUS',
        UNREAD_MESSAGES: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.UNREAD_MESSAGES',
        ACCOUNT_MANAGER: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.ACCOUNT_MANAGER',
        OPERATOR: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.OPERATOR',
        AMOUNT: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.AMOUNT',
        DATE: 'THIRD_PARTY_CASES.FILTERS.PLACEHOLDERS.DATE',
      },
    },
    DESCRIPTIONS: {
      BAILIFF: {
        FIRST: 'THIRD_PARTY_CASES.DESCRIPTIONS.BAILIFF.FIRST',
        SECOND: 'THIRD_PARTY_CASES.DESCRIPTIONS.BAILIFF.SECOND',
      },
      DEBTCOLLECTOR: {
        FIRST: 'THIRD_PARTY_CASES.DESCRIPTIONS.DEBTCOLLECTOR.FIRST',
        SECOND: 'THIRD_PARTY_CASES.DESCRIPTIONS.DEBTCOLLECTOR.SECOND',
      },
      LAWYER: {
        FIRST: 'THIRD_PARTY_CASES.DESCRIPTIONS.LAWYER.FIRST',
        SECOND: 'THIRD_PARTY_CASES.DESCRIPTIONS.LAWYER.SECOND',
      },
      WHAT: 'THIRD_PARTY_CASES.DESCRIPTIONS.WHAT',
      WHEN: 'THIRD_PARTY_CASES.DESCRIPTIONS.WHEN',
    },
    INVOICES_OF_CASE: {
      MANY: 'THIRD_PARTY_CASES.INVOICES_OF_CASE.MANY',
      ONE: 'THIRD_PARTY_CASES.INVOICES_OF_CASE.ONE',
    },
    MANY: 'THIRD_PARTY_CASES.MANY',
    MODAL_TITLE: 'THIRD_PARTY_CASES.MODAL_TITLE',
    NOT_COMMUNICATED: 'THIRD_PARTY_CASES.NOT_COMMUNICATED',
    NOT_STARTED: 'THIRD_PARTY_CASES.NOT_STARTED',
    ONE: 'THIRD_PARTY_CASES.ONE',
    REFERENCE: 'THIRD_PARTY_CASES.REFERENCE',
    STARTED: 'THIRD_PARTY_CASES.STARTED',
    THIRD_PARTY_CASES_LIST: 'THIRD_PARTY_CASES.THIRD_PARTY_CASES_LIST',
    CASE_INFORMATION: 'THIRD_PARTY_CASES.CASE_INFORMATION',
  },
  TIMELINE: {
    ACTIVITY: 'TIMELINE.ACTIVITY',
    DEBTOR_REACTION: 'TIMELINE.DEBTOR_REACTION',
    EXTERNAL_MAIL: 'TIMELINE.EXTERNAL_MAIL',
  },
  TO: 'TO',
  TOOLTIP: {
    AI_CALL_REPEATED: 'TOOLTIP.AI_CALL_REPEATED',
    CAN_BE_INCLUDED_IN_PAYMENT_PLAN: 'TOOLTIP.CAN_BE_INCLUDED_IN_PAYMENT_PLAN',
    CAN_NOT_BE_INCLUDED_IN_PAYMENT_PLAN: 'TOOLTIP.CAN_NOT_BE_INCLUDED_IN_PAYMENT_PLAN',
    IMMINENT_REMINDER_INVOICES: 'TOOLTIP.IMMINENT_REMINDER_INVOICES',
  },
  TOO_LONG_LOADING: 'TOO_LONG_LOADING',
  TOTAL: 'TOTAL',
  TOTAL_NOT_VAT_PRICE: 'TOTAL_NOT_VAT_PRICE',
  TOTAL_VAT_PRICE: 'TOTAL_VAT_PRICE',
  TYPE_COLUMN: 'TYPE_COLUMN',
  UNAVAILABLE_WITH_SCREEN_SIZE: 'UNAVAILABLE_WITH_SCREEN_SIZE',
  UNHANDLED_INVOICES: 'UNHANDLED_INVOICES',
  UNPAIDS: 'UNPAIDS',
  UNUSED: 'UNUSED',
  UPDATE_DATE: 'UPDATE_DATE',
  USED: 'USED',
  USED_DEFAULT: 'USED_DEFAULT',
  USER: {
    UPDATED: 'USER.UPDATED',
    UPDATED_SETTINGS: 'USER.UPDATED_SETTINGS',
  },
  USERNAME: 'USERNAME',
  VALUE: 'VALUE',
  VARIABLES: 'VARIABLES',
  VAT: 'VAT',
  VAT_NUMBER: 'VAT_NUMBER',
  VAT_NUMBER_MISSING: 'VAT_NUMBER_MISSING',
  VIEWS: {
    FILTERS: {
      CATEGORY: {
        CUSTOM_DATA: 'VIEWS.FILTERS.CATEGORY.CUSTOM_DATA',
        DATE_DATA: 'VIEWS.FILTERS.CATEGORY.DATE_DATA',
        DEBTOR_DATA: 'VIEWS.FILTERS.CATEGORY.DEBTOR_DATA',
        INVOICE_DATA: 'VIEWS.FILTERS.CATEGORY.INVOICE_DATA',
        MOST_USED: 'VIEWS.FILTERS.CATEGORY.MOST_USED',
        PAYMENT_PLAN_DATA: 'VIEWS.FILTERS.CATEGORY.PAYMENT_PLAN_DATA',
        RECOVERY_DATA: 'VIEWS.FILTERS.CATEGORY.RECOVERY_DATA',
        TASK_DATA: 'VIEWS.FILTERS.CATEGORY.TASK_DATA',
      },
      EMPTY_DATA: 'VIEWS.FILTERS.EMPTY_DATA',
      FILL_DATA: 'VIEWS.FILTERS.FILL_DATA',
    },
    SETTINGS: {
      COLUMNS: 'VIEWS.SETTINGS.COLUMNS',
      CONFIRM_DELETE: 'VIEWS.SETTINGS.CONFIRM_DELETE',
      DEFAULT_LABEL: 'VIEWS.SETTINGS.DEFAULT_LABEL',
      DUPLICATE: 'VIEWS.SETTINGS.DUPLICATE',
      FILTERS: 'VIEWS.SETTINGS.FILTERS',
      MAKE_FAVORITE: 'VIEWS.SETTINGS.MAKE_FAVORITE',
      NEW: 'VIEWS.SETTINGS.NEW',
      PUBLIC: 'VIEWS.SETTINGS.PUBLIC',
      TITLE: 'VIEWS.SETTINGS.TITLE',
    },
  },
  VIEW_NAME: 'VIEW_NAME',
  VIEW_UNASSIGNED_EMAILS: 'VIEW_UNASSIGNED_EMAILS',
  WARNING: 'WARNING',
  WELCOME: 'WELCOME',
  WELCOME_API: 'WELCOME_API',
  WILL_BE_MERGED: {
    FINAL_DATA: 'WILL_BE_MERGED.FINAL_DATA',
    MODELS_MERGED: 'WILL_BE_MERGED.MODELS_MERGED',
    OF_OTHER_CLIENT: 'WILL_BE_MERGED.OF_OTHER_CLIENT',
    SINGLE: 'WILL_BE_MERGED.SINGLE',
    WILL_BE_ASSOCIATED_TO: 'WILL_BE_MERGED.WILL_BE_ASSOCIATED_TO',
  },
  WILL_BE_SENT: {
    EMAIL: 'WILL_BE_SENT.EMAIL',
    MULTIPLE: 'WILL_BE_SENT.MULTIPLE',
    POST: 'WILL_BE_SENT.POST',
    REGISTERED_POST: 'WILL_BE_SENT.REGISTERED_POST',
    SINGLE: 'WILL_BE_SENT.SINGLE',
    SMS: 'WILL_BE_SENT.SMS',
  },
  WITHOUT_FEES: 'WITHOUT_FEES',
  WITH_FEES: 'WITH_FEES',
  WITH_LATE_FEES: 'WITH_LATE_FEES',
  WORKFLOW: {
    ADD: {
      PAYMENT: 'WORKFLOW.ADD.PAYMENT',
    },
    EDIT: {
      PAYMENT: 'WORKFLOW.EDIT.PAYMENT',
    },
  },
  YEAR: 'YEAR',
  YES: 'YES',
  YOUR_ACCOUNT: 'YOUR_ACCOUNT',
  YOUR_EMAIL: 'YOUR_EMAIL',
  SUPERADMIN: {
    LABEL: 'SUPERADMIN.LABEL',
    CONFIRM_TITLE: 'SUPERADMIN.CONFIRM_TITLE',
    CONFIRM_MESSAGE: 'SUPERADMIN.CONFIRM_MESSAGE',
    UPDATE_DATES: 'SUPERADMIN.UPDATE_DATES',
    WARNING_MESSAGES: {
      INVOICE: 'SUPERADMIN.WARNING_MESSAGES.INVOICE',
      SYNCHRONIZE_PDFS: 'SUPERADMIN.WARNING_MESSAGES.SYNCHRONIZE_PDFS',
      DEBTOR: 'SUPERADMIN.WARNING_MESSAGES.DEBTOR',
    },
  },
  UPSELL: {
    UPGRADE: 'UPSELL.UPGRADE',
    INTERCOM_MESSAGE: 'UPSELL.INTERCOM_MESSAGE',
    AUTOMATIONS: {
      TITLE: 'UPSELL.AUTOMATIONS.TITLE',
      DESCRIPTION: 'UPSELL.AUTOMATIONS.DESCRIPTION',
    },
    TASKS: {
      TITLE: 'UPSELL.TASKS.TITLE',
      DESCRIPTION: 'UPSELL.TASKS.DESCRIPTION',
    },
    ANALYTICS: {
      TITLE: 'UPSELL.ANALYTICS.TITLE',
      DESCRIPTION: 'UPSELL.ANALYTICS.DESCRIPTION',
    },
    REPORTS: {
      TITLE: 'UPSELL.REPORTS.TITLE',
      DESCRIPTION: 'UPSELL.REPORTS.DESCRIPTION',
    },
    EMAILS: {
      TITLE: 'UPSELL.EMAILS.TITLE',
      DESCRIPTION: 'UPSELL.EMAILS.DESCRIPTION',
    },
    AI_CALLS: {
      TITLE: 'UPSELL.AI_CALLS.TITLE',
      DESCRIPTION: 'UPSELL.AI_CALLS.DESCRIPTION',
    },
    PAYMENT_PLANS: {
      TITLE: 'UPSELL.PAYMENT_PLANS.TITLE',
      DESCRIPTION: 'UPSELL.PAYMENT_PLANS.DESCRIPTION',
      CALLOUT: 'UPSELL.PAYMENT_PLANS.CALLOUT',
      CALLOUT_CTA: 'UPSELL.PAYMENT_PLANS.CALLOUT_CTA',
    },
  },
};
